export default [
  {
    label: 'Abhaya Libre',
    value: 'Abhaya Libre',
    preview:
      'https://fonts.gstatic.com/s/abhayalibre/v14/e3tmeuGtX-Co5MNzeAOqinEQeknX.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/abhayalibre/v14/e3tmeuGtX-Co5MNzeAOqinEgfkPWovdU4w.woff2',
      '500':
        'https://fonts.gstatic.com/s/abhayalibre/v14/e3t5euGtX-Co5MNzeAOqinEYj2ryr9xI6oYtBA.woff2',
      '600':
        'https://fonts.gstatic.com/s/abhayalibre/v14/e3t5euGtX-Co5MNzeAOqinEYo23yr9xI6oYtBA.woff2',
      '700':
        'https://fonts.gstatic.com/s/abhayalibre/v14/e3t5euGtX-Co5MNzeAOqinEYx2zyr9xI6oYtBA.woff2',
      '800':
        'https://fonts.gstatic.com/s/abhayalibre/v14/e3t5euGtX-Co5MNzeAOqinEY22_yr9xI6oYtBA.woff2',
    },
    installName: 'abhaya_libre',
  },
  {
    label: 'Advent Pro',
    value: 'Advent Pro',
    preview:
      'https://fonts.gstatic.com/s/adventpro/v23/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpLQyN_TZAp.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/adventpro/v23/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpLQyNPSZoonw1aBA.woff2',
      '500':
        'https://fonts.gstatic.com/s/adventpro/v23/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpLcSNPSZoonw1aBA.woff2',
      '600':
        'https://fonts.gstatic.com/s/adventpro/v23/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpLnSRPSZoonw1aBA.woff2',
      '700':
        'https://fonts.gstatic.com/s/adventpro/v23/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpLpCRPSZoonw1aBA.woff2',
      '800':
        'https://fonts.gstatic.com/s/adventpro/v23/V8mqoQfxVT4Dvddr_yOwrzaFxV7JtdQgFqXdUAQrGp_zgX5sWCpLwyRPSZoonw1aBA.woff2',
    },
    installName: 'advent_pro',
  },
  {
    label: 'Akatab',
    value: 'Akatab',
    preview: 'https://fonts.gstatic.com/s/akatab/v7/VuJwdNrK3Z7gqJE_WYb4.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/akatab/v7/VuJwdNrK3Z7gqJEPXYz5NIh-YA.woff2',
      '500':
        'https://fonts.gstatic.com/s/akatab/v7/VuJzdNrK3Z7gqJE3rKXdOaNiaRpFvg.woff2',
      '600':
        'https://fonts.gstatic.com/s/akatab/v7/VuJzdNrK3Z7gqJE3gKLdOaNiaRpFvg.woff2',
      '700':
        'https://fonts.gstatic.com/s/akatab/v7/VuJzdNrK3Z7gqJE35KPdOaNiaRpFvg.woff2',
      '800':
        'https://fonts.gstatic.com/s/akatab/v7/VuJzdNrK3Z7gqJE3-KDdOaNiaRpFvg.woff2',
    },
    installName: 'akatab',
  },
  {
    label: 'Albert Sans',
    value: 'Albert Sans',
    preview:
      'https://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHq5PPrYf3.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHq5P_qY32TxAj1g.woff2',
      '500':
        'https://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHmZP_qY32TxAj1g.woff2',
      '600':
        'https://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHdZT_qY32TxAj1g.woff2',
      '700':
        'https://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHTJT_qY32TxAj1g.woff2',
      '800':
        'https://fonts.gstatic.com/s/albertsans/v1/i7dZIFdwYjGaAMFtZd_QA3xXSKZqhr-TenSHK5T_qY32TxAj1g.woff2',
    },
    installName: 'albert_sans',
  },
  {
    label: 'Alegreya',
    value: 'Alegreya',
    preview:
      'https://fonts.gstatic.com/s/alegreya/v35/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNG9hU4_aqj.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/alegreya/v35/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNG9hUI-aCisSGVrw.woff2',
      '500':
        'https://fonts.gstatic.com/s/alegreya/v35/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNGxBUI-aCisSGVrw.woff2',
      '600':
        'https://fonts.gstatic.com/s/alegreya/v35/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNGKBII-aCisSGVrw.woff2',
      '700':
        'https://fonts.gstatic.com/s/alegreya/v35/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNGERII-aCisSGVrw.woff2',
      '800':
        'https://fonts.gstatic.com/s/alegreya/v35/4UacrEBBsBhlBjvfkQjt71kZfyBzPgNGdhII-aCisSGVrw.woff2',
    },
    installName: 'alegreya',
  },
  {
    label: 'Aleo',
    value: 'Aleo',
    preview:
      'https://fonts.gstatic.com/s/aleo/v14/c4m61nF8G8_s6gHhIOX0IYBo_KJ3GlP8Fo8.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/aleo/v14/c4m61nF8G8_s6gHhIOX0IYBo_KJ3GmP4HI4qCBtJ.woff2',
      '500':
        'https://fonts.gstatic.com/s/aleo/v14/c4m61nF8G8_s6gHhIOX0IYBo_KJFGmP4HI4qCBtJ.woff2',
      '600':
        'https://fonts.gstatic.com/s/aleo/v14/c4m61nF8G8_s6gHhIOX0IYBo_KKpHWP4HI4qCBtJ.woff2',
      '700':
        'https://fonts.gstatic.com/s/aleo/v14/c4m61nF8G8_s6gHhIOX0IYBo_KKQHWP4HI4qCBtJ.woff2',
      '800':
        'https://fonts.gstatic.com/s/aleo/v14/c4m61nF8G8_s6gHhIOX0IYBo_KL3HWP4HI4qCBtJ.woff2',
    },
    installName: 'aleo',
  },
  {
    label: 'Alexandria',
    value: 'Alexandria',
    preview:
      'https://fonts.gstatic.com/s/alexandria/v3/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9r7TpbGFp4.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/alexandria/v3/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9r7TqbCHJ8BRq0b.woff2',
      '500':
        'https://fonts.gstatic.com/s/alexandria/v3/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9rJTqbCHJ8BRq0b.woff2',
      '600':
        'https://fonts.gstatic.com/s/alexandria/v3/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9olSabCHJ8BRq0b.woff2',
      '700':
        'https://fonts.gstatic.com/s/alexandria/v3/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9ocSabCHJ8BRq0b.woff2',
      '800':
        'https://fonts.gstatic.com/s/alexandria/v3/UMBCrPdDqW66y0Y2usFeQCH18mulUxBvI9p7SabCHJ8BRq0b.woff2',
    },
    installName: 'alexandria',
  },
  {
    label: 'Alumni Sans',
    value: 'Alumni Sans',
    preview:
      'https://fonts.gstatic.com/s/alumnisans/v18/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd9OO9gqVEI.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/alumnisans/v18/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd9OO9QrVsJ3C8qng.woff2',
      '500':
        'https://fonts.gstatic.com/s/alumnisans/v18/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd9Cu9QrVsJ3C8qng.woff2',
      '600':
        'https://fonts.gstatic.com/s/alumnisans/v18/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd95uhQrVsJ3C8qng.woff2',
      '700':
        'https://fonts.gstatic.com/s/alumnisans/v18/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd93-hQrVsJ3C8qng.woff2',
      '800':
        'https://fonts.gstatic.com/s/alumnisans/v18/nwpHtKqkOwdO2aOIwhWudEWpx_zq_Xna-Xd9uOhQrVsJ3C8qng.woff2',
    },
    installName: 'alumni_sans',
  },
  {
    label: 'Andada Pro',
    value: 'Andada Pro',
    preview:
      'https://fonts.gstatic.com/s/andadapro/v20/HhyEU5Qi9-SuOEhPe4LtKoVCuWGURPcg3DPJBb8dHr0.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/andadapro/v20/HhyEU5Qi9-SuOEhPe4LtKoVCuWGURPcg3DPJBY8ZFLzvIt2S.woff2',
      '500':
        'https://fonts.gstatic.com/s/andadapro/v20/HhyEU5Qi9-SuOEhPe4LtKoVCuWGURPcg3DP7BY8ZFLzvIt2S.woff2',
      '600':
        'https://fonts.gstatic.com/s/andadapro/v20/HhyEU5Qi9-SuOEhPe4LtKoVCuWGURPcg3DMXAo8ZFLzvIt2S.woff2',
      '700':
        'https://fonts.gstatic.com/s/andadapro/v20/HhyEU5Qi9-SuOEhPe4LtKoVCuWGURPcg3DMuAo8ZFLzvIt2S.woff2',
      '800':
        'https://fonts.gstatic.com/s/andadapro/v20/HhyEU5Qi9-SuOEhPe4LtKoVCuWGURPcg3DNJAo8ZFLzvIt2S.woff2',
    },
    installName: 'andada_pro',
  },
  {
    label: 'Anek Bangla',
    value: 'Anek Bangla',
    preview:
      'https://fonts.gstatic.com/s/anekbangla/v4/_gPW1R38qTExHg-17BhM6n66QhabMYB0fBKONtHhRSIUIre5mq3Ofm9ZEoYq5g.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/anekbangla/v4/_gPW1R38qTExHg-17BhM6n66QhabMYB0fBKONtHhRSIUIre5mq3Ofm9ZIoIg56yyvt0.woff2',
      '500':
        'https://fonts.gstatic.com/s/anekbangla/v4/_gPW1R38qTExHg-17BhM6n66QhabMYB0fBKONtHhRSIUIre5mq3Ofl1ZIoIg56yyvt0.woff2',
      '600':
        'https://fonts.gstatic.com/s/anekbangla/v4/_gPW1R38qTExHg-17BhM6n66QhabMYB0fBKONtHhRSIUIre5mq3OfrFeIoIg56yyvt0.woff2',
      '700':
        'https://fonts.gstatic.com/s/anekbangla/v4/_gPW1R38qTExHg-17BhM6n66QhabMYB0fBKONtHhRSIUIre5mq3OfoheIoIg56yyvt0.woff2',
      '800':
        'https://fonts.gstatic.com/s/anekbangla/v4/_gPW1R38qTExHg-17BhM6n66QhabMYB0fBKONtHhRSIUIre5mq3Ofu9eIoIg56yyvt0.woff2',
    },
    installName: 'anek_bangla',
  },
  {
    label: 'Anek Devanagari',
    value: 'Anek Devanagari',
    preview:
      'https://fonts.gstatic.com/s/anekdevanagari/v8/jVyo7nP0CGrUsxB-QiRgw0NlLaVt_QUAkYxLRoCL23mlh20ZVHOMAWbgHLDtkt9mHEw.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/anekdevanagari/v8/jVyo7nP0CGrUsxB-QiRgw0NlLaVt_QUAkYxLRoCL23mlh20ZVHOMAWbgHLDtku9iFk0LjZ7E.woff2',
      '500':
        'https://fonts.gstatic.com/s/anekdevanagari/v8/jVyo7nP0CGrUsxB-QiRgw0NlLaVt_QUAkYxLRoCL23mlh20ZVHOMAWbgHLDfku9iFk0LjZ7E.woff2',
      '600':
        'https://fonts.gstatic.com/s/anekdevanagari/v8/jVyo7nP0CGrUsxB-QiRgw0NlLaVt_QUAkYxLRoCL23mlh20ZVHOMAWbgHLAzle9iFk0LjZ7E.woff2',
      '700':
        'https://fonts.gstatic.com/s/anekdevanagari/v8/jVyo7nP0CGrUsxB-QiRgw0NlLaVt_QUAkYxLRoCL23mlh20ZVHOMAWbgHLAKle9iFk0LjZ7E.woff2',
      '800':
        'https://fonts.gstatic.com/s/anekdevanagari/v8/jVyo7nP0CGrUsxB-QiRgw0NlLaVt_QUAkYxLRoCL23mlh20ZVHOMAWbgHLBtle9iFk0LjZ7E.woff2',
    },
    installName: 'anek_devanagari',
  },
  {
    label: 'Anek Gujarati',
    value: 'Anek Gujarati',
    preview:
      'https://fonts.gstatic.com/s/anekgujarati/v9/l7g_bj5oysqknvkCo2T_8FuiIRBA7lncQUmbIBEtPKiYYQhRwyBxCD-0F5CLwkih.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/anekgujarati/v9/l7g_bj5oysqknvkCo2T_8FuiIRBA7lncQUmbIBEtPKiYYQhRwyBxCD-0F5C7xkKgB7Lm7g.woff2',
      '500':
        'https://fonts.gstatic.com/s/anekgujarati/v9/l7g_bj5oysqknvkCo2T_8FuiIRBA7lncQUmbIBEtPKiYYQhRwyBxCD-0JZC7xkKgB7Lm7g.woff2',
      '600':
        'https://fonts.gstatic.com/s/anekgujarati/v9/l7g_bj5oysqknvkCo2T_8FuiIRBA7lncQUmbIBEtPKiYYQhRwyBxCD-0yZe7xkKgB7Lm7g.woff2',
      '700':
        'https://fonts.gstatic.com/s/anekgujarati/v9/l7g_bj5oysqknvkCo2T_8FuiIRBA7lncQUmbIBEtPKiYYQhRwyBxCD-08Je7xkKgB7Lm7g.woff2',
      '800':
        'https://fonts.gstatic.com/s/anekgujarati/v9/l7g_bj5oysqknvkCo2T_8FuiIRBA7lncQUmbIBEtPKiYYQhRwyBxCD-0l5e7xkKgB7Lm7g.woff2',
    },
    installName: 'anek_gujarati',
  },
  {
    label: 'Anek Gurmukhi',
    value: 'Anek Gurmukhi',
    preview:
      'https://fonts.gstatic.com/s/anekgurmukhi/v8/0QIAMXRO_YSkA0quVLY79JnHybfeEOrXCa9Dmd9Ql6a6R_vEMc5TaLkbd5tZXaQ0.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/anekgurmukhi/v8/0QIAMXRO_YSkA0quVLY79JnHybfeEOrXCa9Dmd9Ql6a6R_vEMc5TaLkbd5tpWa41H6DjbA.woff2',
      '500':
        'https://fonts.gstatic.com/s/anekgurmukhi/v8/0QIAMXRO_YSkA0quVLY79JnHybfeEOrXCa9Dmd9Ql6a6R_vEMc5TaLkbRZtpWa41H6DjbA.woff2',
      '600':
        'https://fonts.gstatic.com/s/anekgurmukhi/v8/0QIAMXRO_YSkA0quVLY79JnHybfeEOrXCa9Dmd9Ql6a6R_vEMc5TaLkbqZxpWa41H6DjbA.woff2',
      '700':
        'https://fonts.gstatic.com/s/anekgurmukhi/v8/0QIAMXRO_YSkA0quVLY79JnHybfeEOrXCa9Dmd9Ql6a6R_vEMc5TaLkbkJxpWa41H6DjbA.woff2',
      '800':
        'https://fonts.gstatic.com/s/anekgurmukhi/v8/0QIAMXRO_YSkA0quVLY79JnHybfeEOrXCa9Dmd9Ql6a6R_vEMc5TaLkb95xpWa41H6DjbA.woff2',
    },
    installName: 'anek_gurmukhi',
  },
  {
    label: 'Anek Kannada',
    value: 'Anek Kannada',
    preview:
      'https://fonts.gstatic.com/s/anekkannada/v4/raxcHiCNvNMKe1CKFsINYFlgkEIwGa8nL6ruWJg1j--h8pvBKSiw4dFDETulXxY.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/anekkannada/v4/raxcHiCNvNMKe1CKFsINYFlgkEIwGa8nL6ruWJg1j--h8pvBKSiw4dFDEQuhVReA1oef.woff2',
      '500':
        'https://fonts.gstatic.com/s/anekkannada/v4/raxcHiCNvNMKe1CKFsINYFlgkEIwGa8nL6ruWJg1j--h8pvBKSiw4dFxEQuhVReA1oef.woff2',
      '600':
        'https://fonts.gstatic.com/s/anekkannada/v4/raxcHiCNvNMKe1CKFsINYFlgkEIwGa8nL6ruWJg1j--h8pvBKSiw4dGdFguhVReA1oef.woff2',
      '700':
        'https://fonts.gstatic.com/s/anekkannada/v4/raxcHiCNvNMKe1CKFsINYFlgkEIwGa8nL6ruWJg1j--h8pvBKSiw4dGkFguhVReA1oef.woff2',
      '800':
        'https://fonts.gstatic.com/s/anekkannada/v4/raxcHiCNvNMKe1CKFsINYFlgkEIwGa8nL6ruWJg1j--h8pvBKSiw4dHDFguhVReA1oef.woff2',
    },
    installName: 'anek_kannada',
  },
  {
    label: 'Anek Latin',
    value: 'Anek Latin',
    preview:
      'https://fonts.gstatic.com/s/aneklatin/v4/co3pmWZulTRoU4a8dqrWiajBS5ByUkvdrluH-xWG5uJTY4x-L3PuR7ApKNqk.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/aneklatin/v4/co3pmWZulTRoU4a8dqrWiajBS5ByUkvdrluH-xWG5uJTY4x-L3PuR7AZLNClWL3kgw.woff2',
      '500':
        'https://fonts.gstatic.com/s/aneklatin/v4/co3pmWZulTRoU4a8dqrWiajBS5ByUkvdrluH-xWG5uJTY4x-L3PudbAZLNClWL3kgw.woff2',
      '600':
        'https://fonts.gstatic.com/s/aneklatin/v4/co3pmWZulTRoU4a8dqrWiajBS5ByUkvdrluH-xWG5uJTY4x-L3PumbcZLNClWL3kgw.woff2',
      '700':
        'https://fonts.gstatic.com/s/aneklatin/v4/co3pmWZulTRoU4a8dqrWiajBS5ByUkvdrluH-xWG5uJTY4x-L3PuoLcZLNClWL3kgw.woff2',
      '800':
        'https://fonts.gstatic.com/s/aneklatin/v4/co3pmWZulTRoU4a8dqrWiajBS5ByUkvdrluH-xWG5uJTY4x-L3Pux7cZLNClWL3kgw.woff2',
    },
    installName: 'anek_latin',
  },
  {
    label: 'Anek Malayalam',
    value: 'Anek Malayalam',
    preview:
      'https://fonts.gstatic.com/s/anekmalayalam/v5/6qLjKZActRTs_mZAJUZWWkhke0nYa_vC8_Azq3-gP1SReZeOtqQuDVUTUZu-LMvzPQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/anekmalayalam/v5/6qLjKZActRTs_mZAJUZWWkhke0nYa_vC8_Azq3-gP1SReZeOtqQuDVUTUZu-HM_5PDO71Qs.woff2',
      '500':
        'https://fonts.gstatic.com/s/anekmalayalam/v5/6qLjKZActRTs_mZAJUZWWkhke0nYa_vC8_Azq3-gP1SReZeOtqQuDVUTUam-HM_5PDO71Qs.woff2',
      '600':
        'https://fonts.gstatic.com/s/anekmalayalam/v5/6qLjKZActRTs_mZAJUZWWkhke0nYa_vC8_Azq3-gP1SReZeOtqQuDVUTUUW5HM_5PDO71Qs.woff2',
      '700':
        'https://fonts.gstatic.com/s/anekmalayalam/v5/6qLjKZActRTs_mZAJUZWWkhke0nYa_vC8_Azq3-gP1SReZeOtqQuDVUTUXy5HM_5PDO71Qs.woff2',
      '800':
        'https://fonts.gstatic.com/s/anekmalayalam/v5/6qLjKZActRTs_mZAJUZWWkhke0nYa_vC8_Azq3-gP1SReZeOtqQuDVUTURu5HM_5PDO71Qs.woff2',
    },
    installName: 'anek_malayalam',
  },
  {
    label: 'Anek Odia',
    value: 'Anek Odia',
    preview:
      'https://fonts.gstatic.com/s/anekodia/v5/TK3PWkoJARApz5UCd345tuevwwQX0CwsoYkAWgWYevAauivBUnmZfp3nV5E.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/anekodia/v5/TK3PWkoJARApz5UCd345tuevwwQX0CwsoYkAWgWYevAauivBUnmZfq3jXZAtm_es.woff2',
      '500':
        'https://fonts.gstatic.com/s/anekodia/v5/TK3PWkoJARApz5UCd345tuevwwQX0CwsoYkAWgWYevAauivBUnmrfq3jXZAtm_es.woff2',
      '600':
        'https://fonts.gstatic.com/s/anekodia/v5/TK3PWkoJARApz5UCd345tuevwwQX0CwsoYkAWgWYevAauivBUnlHea3jXZAtm_es.woff2',
      '700':
        'https://fonts.gstatic.com/s/anekodia/v5/TK3PWkoJARApz5UCd345tuevwwQX0CwsoYkAWgWYevAauivBUnl-ea3jXZAtm_es.woff2',
      '800':
        'https://fonts.gstatic.com/s/anekodia/v5/TK3PWkoJARApz5UCd345tuevwwQX0CwsoYkAWgWYevAauivBUnkZea3jXZAtm_es.woff2',
    },
    installName: 'anek_odia',
  },
  {
    label: 'Anek Tamil',
    value: 'Anek Tamil',
    preview:
      'https://fonts.gstatic.com/s/anektamil/v9/XLYJIZH2bYJHGYtPGSbUB8JKTp-_9n55SsLHW0WZez6TjtkDu3uNQidKqoH5.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/anektamil/v9/XLYJIZH2bYJHGYtPGSbUB8JKTp-_9n55SsLHW0WZez6TjtkDu3uNQid6rov4oegjOQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/anektamil/v9/XLYJIZH2bYJHGYtPGSbUB8JKTp-_9n55SsLHW0WZez6TjtkDu3uNcCd6rov4oegjOQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/anektamil/v9/XLYJIZH2bYJHGYtPGSbUB8JKTp-_9n55SsLHW0WZez6TjtkDu3uNnCB6rov4oegjOQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/anektamil/v9/XLYJIZH2bYJHGYtPGSbUB8JKTp-_9n55SsLHW0WZez6TjtkDu3uNpSB6rov4oegjOQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/anektamil/v9/XLYJIZH2bYJHGYtPGSbUB8JKTp-_9n55SsLHW0WZez6TjtkDu3uNwiB6rov4oegjOQ.woff2',
    },
    installName: 'anek_tamil',
  },
  {
    label: 'Anek Telugu',
    value: 'Anek Telugu',
    preview:
      'https://fonts.gstatic.com/s/anektelugu/v8/LhWLMVrUNvsddMtYGCx4FcVWOjlwE1WgXdoJ-5XHMl2DkooGK7i13y--kEyM2A.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/anektelugu/v8/LhWLMVrUNvsddMtYGCx4FcVWOjlwE1WgXdoJ-5XHMl2DkooGK7i13y--oEiG2ep10_8.woff2',
      '500':
        'https://fonts.gstatic.com/s/anektelugu/v8/LhWLMVrUNvsddMtYGCx4FcVWOjlwE1WgXdoJ-5XHMl2DkooGK7i13x2-oEiG2ep10_8.woff2',
      '600':
        'https://fonts.gstatic.com/s/anektelugu/v8/LhWLMVrUNvsddMtYGCx4FcVWOjlwE1WgXdoJ-5XHMl2DkooGK7i13_G5oEiG2ep10_8.woff2',
      '700':
        'https://fonts.gstatic.com/s/anektelugu/v8/LhWLMVrUNvsddMtYGCx4FcVWOjlwE1WgXdoJ-5XHMl2DkooGK7i138i5oEiG2ep10_8.woff2',
      '800':
        'https://fonts.gstatic.com/s/anektelugu/v8/LhWLMVrUNvsddMtYGCx4FcVWOjlwE1WgXdoJ-5XHMl2DkooGK7i136-5oEiG2ep10_8.woff2',
    },
    installName: 'anek_telugu',
  },
  {
    label: 'Anybody',
    value: 'Anybody',
    preview:
      'https://fonts.gstatic.com/s/anybody/v11/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4J12D_r8_C.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/anybody/v11/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4J12DPq8XD_nBPpQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/anybody/v11/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4J5WDPq8XD_nBPpQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/anybody/v11/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4JCWfPq8XD_nBPpQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/anybody/v11/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4JMGfPq8XD_nBPpQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/anybody/v11/VuJbdNvK2Ib2ppdWYq311GH32hxIv0sd5grncSUi2F_Wim4JV2fPq8XD_nBPpQ.woff2',
    },
    installName: 'anybody',
  },
  {
    label: 'Archivo',
    value: 'Archivo',
    preview:
      'https://fonts.gstatic.com/s/archivo/v18/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTTNDNZ8Rdp.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/archivo/v18/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTTNDNp9R1oJ0vyVQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/archivo/v18/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTTBjNp9R1oJ0vyVQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/archivo/v18/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTT6jRp9R1oJ0vyVQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/archivo/v18/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTT0zRp9R1oJ0vyVQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/archivo/v18/k3k6o8UDI-1M0wlSV9XAw6lQkqWY8Q82sJaRE-NWIDdgffTTtDRp9R1oJ0vyVQ.woff2',
    },
    installName: 'archivo',
  },
  {
    label: 'Assistant',
    value: 'Assistant',
    preview: '/fonts/Assistant/Assistant-Regular.woff2',
    weights: {
      '300': '/fonts/Assistant/Assistant-Light.woff2',
      '400': '/fonts/Assistant/Assistant-Regular.woff2',
      '600': '/fonts/Assistant/Assistant-SemiBold.woff2',
      '700': '/fonts/Assistant/Assistant-Bold.woff2',
    },
    installName: 'assistant',
  },
  {
    label: 'Asap',
    value: 'Asap',
    preview:
      'https://fonts.gstatic.com/s/asap/v30/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYkqUcL2mW.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/asap/v30/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYkqUsK2OXoA7Glw.woff2',
      '500':
        'https://fonts.gstatic.com/s/asap/v30/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYoKUsK2OXoA7Glw.woff2',
      '600':
        'https://fonts.gstatic.com/s/asap/v30/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYTKIsK2OXoA7Glw.woff2',
      '700':
        'https://fonts.gstatic.com/s/asap/v30/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYdaIsK2OXoA7Glw.woff2',
      '800':
        'https://fonts.gstatic.com/s/asap/v30/KFOOCniXp96a4Tc2DaTeuDAoKsE617JFc49knOIYdjTYEqIsK2OXoA7Glw.woff2',
    },
    installName: 'asap',
  },
  {
    label: 'Asap Condensed',
    value: 'Asap Condensed',
    preview:
      'https://fonts.gstatic.com/s/asapcondensed/v17/pxidypY1o9NHyXh3WvSbGSggdOeKaEw.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/asapcondensed/v17/pxidypY1o9NHyXh3WvSbGSggdNeOYk1Mq3ap.woff2',
      '500':
        'https://fonts.gstatic.com/s/asapcondensed/v17/pxieypY1o9NHyXh3WvSbGSggdO9_S2lBgGqgp-pO.woff2',
      '600':
        'https://fonts.gstatic.com/s/asapcondensed/v17/pxieypY1o9NHyXh3WvSbGSggdO9TTGlBgGqgp-pO.woff2',
      '700':
        'https://fonts.gstatic.com/s/asapcondensed/v17/pxieypY1o9NHyXh3WvSbGSggdO83TWlBgGqgp-pO.woff2',
      '800':
        'https://fonts.gstatic.com/s/asapcondensed/v17/pxieypY1o9NHyXh3WvSbGSggdO8rTmlBgGqgp-pO.woff2',
    },
    installName: 'asap_condensed',
  },
  {
    label: 'Azeret Mono',
    value: 'Azeret Mono',
    preview:
      'https://fonts.gstatic.com/s/azeretmono/v17/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfnPVR07yb.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/azeretmono/v17/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfnPVh17aa-5s3AA.woff2',
      '500':
        'https://fonts.gstatic.com/s/azeretmono/v17/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfrvVh17aa-5s3AA.woff2',
      '600':
        'https://fonts.gstatic.com/s/azeretmono/v17/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfQvJh17aa-5s3AA.woff2',
      '700':
        'https://fonts.gstatic.com/s/azeretmono/v17/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfe_Jh17aa-5s3AA.woff2',
      '800':
        'https://fonts.gstatic.com/s/azeretmono/v17/3XF5ErsiyJsY9O_Gepph-FvtTQgMQUdNekSfHPJh17aa-5s3AA.woff2',
    },
    installName: 'azeret_mono',
  },
  {
    label: 'Baloo 2',
    value: 'Baloo 2',
    preview:
      'https://fonts.gstatic.com/s/baloo2/v21/wXK0E3kTposypRydzVT08TS3JnAmtdgazZpu_lc.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/baloo2/v21/wXK0E3kTposypRydzVT08TS3JnAmtdgazapq9Fat7WcN.woff2',
      '500':
        'https://fonts.gstatic.com/s/baloo2/v21/wXK0E3kTposypRydzVT08TS3JnAmtdgozapq9Fat7WcN.woff2',
      '600':
        'https://fonts.gstatic.com/s/baloo2/v21/wXK0E3kTposypRydzVT08TS3JnAmtdjEyqpq9Fat7WcN.woff2',
      '700':
        'https://fonts.gstatic.com/s/baloo2/v21/wXK0E3kTposypRydzVT08TS3JnAmtdj9yqpq9Fat7WcN.woff2',
      '800':
        'https://fonts.gstatic.com/s/baloo2/v21/wXK0E3kTposypRydzVT08TS3JnAmtdiayqpq9Fat7WcN.woff2',
    },
    installName: 'baloo_2',
  },
  {
    label: 'Baloo Bhai 2',
    value: 'Baloo Bhai 2',
    preview:
      'https://fonts.gstatic.com/s/baloobhai2/v28/sZlWdRSL-z1VEWZ4YNA7Y5ItevYWUOHDE8FvNighAXaIog.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/baloobhai2/v28/sZlWdRSL-z1VEWZ4YNA7Y5ItevYWUOHDE8FvNighMXKCo-jsZzo.woff2',
      '500':
        'https://fonts.gstatic.com/s/baloobhai2/v28/sZlWdRSL-z1VEWZ4YNA7Y5ItevYWUOHDE8FvNhohMXKCo-jsZzo.woff2',
      '600':
        'https://fonts.gstatic.com/s/baloobhai2/v28/sZlWdRSL-z1VEWZ4YNA7Y5ItevYWUOHDE8FvNvYmMXKCo-jsZzo.woff2',
      '700':
        'https://fonts.gstatic.com/s/baloobhai2/v28/sZlWdRSL-z1VEWZ4YNA7Y5ItevYWUOHDE8FvNs8mMXKCo-jsZzo.woff2',
      '800':
        'https://fonts.gstatic.com/s/baloobhai2/v28/sZlWdRSL-z1VEWZ4YNA7Y5ItevYWUOHDE8FvNqgmMXKCo-jsZzo.woff2',
    },
    installName: 'baloo_bhai_2',
  },
  {
    label: 'Baloo Bhaijaan 2',
    value: 'Baloo Bhaijaan 2',
    preview:
      'https://fonts.gstatic.com/s/baloobhaijaan2/v19/zYXwKUwuEqdVGqM8tPDdAA_Y-_bMKo1EhQd2tWxo8TyRSpP5JYs.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/baloobhaijaan2/v19/zYXwKUwuEqdVGqM8tPDdAA_Y-_bMKo1EhQd2tWxo8TyRSqP9L4ppfcyC.woff2',
      '500':
        'https://fonts.gstatic.com/s/baloobhaijaan2/v19/zYXwKUwuEqdVGqM8tPDdAA_Y-_bMKo1EhQd2tWxo8TyjSqP9L4ppfcyC.woff2',
      '600':
        'https://fonts.gstatic.com/s/baloobhaijaan2/v19/zYXwKUwuEqdVGqM8tPDdAA_Y-_bMKo1EhQd2tWxo8TxPTaP9L4ppfcyC.woff2',
      '700':
        'https://fonts.gstatic.com/s/baloobhaijaan2/v19/zYXwKUwuEqdVGqM8tPDdAA_Y-_bMKo1EhQd2tWxo8Tx2TaP9L4ppfcyC.woff2',
      '800':
        'https://fonts.gstatic.com/s/baloobhaijaan2/v19/zYXwKUwuEqdVGqM8tPDdAA_Y-_bMKo1EhQd2tWxo8TwRTaP9L4ppfcyC.woff2',
    },
    installName: 'baloo_bhaijaan_2',
  },
  {
    label: 'Baloo Bhaina 2',
    value: 'Baloo Bhaina 2',
    preview:
      'https://fonts.gstatic.com/s/baloobhaina2/v27/qWc-B6yyq4P9Adr3RtoX1q6ySgbwusXwJjkOS-XEssPfRP5K.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/baloobhaina2/v27/qWc-B6yyq4P9Adr3RtoX1q6ySgbwusXwJjkOS-XEssPvQPRLYWmZSA.woff2',
      '500':
        'https://fonts.gstatic.com/s/baloobhaina2/v27/qWc-B6yyq4P9Adr3RtoX1q6ySgbwusXwJjkOS-XEgMPvQPRLYWmZSA.woff2',
      '600':
        'https://fonts.gstatic.com/s/baloobhaina2/v27/qWc-B6yyq4P9Adr3RtoX1q6ySgbwusXwJjkOS-XEbMTvQPRLYWmZSA.woff2',
      '700':
        'https://fonts.gstatic.com/s/baloobhaina2/v27/qWc-B6yyq4P9Adr3RtoX1q6ySgbwusXwJjkOS-XEVcTvQPRLYWmZSA.woff2',
      '800':
        'https://fonts.gstatic.com/s/baloobhaina2/v27/qWc-B6yyq4P9Adr3RtoX1q6ySgbwusXwJjkOS-XEMsTvQPRLYWmZSA.woff2',
    },
    installName: 'baloo_bhaina_2',
  },
  {
    label: 'Baloo Chettan 2',
    value: 'Baloo Chettan 2',
    preview:
      'https://fonts.gstatic.com/s/baloochettan2/v21/vm8hdRbmXEva26PK-NtuX4ynWEzF69-L4gqgkIL5CeKTC1sUHg.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/baloochettan2/v21/vm8hdRbmXEva26PK-NtuX4ynWEzF69-L4gqgkIL5CeKTO18eH9xI2gc.woff2',
      '500':
        'https://fonts.gstatic.com/s/baloochettan2/v21/vm8hdRbmXEva26PK-NtuX4ynWEzF69-L4gqgkIL5CdCTO18eH9xI2gc.woff2',
      '600':
        'https://fonts.gstatic.com/s/baloochettan2/v21/vm8hdRbmXEva26PK-NtuX4ynWEzF69-L4gqgkIL5CTyUO18eH9xI2gc.woff2',
      '700':
        'https://fonts.gstatic.com/s/baloochettan2/v21/vm8hdRbmXEva26PK-NtuX4ynWEzF69-L4gqgkIL5CQWUO18eH9xI2gc.woff2',
      '800':
        'https://fonts.gstatic.com/s/baloochettan2/v21/vm8hdRbmXEva26PK-NtuX4ynWEzF69-L4gqgkIL5CWKUO18eH9xI2gc.woff2',
    },
    installName: 'baloo_chettan_2',
  },
  {
    label: 'Baloo Da 2',
    value: 'Baloo Da 2',
    preview:
      'https://fonts.gstatic.com/s/balooda2/v24/2-c39J9j0IaUMQZwAJyJaOX1UUnf3GLnYjALsQNf7Zc.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/balooda2/v24/2-c39J9j0IaUMQZwAJyJaOX1UUnf3GLnYjALsTNb55aRa7UE.woff2',
      '500':
        'https://fonts.gstatic.com/s/balooda2/v24/2-c39J9j0IaUMQZwAJyJaOX1UUnf3GLnYjA5sTNb55aRa7UE.woff2',
      '600':
        'https://fonts.gstatic.com/s/balooda2/v24/2-c39J9j0IaUMQZwAJyJaOX1UUnf3GLnYjDVtjNb55aRa7UE.woff2',
      '700':
        'https://fonts.gstatic.com/s/balooda2/v24/2-c39J9j0IaUMQZwAJyJaOX1UUnf3GLnYjDstjNb55aRa7UE.woff2',
      '800':
        'https://fonts.gstatic.com/s/balooda2/v24/2-c39J9j0IaUMQZwAJyJaOX1UUnf3GLnYjCLtjNb55aRa7UE.woff2',
    },
    installName: 'baloo_da_2',
  },
  {
    label: 'Baloo Paaji 2',
    value: 'Baloo Paaji 2',
    preview:
      'https://fonts.gstatic.com/s/baloopaaji2/v27/i7dfIFFzbz-QHZUdV9_UGWZuelmy79QJ1HOSY9AX77fzZxQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/baloopaaji2/v27/i7dfIFFzbz-QHZUdV9_UGWZuelmy79QJ1HOSY9AX74f3bRUz1r5t.woff2',
      '500':
        'https://fonts.gstatic.com/s/baloopaaji2/v27/i7dfIFFzbz-QHZUdV9_UGWZuelmy79QJ1HOSY9Al74f3bRUz1r5t.woff2',
      '600':
        'https://fonts.gstatic.com/s/baloopaaji2/v27/i7dfIFFzbz-QHZUdV9_UGWZuelmy79QJ1HOSY9DJ6If3bRUz1r5t.woff2',
      '700':
        'https://fonts.gstatic.com/s/baloopaaji2/v27/i7dfIFFzbz-QHZUdV9_UGWZuelmy79QJ1HOSY9Dw6If3bRUz1r5t.woff2',
      '800':
        'https://fonts.gstatic.com/s/baloopaaji2/v27/i7dfIFFzbz-QHZUdV9_UGWZuelmy79QJ1HOSY9CX6If3bRUz1r5t.woff2',
    },
    installName: 'baloo_paaji_2',
  },
  {
    label: 'Baloo Tamma 2',
    value: 'Baloo Tamma 2',
    preview:
      'https://fonts.gstatic.com/s/balootamma2/v15/vEFE2_hCAgcR46PaajtrYlBbVUMUJgIC5LHTrMscPq-1Kl8.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/balootamma2/v15/vEFE2_hCAgcR46PaajtrYlBbVUMUJgIC5LHTrMscPp-xIF71SGC5.woff2',
      '500':
        'https://fonts.gstatic.com/s/balootamma2/v15/vEFE2_hCAgcR46PaajtrYlBbVUMUJgIC5LHTrMsuPp-xIF71SGC5.woff2',
      '600':
        'https://fonts.gstatic.com/s/balootamma2/v15/vEFE2_hCAgcR46PaajtrYlBbVUMUJgIC5LHTrMvCOZ-xIF71SGC5.woff2',
      '700':
        'https://fonts.gstatic.com/s/balootamma2/v15/vEFE2_hCAgcR46PaajtrYlBbVUMUJgIC5LHTrMv7OZ-xIF71SGC5.woff2',
      '800':
        'https://fonts.gstatic.com/s/balootamma2/v15/vEFE2_hCAgcR46PaajtrYlBbVUMUJgIC5LHTrMucOZ-xIF71SGC5.woff2',
    },
    installName: 'baloo_tamma_2',
  },
  {
    label: 'Baloo Tammudu 2',
    value: 'Baloo Tammudu 2',
    preview:
      'https://fonts.gstatic.com/s/balootammudu2/v22/1Pt5g8TIS_SAmkLguUdFP8UaJcKkzlPmMT00GaE_Jf8e0c-FZA.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/balootammudu2/v22/1Pt5g8TIS_SAmkLguUdFP8UaJcKkzlPmMT00GaE_Jf8e4cuPZSlGmAA.woff2',
      '500':
        'https://fonts.gstatic.com/s/balootammudu2/v22/1Pt5g8TIS_SAmkLguUdFP8UaJcKkzlPmMT00GaE_Jc0e4cuPZSlGmAA.woff2',
      '600':
        'https://fonts.gstatic.com/s/balootammudu2/v22/1Pt5g8TIS_SAmkLguUdFP8UaJcKkzlPmMT00GaE_JSEZ4cuPZSlGmAA.woff2',
      '700':
        'https://fonts.gstatic.com/s/balootammudu2/v22/1Pt5g8TIS_SAmkLguUdFP8UaJcKkzlPmMT00GaE_JRgZ4cuPZSlGmAA.woff2',
      '800':
        'https://fonts.gstatic.com/s/balootammudu2/v22/1Pt5g8TIS_SAmkLguUdFP8UaJcKkzlPmMT00GaE_JX8Z4cuPZSlGmAA.woff2',
    },
    installName: 'baloo_tammudu_2',
  },
  {
    label: 'Baloo Thambi 2',
    value: 'Baloo Thambi 2',
    preview:
      'https://fonts.gstatic.com/s/baloothambi2/v16/cY9RfjeOW0NHpmOQXranrbDyu5JMJmNp-aDvUBbKzcIDaA5H.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/baloothambi2/v16/cY9RfjeOW0NHpmOQXranrbDyu5JMJmNp-aDvUBbKzcIzbARG_n4osQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/baloothambi2/v16/cY9RfjeOW0NHpmOQXranrbDyu5JMJmNp-aDvUBbK_8IzbARG_n4osQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/baloothambi2/v16/cY9RfjeOW0NHpmOQXranrbDyu5JMJmNp-aDvUBbKE8UzbARG_n4osQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/baloothambi2/v16/cY9RfjeOW0NHpmOQXranrbDyu5JMJmNp-aDvUBbKKsUzbARG_n4osQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/baloothambi2/v16/cY9RfjeOW0NHpmOQXranrbDyu5JMJmNp-aDvUBbKTcUzbARG_n4osQ.woff2',
    },
    installName: 'baloo_thambi_2',
  },
  {
    label: 'Barlow',
    value: 'Barlow',
    preview:
      'https://fonts.gstatic.com/s/barlow/v12/7cHpv4kjgoGqM7E_Css5.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/barlow/v12/7cHpv4kjgoGqM7EPDsE46HsxnA.woff2',
      '500':
        'https://fonts.gstatic.com/s/barlow/v12/7cHqv4kjgoGqM7E3_-gc5VAtlT47dw.woff2',
      '600':
        'https://fonts.gstatic.com/s/barlow/v12/7cHqv4kjgoGqM7E30-8c5VAtlT47dw.woff2',
      '700':
        'https://fonts.gstatic.com/s/barlow/v12/7cHqv4kjgoGqM7E3t-4c5VAtlT47dw.woff2',
      '800':
        'https://fonts.gstatic.com/s/barlow/v12/7cHqv4kjgoGqM7E3q-0c5VAtlT47dw.woff2',
    },
    installName: 'barlow',
  },
  {
    label: 'Barlow Condensed',
    value: 'Barlow Condensed',
    preview:
      'https://fonts.gstatic.com/s/barlowcondensed/v12/HTx3L3I-JCGChYJ8VI-L6OO_au7B6xfT2g.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/barlowcondensed/v12/HTx3L3I-JCGChYJ8VI-L6OO_au7B2xPZ23n3pKg.woff2',
      '500':
        'https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B4-Lw_3TcuKECcrs.woff2',
      '600':
        'https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B4873_3TcuKECcrs.woff2',
      '700':
        'https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B46r2_3TcuKECcrs.woff2',
      '800':
        'https://fonts.gstatic.com/s/barlowcondensed/v12/HTxwL3I-JCGChYJ8VI-L6OO_au7B47b1_3TcuKECcrs.woff2',
    },
    installName: 'barlow_condensed',
  },
  {
    label: 'Barlow Semi Condensed',
    value: 'Barlow Semi Condensed',
    preview:
      'https://fonts.gstatic.com/s/barlowsemicondensed/v15/wlpvgxjLBV1hqnzfr-F8sEYMB0Yybp0mudRXfoqq.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/barlowsemicondensed/v15/wlpvgxjLBV1hqnzfr-F8sEYMB0Yybp0mudRneoCrCEo4gg.woff2',
      '500':
        'https://fonts.gstatic.com/s/barlowsemicondensed/v15/wlpigxjLBV1hqnzfr-F8sEYMB0Yybp0mudRfi6mPBWEki52WfA.woff2',
      '600':
        'https://fonts.gstatic.com/s/barlowsemicondensed/v15/wlpigxjLBV1hqnzfr-F8sEYMB0Yybp0mudRfp66PBWEki52WfA.woff2',
      '700':
        'https://fonts.gstatic.com/s/barlowsemicondensed/v15/wlpigxjLBV1hqnzfr-F8sEYMB0Yybp0mudRfw6-PBWEki52WfA.woff2',
      '800':
        'https://fonts.gstatic.com/s/barlowsemicondensed/v15/wlpigxjLBV1hqnzfr-F8sEYMB0Yybp0mudRf36yPBWEki52WfA.woff2',
    },
    installName: 'barlow_semi_condensed',
  },
  {
    label: 'Be Vietnam Pro',
    value: 'Be Vietnam Pro',
    preview:
      'https://fonts.gstatic.com/s/bevietnampro/v11/QdVPSTAyLFyeg_IDWvOJmVES_HwxBXo.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/bevietnampro/v11/QdVPSTAyLFyeg_IDWvOJmVES_Ew1D3s6ZKAi.woff2',
      '500':
        'https://fonts.gstatic.com/s/bevietnampro/v11/QdVMSTAyLFyeg_IDWvOJmVES_HTEJl83T7wrcwap.woff2',
      '600':
        'https://fonts.gstatic.com/s/bevietnampro/v11/QdVMSTAyLFyeg_IDWvOJmVES_HToIV83T7wrcwap.woff2',
      '700':
        'https://fonts.gstatic.com/s/bevietnampro/v11/QdVMSTAyLFyeg_IDWvOJmVES_HSMIF83T7wrcwap.woff2',
      '800':
        'https://fonts.gstatic.com/s/bevietnampro/v11/QdVMSTAyLFyeg_IDWvOJmVES_HSQI183T7wrcwap.woff2',
    },
    installName: 'be_vietnam_pro',
  },
  {
    label: 'Besley',
    value: 'Besley',
    preview:
      'https://fonts.gstatic.com/s/besley/v19/PlIhFlO1MaNwaNGWUC92IOH_mtG4fbbBedViFQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/besley/v19/PlIhFlO1MaNwaNGWUC92IOH_mtG4fbbBSdFoFPOl8-E.woff2',
      '500':
        'https://fonts.gstatic.com/s/besley/v19/PlIhFlO1MaNwaNGWUC92IOH_mtG4fYTBSdFoFPOl8-E.woff2',
      '600':
        'https://fonts.gstatic.com/s/besley/v19/PlIhFlO1MaNwaNGWUC92IOH_mtG4fWjGSdFoFPOl8-E.woff2',
      '700':
        'https://fonts.gstatic.com/s/besley/v19/PlIhFlO1MaNwaNGWUC92IOH_mtG4fVHGSdFoFPOl8-E.woff2',
      '800':
        'https://fonts.gstatic.com/s/besley/v19/PlIhFlO1MaNwaNGWUC92IOH_mtG4fTbGSdFoFPOl8-E.woff2',
    },
    installName: 'besley',
  },
  {
    label: 'Big Shoulders Display',
    value: 'Big Shoulders Display',
    preview:
      'https://fonts.gstatic.com/s/bigshouldersdisplay/v21/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0YdY87FF8wSA.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/bigshouldersdisplay/v21/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0YdY87JFs6SRP4yZQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/bigshouldersdisplay/v21/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0Ydb07JFs6SRP4yZQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/bigshouldersdisplay/v21/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0YdVE8JFs6SRP4yZQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/bigshouldersdisplay/v21/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0YdWg8JFs6SRP4yZQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/bigshouldersdisplay/v21/fC1MPZJEZG-e9gHhdI4-NBbfd2ys3SjJCx12wPgf9g-_3F0YdQ88JFs6SRP4yZQ.woff2',
    },
    installName: 'big_shoulders_display',
  },
  {
    label: 'Big Shoulders Inline Display',
    value: 'Big Shoulders Inline Display',
    preview:
      'https://fonts.gstatic.com/s/bigshouldersinlinedisplay/v27/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0nBE0R4wvY.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/bigshouldersinlinedisplay/v27/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0nBE3R8yPc2Huux.woff2',
      '500':
        'https://fonts.gstatic.com/s/bigshouldersinlinedisplay/v27/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0nzE3R8yPc2Huux.woff2',
      '600':
        'https://fonts.gstatic.com/s/bigshouldersinlinedisplay/v27/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0kfFHR8yPc2Huux.woff2',
      '700':
        'https://fonts.gstatic.com/s/bigshouldersinlinedisplay/v27/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0kmFHR8yPc2Huux.woff2',
      '800':
        'https://fonts.gstatic.com/s/bigshouldersinlinedisplay/v27/_LOumyfF4eSU_SCrJc9OI24U7siGvBGcZqmqV9-ZZ85CGNOFeNLxoYMPJ0lBFHR8yPc2Huux.woff2',
    },
    installName: 'big_shoulders_inline_display',
  },
  {
    label: 'Big Shoulders Inline Text',
    value: 'Big Shoulders Inline Text',
    preview:
      'https://fonts.gstatic.com/s/bigshouldersinlinetext/v26/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwga0y5GM548.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/bigshouldersinlinetext/v26/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwga0y6GI7Y6Jsc8c.woff2',
      '500':
        'https://fonts.gstatic.com/s/bigshouldersinlinetext/v26/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwgaGy6GI7Y6Jsc8c.woff2',
      '600':
        'https://fonts.gstatic.com/s/bigshouldersinlinetext/v26/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwgZqzKGI7Y6Jsc8c.woff2',
      '700':
        'https://fonts.gstatic.com/s/bigshouldersinlinetext/v26/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwgZTzKGI7Y6Jsc8c.woff2',
      '800':
        'https://fonts.gstatic.com/s/bigshouldersinlinetext/v26/vm8XdQDmVECV5-vm5dJ-Tp-6WDeRjL4RV7dP8u-NMyHY74qpoNNcwgY0zKGI7Y6Jsc8c.woff2',
    },
    installName: 'big_shoulders_inline_text',
  },
  {
    label: 'Big Shoulders Stencil Display',
    value: 'Big Shoulders Stencil Display',
    preview:
      'https://fonts.gstatic.com/s/bigshouldersstencildisplay/v28/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_O0j_KXbm.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/bigshouldersstencildisplay/v28/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_O0jPLXznJucP9w.woff2',
      '500':
        'https://fonts.gstatic.com/s/bigshouldersstencildisplay/v28/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_CUjPLXznJucP9w.woff2',
      '600':
        'https://fonts.gstatic.com/s/bigshouldersstencildisplay/v28/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_5U_PLXznJucP9w.woff2',
      '700':
        'https://fonts.gstatic.com/s/bigshouldersstencildisplay/v28/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_3E_PLXznJucP9w.woff2',
      '800':
        'https://fonts.gstatic.com/s/bigshouldersstencildisplay/v28/6aeZ4LS6U6pR_bp5b_t2ugOhHWFcxSGP9ttD96KCb8xPytKb-oPRU-vkuLm_u0_PLXznJucP9w.woff2',
    },
    installName: 'big_shoulders_stencil_display',
  },
  {
    label: 'Big Shoulders Stencil Text',
    value: 'Big Shoulders Stencil Text',
    preview:
      'https://fonts.gstatic.com/s/bigshouldersstenciltext/v26/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGR04T4GCXO.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/bigshouldersstenciltext/v26/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGR04TIHC_Py_AWbQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/bigshouldersstenciltext/v26/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGR4YTIHC_Py_AWbQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/bigshouldersstenciltext/v26/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGRDYPIHC_Py_AWbQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/bigshouldersstenciltext/v26/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGRNIPIHC_Py_AWbQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/bigshouldersstenciltext/v26/5aUV9-i2oxDMNwY3dHfW7UAt3Q453SM15wNj53bCcab2SJYLLUtk1OGRU4PIHC_Py_AWbQ.woff2',
    },
    installName: 'big_shoulders_stencil_text',
  },
  {
    label: 'Big Shoulders Text',
    value: 'Big Shoulders Text',
    preview:
      'https://fonts.gstatic.com/s/bigshoulderstext/v24/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3Y-q7TMFNw.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/bigshoulderstext/v24/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3Y-q3TcPNl6P2pc.woff2',
      '500':
        'https://fonts.gstatic.com/s/bigshoulderstext/v24/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3b2q3TcPNl6P2pc.woff2',
      '600':
        'https://fonts.gstatic.com/s/bigshoulderstext/v24/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3VGt3TcPNl6P2pc.woff2',
      '700':
        'https://fonts.gstatic.com/s/bigshoulderstext/v24/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3Wit3TcPNl6P2pc.woff2',
      '800':
        'https://fonts.gstatic.com/s/bigshoulderstext/v24/55xEezRtP9G3CGPIf49hxc8P0eytUxB2l66LmF6xc3kA3Q-t3TcPNl6P2pc.woff2',
    },
    installName: 'big_shoulders_text',
  },
  {
    label: 'Bitter',
    value: 'Bitter',
    preview:
      'https://fonts.gstatic.com/s/bitter/v32/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8fbfOL7OXQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/bitter/v32/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8fbfCLrEXFh2reU.woff2',
      '500':
        'https://fonts.gstatic.com/s/bitter/v32/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8cTfCLrEXFh2reU.woff2',
      '600':
        'https://fonts.gstatic.com/s/bitter/v32/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8SjYCLrEXFh2reU.woff2',
      '700':
        'https://fonts.gstatic.com/s/bitter/v32/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8RHYCLrEXFh2reU.woff2',
      '800':
        'https://fonts.gstatic.com/s/bitter/v32/raxhHiqOu8IVPmnRc6SY1KXhnF_Y8XbYCLrEXFh2reU.woff2',
    },
    installName: 'bitter',
  },
  {
    label: 'Bodoni Moda',
    value: 'Bodoni Moda',
    preview:
      'https://fonts.gstatic.com/s/bodonimoda/v23/aFT67PxzY382XsXX63LUYL6GYFcan6NJrKp-VPjfJMShrpsGFUt8oU7a8IF4tA.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/bodonimoda/v23/aFT67PxzY382XsXX63LUYL6GYFcan6NJrKp-VPjfJMShrpsGFUt8oU7awIVytVjMYwE.woff2',
      '500':
        'https://fonts.gstatic.com/s/bodonimoda/v23/aFT67PxzY382XsXX63LUYL6GYFcan6NJrKp-VPjfJMShrpsGFUt8oXzawIVytVjMYwE.woff2',
      '600':
        'https://fonts.gstatic.com/s/bodonimoda/v23/aFT67PxzY382XsXX63LUYL6GYFcan6NJrKp-VPjfJMShrpsGFUt8oZDdwIVytVjMYwE.woff2',
      '700':
        'https://fonts.gstatic.com/s/bodonimoda/v23/aFT67PxzY382XsXX63LUYL6GYFcan6NJrKp-VPjfJMShrpsGFUt8oandwIVytVjMYwE.woff2',
      '800':
        'https://fonts.gstatic.com/s/bodonimoda/v23/aFT67PxzY382XsXX63LUYL6GYFcan6NJrKp-VPjfJMShrpsGFUt8oc7dwIVytVjMYwE.woff2',
    },
    installName: 'bodoni_moda',
  },
  {
    label: 'Bricolage Grotesque',
    value: 'Bricolage Grotesque',
    preview:
      'https://fonts.gstatic.com/s/bricolagegrotesque/v1/3y9U6as8bTXq_nANBjzKo3IeZx8z6up5BeSl5jBNz_19PpbpMXuECpwUxJBOm_OJWiaaD30YfKfjZZoLvRvi-Mwlsg.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/bricolagegrotesque/v1/3y9U6as8bTXq_nANBjzKo3IeZx8z6up5BeSl5jBNz_19PpbpMXuECpwUxJBOm_OJWiaaD30YfKfjZZoLvRviyMgvs-wJDtw.woff2',
      '500':
        'https://fonts.gstatic.com/s/bricolagegrotesque/v1/3y9U6as8bTXq_nANBjzKo3IeZx8z6up5BeSl5jBNz_19PpbpMXuECpwUxJBOm_OJWiaaD30YfKfjZZoLvSniyMgvs-wJDtw.woff2',
      '600':
        'https://fonts.gstatic.com/s/bricolagegrotesque/v1/3y9U6as8bTXq_nANBjzKo3IeZx8z6up5BeSl5jBNz_19PpbpMXuECpwUxJBOm_OJWiaaD30YfKfjZZoLvcXlyMgvs-wJDtw.woff2',
      '700':
        'https://fonts.gstatic.com/s/bricolagegrotesque/v1/3y9U6as8bTXq_nANBjzKo3IeZx8z6up5BeSl5jBNz_19PpbpMXuECpwUxJBOm_OJWiaaD30YfKfjZZoLvfzlyMgvs-wJDtw.woff2',
      '800':
        'https://fonts.gstatic.com/s/bricolagegrotesque/v1/3y9U6as8bTXq_nANBjzKo3IeZx8z6up5BeSl5jBNz_19PpbpMXuECpwUxJBOm_OJWiaaD30YfKfjZZoLvZvlyMgvs-wJDtw.woff2',
    },
    installName: 'bricolage_grotesque',
  },
  {
    label: 'Cairo',
    value: 'Cairo',
    preview:
      'https://fonts.gstatic.com/s/cairo/v28/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hOA-a1XiLA.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/cairo/v28/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hOA-W1HoLQ-HmkA.woff2',
      '500':
        'https://fonts.gstatic.com/s/cairo/v28/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hNI-W1HoLQ-HmkA.woff2',
      '600':
        'https://fonts.gstatic.com/s/cairo/v28/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hD45W1HoLQ-HmkA.woff2',
      '700':
        'https://fonts.gstatic.com/s/cairo/v28/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hAc5W1HoLQ-HmkA.woff2',
      '800':
        'https://fonts.gstatic.com/s/cairo/v28/SLXgc1nY6HkvangtZmpQdkhzfH5lkSs2SgRjCAGMQ1z0hGA5W1HoLQ-HmkA.woff2',
    },
    installName: 'cairo',
  },
  {
    label: 'Cairo Play',
    value: 'Cairo Play',
    preview:
      'https://fonts.gstatic.com/s/cairoplay/v7/wXKEE3QSpo4vpRz_mz6FP-8iaauCLt_Hjopv3miu5IvcJo49mOo1knYa9i_b.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/cairoplay/v7/wXKEE3QSpo4vpRz_mz6FP-8iaauCLt_Hjopv3miu5IvcJo49mOo1knYq8iXa8GvzaA.woff2',
      '500':
        'https://fonts.gstatic.com/s/cairoplay/v7/wXKEE3QSpo4vpRz_mz6FP-8iaauCLt_Hjopv3miu5IvcJo49mOo1oHYq8iXa8GvzaA.woff2',
      '600':
        'https://fonts.gstatic.com/s/cairoplay/v7/wXKEE3QSpo4vpRz_mz6FP-8iaauCLt_Hjopv3miu5IvcJo49mOo1THEq8iXa8GvzaA.woff2',
      '700':
        'https://fonts.gstatic.com/s/cairoplay/v7/wXKEE3QSpo4vpRz_mz6FP-8iaauCLt_Hjopv3miu5IvcJo49mOo1dXEq8iXa8GvzaA.woff2',
      '800':
        'https://fonts.gstatic.com/s/cairoplay/v7/wXKEE3QSpo4vpRz_mz6FP-8iaauCLt_Hjopv3miu5IvcJo49mOo1EnEq8iXa8GvzaA.woff2',
    },
    installName: 'cairo_play',
  },
  {
    label: 'Catamaran',
    value: 'Catamaran',
    preview:
      'https://fonts.gstatic.com/s/catamaran/v18/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPHjd5ajduw.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/catamaran/v18/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPHjd1azXuluiLyw.woff2',
      '500':
        'https://fonts.gstatic.com/s/catamaran/v18/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPErd1azXuluiLyw.woff2',
      '600':
        'https://fonts.gstatic.com/s/catamaran/v18/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPKba1azXuluiLyw.woff2',
      '700':
        'https://fonts.gstatic.com/s/catamaran/v18/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPJ_a1azXuluiLyw.woff2',
      '800':
        'https://fonts.gstatic.com/s/catamaran/v18/o-0bIpQoyXQa2RxT7-5B6Ryxs2E_6n1iPPja1azXuluiLyw.woff2',
    },
    installName: 'catamaran',
  },
  {
    label: 'Changa',
    value: 'Changa',
    preview:
      'https://fonts.gstatic.com/s/changa/v27/2-c79JNi2YuVOUcOarRPgnNGooxCZ62xcjHj9w.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/changa/v27/2-c79JNi2YuVOUcOarRPgnNGooxCZ62xQjXp9htf1ZM.woff2',
      '500':
        'https://fonts.gstatic.com/s/changa/v27/2-c79JNi2YuVOUcOarRPgnNGooxCZ5-xQjXp9htf1ZM.woff2',
      '600':
        'https://fonts.gstatic.com/s/changa/v27/2-c79JNi2YuVOUcOarRPgnNGooxCZ3O2QjXp9htf1ZM.woff2',
      '700':
        'https://fonts.gstatic.com/s/changa/v27/2-c79JNi2YuVOUcOarRPgnNGooxCZ0q2QjXp9htf1ZM.woff2',
      '800':
        'https://fonts.gstatic.com/s/changa/v27/2-c79JNi2YuVOUcOarRPgnNGooxCZy22QjXp9htf1ZM.woff2',
    },
    installName: 'changa',
  },
  {
    label: 'Chivo',
    value: 'Chivo',
    preview:
      'https://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_vB_elmrT.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_vB_ukmDSFXjQiQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_jh_ukmDSFXjQiQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_YhjukmDSFXjQiQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_WxjukmDSFXjQiQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/chivo/v18/va9b4kzIxd1KFppkaRKvDRPJVDf_PBjukmDSFXjQiQ.woff2',
    },
    installName: 'chivo',
  },
  {
    label: 'Chivo Mono',
    value: 'Chivo Mono',
    preview:
      'https://fonts.gstatic.com/s/chivomono/v9/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D7hr5fUIJk.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/chivomono/v9/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D7hr6fQKphL03l4.woff2',
      '500':
        'https://fonts.gstatic.com/s/chivomono/v9/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D7Tr6fQKphL03l4.woff2',
      '600':
        'https://fonts.gstatic.com/s/chivomono/v9/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D4_qKfQKphL03l4.woff2',
      '700':
        'https://fonts.gstatic.com/s/chivomono/v9/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D4GqKfQKphL03l4.woff2',
      '800':
        'https://fonts.gstatic.com/s/chivomono/v9/mFThWbgRxKvF_Z5eQMO9qRMrJJrnKNtC3D5hqKfQKphL03l4.woff2',
    },
    installName: 'chivo_mono',
  },
  {
    label: 'Cinzel',
    value: 'Cinzel',
    preview:
      'https://fonts.gstatic.com/s/cinzel/v23/8vIU7ww63mVu7gtR-kwKxNvkNOjw-tbnfYvlDQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/cinzel/v23/8vIU7ww63mVu7gtR-kwKxNvkNOjw-tbnTY_vDE5ZdqU.woff2',
      '500':
        'https://fonts.gstatic.com/s/cinzel/v23/8vIU7ww63mVu7gtR-kwKxNvkNOjw-uTnTY_vDE5ZdqU.woff2',
      '600':
        'https://fonts.gstatic.com/s/cinzel/v23/8vIU7ww63mVu7gtR-kwKxNvkNOjw-gjgTY_vDE5ZdqU.woff2',
      '700':
        'https://fonts.gstatic.com/s/cinzel/v23/8vIU7ww63mVu7gtR-kwKxNvkNOjw-jHgTY_vDE5ZdqU.woff2',
      '800':
        'https://fonts.gstatic.com/s/cinzel/v23/8vIU7ww63mVu7gtR-kwKxNvkNOjw-lbgTY_vDE5ZdqU.woff2',
    },
    installName: 'cinzel',
  },
  {
    label: 'Comme',
    value: 'Comme',
    preview:
      'https://fonts.gstatic.com/s/comme/v2/8QIUdirKhMbn-uG1kHz0MgviDe1z5cFb6oQe.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/comme/v2/8QIUdirKhMbn-uG1kHz0MgviDe1z5cFr7o4fWsRO9w.woff2',
      '500':
        'https://fonts.gstatic.com/s/comme/v2/8QIUdirKhMbn-uG1kHz0MgviDe1z18Fr7o4fWsRO9w.woff2',
      '600':
        'https://fonts.gstatic.com/s/comme/v2/8QIUdirKhMbn-uG1kHz0MgviDe1zO8Zr7o4fWsRO9w.woff2',
      '700':
        'https://fonts.gstatic.com/s/comme/v2/8QIUdirKhMbn-uG1kHz0MgviDe1zAsZr7o4fWsRO9w.woff2',
      '800':
        'https://fonts.gstatic.com/s/comme/v2/8QIUdirKhMbn-uG1kHz0MgviDe1zZcZr7o4fWsRO9w.woff2',
    },
    installName: 'comme',
  },
  {
    label: 'Commissioner',
    value: 'Commissioner',
    preview:
      'https://fonts.gstatic.com/s/commissioner/v20/tDaH2o2WnlgI0FNDgduEk4jAhwgumbU1SVfU5BD8OuRL8OstC6KOhgvBYWSFJ-Mgdrgiju6fF8meZm0rk4eF-ZugTMNdKPaxFw.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/commissioner/v20/tDaH2o2WnlgI0FNDgduEk4jAhwgumbU1SVfU5BD8OuRL8OstC6KOhgvBYWSFJ-Mgdrgiju6fF8meZm0rk4eF-ZugTMNdGPK7Fu0jUdk.woff2',
      '500':
        'https://fonts.gstatic.com/s/commissioner/v20/tDaH2o2WnlgI0FNDgduEk4jAhwgumbU1SVfU5BD8OuRL8OstC6KOhgvBYWSFJ-Mgdrgiju6fF8meZm0rk4eF-ZugTPFdGPK7Fu0jUdk.woff2',
      '600':
        'https://fonts.gstatic.com/s/commissioner/v20/tDaH2o2WnlgI0FNDgduEk4jAhwgumbU1SVfU5BD8OuRL8OstC6KOhgvBYWSFJ-Mgdrgiju6fF8meZm0rk4eF-ZugTB1aGPK7Fu0jUdk.woff2',
      '700':
        'https://fonts.gstatic.com/s/commissioner/v20/tDaH2o2WnlgI0FNDgduEk4jAhwgumbU1SVfU5BD8OuRL8OstC6KOhgvBYWSFJ-Mgdrgiju6fF8meZm0rk4eF-ZugTCRaGPK7Fu0jUdk.woff2',
      '800':
        'https://fonts.gstatic.com/s/commissioner/v20/tDaH2o2WnlgI0FNDgduEk4jAhwgumbU1SVfU5BD8OuRL8OstC6KOhgvBYWSFJ-Mgdrgiju6fF8meZm0rk4eF-ZugTENaGPK7Fu0jUdk.woff2',
    },
    installName: 'commissioner',
  },
  {
    label: 'Crimson Pro',
    value: 'Crimson Pro',
    preview:
      'https://fonts.gstatic.com/s/crimsonpro/v23/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZzm1MOZs-.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/crimsonpro/v23/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZzm18PZE_VNWoyQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/crimsonpro/v23/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZ_G18PZE_VNWoyQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/crimsonpro/v23/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZEGp8PZE_VNWoyQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/crimsonpro/v23/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZKWp8PZE_VNWoyQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/crimsonpro/v23/q5uUsoa5M_tv7IihmnkabC5XiXCAlXGks1WZTmp8PZE_VNWoyQ.woff2',
    },
    installName: 'crimson_pro',
  },
  {
    label: 'Darker Grotesque',
    value: 'Darker Grotesque',
    preview:
      'https://fonts.gstatic.com/s/darkergrotesque/v8/U9MK6cuh-mLQlC4BKCtayOfARkSVgb381b-W8-QDqXw3qk7z83A.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/darkergrotesque/v8/U9MK6cuh-mLQlC4BKCtayOfARkSVgb381b-W8-QDqXw3qn73-XFyZFUB.woff2',
      '500':
        'https://fonts.gstatic.com/s/darkergrotesque/v8/U9MK6cuh-mLQlC4BKCtayOfARkSVgb381b-W8-QDqXwFqn73-XFyZFUB.woff2',
      '600':
        'https://fonts.gstatic.com/s/darkergrotesque/v8/U9MK6cuh-mLQlC4BKCtayOfARkSVgb381b-W8-QDqXzprX73-XFyZFUB.woff2',
      '700':
        'https://fonts.gstatic.com/s/darkergrotesque/v8/U9MK6cuh-mLQlC4BKCtayOfARkSVgb381b-W8-QDqXzQrX73-XFyZFUB.woff2',
      '800':
        'https://fonts.gstatic.com/s/darkergrotesque/v8/U9MK6cuh-mLQlC4BKCtayOfARkSVgb381b-W8-QDqXy3rX73-XFyZFUB.woff2',
    },
    installName: 'darker_grotesque',
  },
  {
    label: 'DM Sans',
    value: 'DM Sans',
    preview:
      'https://fonts.gstatic.com/s/dmsans/v14/rP2tp2ywxg089UriI5-g4vlH9VoD8CmcqZG40F9JadbnoEwAopxRT232.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/dmsans/v14/rP2tp2ywxg089UriI5-g4vlH9VoD8CmcqZG40F9JadbnoEwAopxhS2f3ZGMZpg.woff2',
      '500':
        'https://fonts.gstatic.com/s/dmsans/v14/rP2tp2ywxg089UriI5-g4vlH9VoD8CmcqZG40F9JadbnoEwAkJxhS2f3ZGMZpg.woff2',
      '600':
        'https://fonts.gstatic.com/s/dmsans/v14/rP2tp2ywxg089UriI5-g4vlH9VoD8CmcqZG40F9JadbnoEwAfJthS2f3ZGMZpg.woff2',
      '700':
        'https://fonts.gstatic.com/s/dmsans/v14/rP2tp2ywxg089UriI5-g4vlH9VoD8CmcqZG40F9JadbnoEwARZthS2f3ZGMZpg.woff2',
      '800':
        'https://fonts.gstatic.com/s/dmsans/v14/rP2tp2ywxg089UriI5-g4vlH9VoD8CmcqZG40F9JadbnoEwAIpthS2f3ZGMZpg.woff2',
    },
    installName: 'dm_sans',
  },
  {
    label: 'Dosis',
    value: 'Dosis',
    preview:
      'https://fonts.gstatic.com/s/dosis/v32/HhyJU5sn9vOmLxNkIwRSjTVNWLEJN7Ml3RME.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/dosis/v32/HhyJU5sn9vOmLxNkIwRSjTVNWLEJN7MV2RkFTq4EPw.woff2',
      '500':
        'https://fonts.gstatic.com/s/dosis/v32/HhyJU5sn9vOmLxNkIwRSjTVNWLEJBbMV2RkFTq4EPw.woff2',
      '600':
        'https://fonts.gstatic.com/s/dosis/v32/HhyJU5sn9vOmLxNkIwRSjTVNWLEJ6bQV2RkFTq4EPw.woff2',
      '700':
        'https://fonts.gstatic.com/s/dosis/v32/HhyJU5sn9vOmLxNkIwRSjTVNWLEJ0LQV2RkFTq4EPw.woff2',
      '800':
        'https://fonts.gstatic.com/s/dosis/v32/HhyJU5sn9vOmLxNkIwRSjTVNWLEJt7QV2RkFTq4EPw.woff2',
    },
    installName: 'dosis',
  },
  {
    label: 'EB Garamond',
    value: 'EB Garamond',
    preview:
      'https://fonts.gstatic.com/s/ebgaramond/v26/SlGDmQSNjdsmc35JDF1K5E55YMjF_7DPuGi-6_RkAo9_.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/ebgaramond/v26/SlGDmQSNjdsmc35JDF1K5E55YMjF_7DPuGi-6_RUBoV-e6yHgQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/ebgaramond/v26/SlGDmQSNjdsmc35JDF1K5E55YMjF_7DPuGi-2fRUBoV-e6yHgQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/ebgaramond/v26/SlGDmQSNjdsmc35JDF1K5E55YMjF_7DPuGi-NfNUBoV-e6yHgQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/ebgaramond/v26/SlGDmQSNjdsmc35JDF1K5E55YMjF_7DPuGi-DPNUBoV-e6yHgQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/ebgaramond/v26/SlGDmQSNjdsmc35JDF1K5E55YMjF_7DPuGi-a_NUBoV-e6yHgQ.woff2',
    },
    installName: 'eb_garamond',
  },
  {
    label: 'Eczar',
    value: 'Eczar',
    preview:
      'https://fonts.gstatic.com/s/eczar/v22/BXR2vF3Pi-DLmxcpJB-qbNTyTMDXHd6mqDgU.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/eczar/v22/BXR2vF3Pi-DLmxcpJB-qbNTyTMDXHd6WrDIVKWJKWg.woff2',
      '500':
        'https://fonts.gstatic.com/s/eczar/v22/BXR2vF3Pi-DLmxcpJB-qbNTyTMDXL96WrDIVKWJKWg.woff2',
      '600':
        'https://fonts.gstatic.com/s/eczar/v22/BXR2vF3Pi-DLmxcpJB-qbNTyTMDXw9mWrDIVKWJKWg.woff2',
      '700':
        'https://fonts.gstatic.com/s/eczar/v22/BXR2vF3Pi-DLmxcpJB-qbNTyTMDX-tmWrDIVKWJKWg.woff2',
      '800':
        'https://fonts.gstatic.com/s/eczar/v22/BXR2vF3Pi-DLmxcpJB-qbNTyTMDXndmWrDIVKWJKWg.woff2',
    },
    installName: 'eczar',
  },
  {
    label: 'Encode Sans',
    value: 'Encode Sans',
    preview:
      'https://fonts.gstatic.com/s/encodesans/v19/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGGHjVtSF7Q.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/encodesans/v19/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGGHjZtCP7FJCt2c.woff2',
      '500':
        'https://fonts.gstatic.com/s/encodesans/v19/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGFPjZtCP7FJCt2c.woff2',
      '600':
        'https://fonts.gstatic.com/s/encodesans/v19/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGL_kZtCP7FJCt2c.woff2',
      '700':
        'https://fonts.gstatic.com/s/encodesans/v19/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGIbkZtCP7FJCt2c.woff2',
      '800':
        'https://fonts.gstatic.com/s/encodesans/v19/LDIcapOFNxEwR-Bd1O9uYNmnUQomAgE25imKSbHhROjLsZBWTSrQGOHkZtCP7FJCt2c.woff2',
    },
    installName: 'encode_sans',
  },
  {
    label: 'Encode Sans Condensed',
    value: 'Encode Sans Condensed',
    preview:
      'https://fonts.gstatic.com/s/encodesanscondensed/v10/j8_16_LD37rqfuwxyIuaZhE6cRXOLtm2gfT2gK-M.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/encodesanscondensed/v10/j8_16_LD37rqfuwxyIuaZhE6cRXOLtm2gfTGhKWNDw8VIw.woff2',
      '500':
        'https://fonts.gstatic.com/s/encodesanscondensed/v10/j8_46_LD37rqfuwxyIuaZhE6cRXOLtm2gfT-dYypAiQJKnuIFA.woff2',
      '600':
        'https://fonts.gstatic.com/s/encodesanscondensed/v10/j8_46_LD37rqfuwxyIuaZhE6cRXOLtm2gfT-WYupAiQJKnuIFA.woff2',
      '700':
        'https://fonts.gstatic.com/s/encodesanscondensed/v10/j8_46_LD37rqfuwxyIuaZhE6cRXOLtm2gfT-PYqpAiQJKnuIFA.woff2',
      '800':
        'https://fonts.gstatic.com/s/encodesanscondensed/v10/j8_46_LD37rqfuwxyIuaZhE6cRXOLtm2gfT-IYmpAiQJKnuIFA.woff2',
    },
    installName: 'encode_sans_condensed',
  },
  {
    label: 'Encode Sans Expanded',
    value: 'Encode Sans Expanded',
    preview:
      'https://fonts.gstatic.com/s/encodesansexpanded/v11/c4m_1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpojKQY.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/encodesansexpanded/v11/c4m_1mF4GcnstG_Jh1QH6ac4hNLeNyeYUqonIwdAd5Ab.woff2',
      '500':
        'https://fonts.gstatic.com/s/encodesansexpanded/v11/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpLWCiNNXIwSP0XD.woff2',
      '600':
        'https://fonts.gstatic.com/s/encodesansexpanded/v11/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpL6DSNNXIwSP0XD.woff2',
      '700':
        'https://fonts.gstatic.com/s/encodesansexpanded/v11/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpKeDCNNXIwSP0XD.woff2',
      '800':
        'https://fonts.gstatic.com/s/encodesansexpanded/v11/c4mw1mF4GcnstG_Jh1QH6ac4hNLeNyeYUpKCDyNNXIwSP0XD.woff2',
    },
    installName: 'encode_sans_expanded',
  },
  {
    label: 'Encode Sans SC',
    value: 'Encode Sans SC',
    preview:
      'https://fonts.gstatic.com/s/encodesanssc/v8/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HHhmwc5HOQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/encodesanssc/v8/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HHhm8cpNOEEClIc.woff2',
      '500':
        'https://fonts.gstatic.com/s/encodesanssc/v8/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HEpm8cpNOEEClIc.woff2',
      '600':
        'https://fonts.gstatic.com/s/encodesanssc/v8/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HKZh8cpNOEEClIc.woff2',
      '700':
        'https://fonts.gstatic.com/s/encodesanssc/v8/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HJ9h8cpNOEEClIc.woff2',
      '800':
        'https://fonts.gstatic.com/s/encodesanssc/v8/jVyp7nLwCGzQ9zE7ZyRg0QRXHPZc_uUA6Kb3VJWLE_Pdtm7lcD6qvXT1HPhh8cpNOEEClIc.woff2',
    },
    installName: 'encode_sans_sc',
  },
  {
    label: 'Encode Sans Semi Condensed',
    value: 'Encode Sans Semi Condensed',
    preview:
      'https://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT4oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG1yQ9MQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT4oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG2yU_sVPRsjp.woff2',
      '500':
        'https://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT7oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG1Rl1-FCbdTgTFmr.woff2',
      '600':
        'https://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT7oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG1RJ0OFCbdTgTFmr.woff2',
      '700':
        'https://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT7oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG1Qt0eFCbdTgTFmr.woff2',
      '800':
        'https://fonts.gstatic.com/s/encodesanssemicondensed/v10/3qT7oiKqnDuUtQUEHMoXcmspmy55SFWrXFRp9FTOG1Qx0uFCbdTgTFmr.woff2',
    },
    installName: 'encode_sans_semi_condensed',
  },
  {
    label: 'Encode Sans Semi Expanded',
    value: 'Encode Sans Semi Expanded',
    preview:
      'https://fonts.gstatic.com/s/encodesanssemiexpanded/v19/ke83OhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TO4s1Lg.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/encodesanssemiexpanded/v19/ke83OhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TC48_LyjgOXc.woff2',
      '500':
        'https://fonts.gstatic.com/s/encodesanssemiexpanded/v19/ke8yOhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TM34WCyXLJX6XCWU.woff2',
      '600':
        'https://fonts.gstatic.com/s/encodesanssemiexpanded/v19/ke8yOhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TM1IRCyXLJX6XCWU.woff2',
      '700':
        'https://fonts.gstatic.com/s/encodesanssemiexpanded/v19/ke8yOhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TMzYQCyXLJX6XCWU.woff2',
      '800':
        'https://fonts.gstatic.com/s/encodesanssemiexpanded/v19/ke8yOhAPMEZs-BDuzwftTNJ85JvwMOzE9d9Cca5TMyoTCyXLJX6XCWU.woff2',
    },
    installName: 'encode_sans_semi_expanded',
  },
  {
    label: 'Epilogue',
    value: 'Epilogue',
    preview:
      'https://fonts.gstatic.com/s/epilogue/v17/O4ZMFGj5hxF0EhjimngomvnCCtqb30OXMDPSDZ_U.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/epilogue/v17/O4ZMFGj5hxF0EhjimngomvnCCtqb30OXMDPiCZXVigHPVA.woff2',
      '500':
        'https://fonts.gstatic.com/s/epilogue/v17/O4ZMFGj5hxF0EhjimngomvnCCtqb30OXAjPiCZXVigHPVA.woff2',
      '600':
        'https://fonts.gstatic.com/s/epilogue/v17/O4ZMFGj5hxF0EhjimngomvnCCtqb30OX7jTiCZXVigHPVA.woff2',
      '700':
        'https://fonts.gstatic.com/s/epilogue/v17/O4ZMFGj5hxF0EhjimngomvnCCtqb30OX1zTiCZXVigHPVA.woff2',
      '800':
        'https://fonts.gstatic.com/s/epilogue/v17/O4ZMFGj5hxF0EhjimngomvnCCtqb30OXsDTiCZXVigHPVA.woff2',
    },
    installName: 'epilogue',
  },
  {
    label: 'Exo',
    value: 'Exo',
    preview:
      'https://fonts.gstatic.com/s/exo/v20/4UaZrEtFpBI4f1ZSIK9d4LjJ4lM3OwJmOw.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/exo/v20/4UaZrEtFpBI4f1ZSIK9d4LjJ4lM3CwZsOl4p5Is.woff2',
      '500':
        'https://fonts.gstatic.com/s/exo/v20/4UaZrEtFpBI4f1ZSIK9d4LjJ4mE3CwZsOl4p5Is.woff2',
      '600':
        'https://fonts.gstatic.com/s/exo/v20/4UaZrEtFpBI4f1ZSIK9d4LjJ4o0wCwZsOl4p5Is.woff2',
      '700':
        'https://fonts.gstatic.com/s/exo/v20/4UaZrEtFpBI4f1ZSIK9d4LjJ4rQwCwZsOl4p5Is.woff2',
      '800':
        'https://fonts.gstatic.com/s/exo/v20/4UaZrEtFpBI4f1ZSIK9d4LjJ4tMwCwZsOl4p5Is.woff2',
    },
    installName: 'exo',
  },
  {
    label: 'Exo 2',
    value: 'Exo 2',
    preview:
      'https://fonts.gstatic.com/s/exo2/v20/7cH1v4okm5zmbvwkAx_sfcEuiD8jvvKsP9C_.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/exo2/v20/7cH1v4okm5zmbvwkAx_sfcEuiD8jvvKcO9q-rpvLpQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/exo2/v20/7cH1v4okm5zmbvwkAx_sfcEuiD8jjPKcO9q-rpvLpQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/exo2/v20/7cH1v4okm5zmbvwkAx_sfcEuiD8jYPWcO9q-rpvLpQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/exo2/v20/7cH1v4okm5zmbvwkAx_sfcEuiD8jWfWcO9q-rpvLpQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/exo2/v20/7cH1v4okm5zmbvwkAx_sfcEuiD8jPvWcO9q-rpvLpQ.woff2',
    },
    installName: 'exo_2',
  },
  {
    label: 'Faustina',
    value: 'Faustina',
    preview:
      'https://fonts.gstatic.com/s/faustina/v20/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHlsgoEfGF-X.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/faustina/v20/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHlsgoEvHFWWe8tbEg.woff2',
      '500':
        'https://fonts.gstatic.com/s/faustina/v20/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHlssIEvHFWWe8tbEg.woff2',
      '600':
        'https://fonts.gstatic.com/s/faustina/v20/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHlsXIYvHFWWe8tbEg.woff2',
      '700':
        'https://fonts.gstatic.com/s/faustina/v20/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHlsZYYvHFWWe8tbEg.woff2',
      '800':
        'https://fonts.gstatic.com/s/faustina/v20/XLY4IZPxYpJfTbZAFXWzNT2SO8wpWHlsAoYvHFWWe8tbEg.woff2',
    },
    installName: 'faustina',
  },
  {
    label: 'Figtree',
    value: 'Figtree',
    preview:
      'https://fonts.gstatic.com/s/figtree/v5/_Xmz-HUzqDCFdgfMsYiV_F7wfS-Bs_d_QG5fyEA.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/figtree/v5/_Xmz-HUzqDCFdgfMsYiV_F7wfS-Bs_d_QF5bwkEU4HTy.woff2',
      '500':
        'https://fonts.gstatic.com/s/figtree/v5/_Xmz-HUzqDCFdgfMsYiV_F7wfS-Bs_dNQF5bwkEU4HTy.woff2',
      '600':
        'https://fonts.gstatic.com/s/figtree/v5/_Xmz-HUzqDCFdgfMsYiV_F7wfS-Bs_ehR15bwkEU4HTy.woff2',
      '700':
        'https://fonts.gstatic.com/s/figtree/v5/_Xmz-HUzqDCFdgfMsYiV_F7wfS-Bs_eYR15bwkEU4HTy.woff2',
      '800':
        'https://fonts.gstatic.com/s/figtree/v5/_Xmz-HUzqDCFdgfMsYiV_F7wfS-Bs_f_R15bwkEU4HTy.woff2',
    },
    installName: 'figtree',
  },
  {
    label: 'Fira Sans',
    value: 'Fira Sans',
    preview:
      'https://fonts.gstatic.com/s/firasans/v17/va9E4kDNxMZdWfMOD5VvkYjL.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/firasans/v17/va9E4kDNxMZdWfMOD5VflYLKSTbndQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/firasans/v17/va9B4kDNxMZdWfMOD5VnZKvuRB37fF3Wlg.woff2',
      '600':
        'https://fonts.gstatic.com/s/firasans/v17/va9B4kDNxMZdWfMOD5VnSKzuRB37fF3Wlg.woff2',
      '700':
        'https://fonts.gstatic.com/s/firasans/v17/va9B4kDNxMZdWfMOD5VnLK3uRB37fF3Wlg.woff2',
      '800':
        'https://fonts.gstatic.com/s/firasans/v17/va9B4kDNxMZdWfMOD5VnMK7uRB37fF3Wlg.woff2',
    },
    installName: 'fira_sans',
  },
  {
    label: 'Fira Sans Condensed',
    value: 'Fira Sans Condensed',
    preview:
      'https://fonts.gstatic.com/s/firasanscondensed/v10/wEOhEADFm8hSaQTFG18FErVhsC9x-tarUfDtrQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/firasanscondensed/v10/wEOhEADFm8hSaQTFG18FErVhsC9x-tarYfTnrMtVbx8.woff2',
      '500':
        'https://fonts.gstatic.com/s/firasanscondensed/v10/wEOsEADFm8hSaQTFG18FErVhsC9x-tarWQXOiMZ-cxZblY4.woff2',
      '600':
        'https://fonts.gstatic.com/s/firasanscondensed/v10/wEOsEADFm8hSaQTFG18FErVhsC9x-tarWSnJiMZ-cxZblY4.woff2',
      '700':
        'https://fonts.gstatic.com/s/firasanscondensed/v10/wEOsEADFm8hSaQTFG18FErVhsC9x-tarWU3IiMZ-cxZblY4.woff2',
      '800':
        'https://fonts.gstatic.com/s/firasanscondensed/v10/wEOsEADFm8hSaQTFG18FErVhsC9x-tarWVHLiMZ-cxZblY4.woff2',
    },
    installName: 'fira_sans_condensed',
  },
  {
    label: 'Fira Sans Extra Condensed',
    value: 'Fira Sans Extra Condensed',
    preview:
      'https://fonts.gstatic.com/s/firasansextracondensed/v10/NaPKcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda1fmuug.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/firasansextracondensed/v10/NaPKcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda5f2ku3efvE8.woff2',
      '500':
        'https://fonts.gstatic.com/s/firasansextracondensed/v10/NaPPcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda3QyNn3q0oEZ-a2Q.woff2',
      '600':
        'https://fonts.gstatic.com/s/firasansextracondensed/v10/NaPPcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda3SCKn3q0oEZ-a2Q.woff2',
      '700':
        'https://fonts.gstatic.com/s/firasansextracondensed/v10/NaPPcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda3USLn3q0oEZ-a2Q.woff2',
      '800':
        'https://fonts.gstatic.com/s/firasansextracondensed/v10/NaPPcYDaAO5dirw6IaFn7lPJFqXmS-M9Atn3wgda3ViIn3q0oEZ-a2Q.woff2',
    },
    installName: 'fira_sans_extra_condensed',
  },
  {
    label: 'Foldit',
    value: 'Foldit',
    preview:
      'https://fonts.gstatic.com/s/foldit/v5/aFTI7PF3Y3c9WdjNrRVE0Rk2b7j8XpAMqateYQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/foldit/v5/aFTI7PF3Y3c9WdjNrRVE0Rk2b7j8XpAMma9UYLHkN80.woff2',
      '500':
        'https://fonts.gstatic.com/s/foldit/v5/aFTI7PF3Y3c9WdjNrRVE0Rk2b7j8XqIMma9UYLHkN80.woff2',
      '600':
        'https://fonts.gstatic.com/s/foldit/v5/aFTI7PF3Y3c9WdjNrRVE0Rk2b7j8Xk4Lma9UYLHkN80.woff2',
      '700':
        'https://fonts.gstatic.com/s/foldit/v5/aFTI7PF3Y3c9WdjNrRVE0Rk2b7j8XncLma9UYLHkN80.woff2',
      '800':
        'https://fonts.gstatic.com/s/foldit/v5/aFTI7PF3Y3c9WdjNrRVE0Rk2b7j8XhALma9UYLHkN80.woff2',
    },
    installName: 'foldit',
  },
  {
    label: 'Frank Ruhl Libre',
    value: 'Frank Ruhl Libre',
    preview:
      'https://fonts.gstatic.com/s/frankruhllibre/v20/j8_96_fAw7jrcalD7oKYNX0QfAnPcbzNEEB7OoicBw7FYWqRNRU.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/frankruhllibre/v20/j8_96_fAw7jrcalD7oKYNX0QfAnPcbzNEEB7OoicBw7FYVqVPxR2EUR_.woff2',
      '500':
        'https://fonts.gstatic.com/s/frankruhllibre/v20/j8_96_fAw7jrcalD7oKYNX0QfAnPcbzNEEB7OoicBw73YVqVPxR2EUR_.woff2',
      '600':
        'https://fonts.gstatic.com/s/frankruhllibre/v20/j8_96_fAw7jrcalD7oKYNX0QfAnPcbzNEEB7OoicBw4bZlqVPxR2EUR_.woff2',
      '700':
        'https://fonts.gstatic.com/s/frankruhllibre/v20/j8_96_fAw7jrcalD7oKYNX0QfAnPcbzNEEB7OoicBw4iZlqVPxR2EUR_.woff2',
      '800':
        'https://fonts.gstatic.com/s/frankruhllibre/v20/j8_96_fAw7jrcalD7oKYNX0QfAnPcbzNEEB7OoicBw5FZlqVPxR2EUR_.woff2',
    },
    installName: 'frank_ruhl_libre',
  },
  {
    label: 'Fraunces',
    value: 'Fraunces',
    preview:
      'https://fonts.gstatic.com/s/fraunces/v31/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIctxuTD_7T.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/fraunces/v31/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIctxujC_TShUtWNg.woff2',
      '500':
        'https://fonts.gstatic.com/s/fraunces/v31/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIchRujC_TShUtWNg.woff2',
      '600':
        'https://fonts.gstatic.com/s/fraunces/v31/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIcaRyjC_TShUtWNg.woff2',
      '700':
        'https://fonts.gstatic.com/s/fraunces/v31/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIcUByjC_TShUtWNg.woff2',
      '800':
        'https://fonts.gstatic.com/s/fraunces/v31/6NUh8FyLNQOQZAnv9bYEvDiIdE9Ea92uemAk_WBq8U_9v0c2Wa0K7iN7hzFUPJH58nib1603gg7S2nfgRYIcNxyjC_TShUtWNg.woff2',
    },
    installName: 'fraunces',
  },
  {
    label: 'Gantari',
    value: 'Gantari',
    preview:
      'https://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g0gOg3xYZA.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g0gOj31a5GD2qnm.woff2',
      '500':
        'https://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g0SOj31a5GD2qnm.woff2',
      '600':
        'https://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g3-PT31a5GD2qnm.woff2',
      '700':
        'https://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g3HPT31a5GD2qnm.woff2',
      '800':
        'https://fonts.gstatic.com/s/gantari/v1/jVyV7nvyB2HL8iZyDk4GVvSZ5MtC9g2gPT31a5GD2qnm.woff2',
    },
    installName: 'gantari',
  },
  {
    label: 'Gemunu Libre',
    value: 'Gemunu Libre',
    preview:
      'https://fonts.gstatic.com/s/gemunulibre/v14/X7n34bQ6Cfy7jKGXVE_YlqnbEQAFP-PIuTCp0xiJDvWBeQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/gemunulibre/v14/X7n34bQ6Cfy7jKGXVE_YlqnbEQAFP-PIuTCp0xiJPvGLeMXPIWA.woff2',
      '500':
        'https://fonts.gstatic.com/s/gemunulibre/v14/X7n34bQ6Cfy7jKGXVE_YlqnbEQAFP-PIuTCp0yqJPvGLeMXPIWA.woff2',
      '600':
        'https://fonts.gstatic.com/s/gemunulibre/v14/X7n34bQ6Cfy7jKGXVE_YlqnbEQAFP-PIuTCp08aOPvGLeMXPIWA.woff2',
      '700':
        'https://fonts.gstatic.com/s/gemunulibre/v14/X7n34bQ6Cfy7jKGXVE_YlqnbEQAFP-PIuTCp0_-OPvGLeMXPIWA.woff2',
      '800':
        'https://fonts.gstatic.com/s/gemunulibre/v14/X7n34bQ6Cfy7jKGXVE_YlqnbEQAFP-PIuTCp05iOPvGLeMXPIWA.woff2',
    },
    installName: 'gemunu_libre',
  },
  {
    label: 'Genos',
    value: 'Genos',
    preview:
      'https://fonts.gstatic.com/s/genos/v12/SlGNmQqPqpUOYTYjacb0Hc91fTwVqkjYrEi7.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/genos/v12/SlGNmQqPqpUOYTYjacb0Hc91fTwVqkjoqEK6K7ZsAg.woff2',
      '500':
        'https://fonts.gstatic.com/s/genos/v12/SlGNmQqPqpUOYTYjacb0Hc91fTwVmEjoqEK6K7ZsAg.woff2',
      '600':
        'https://fonts.gstatic.com/s/genos/v12/SlGNmQqPqpUOYTYjacb0Hc91fTwVdE_oqEK6K7ZsAg.woff2',
      '700':
        'https://fonts.gstatic.com/s/genos/v12/SlGNmQqPqpUOYTYjacb0Hc91fTwVTU_oqEK6K7ZsAg.woff2',
      '800':
        'https://fonts.gstatic.com/s/genos/v12/SlGNmQqPqpUOYTYjacb0Hc91fTwVKk_oqEK6K7ZsAg.woff2',
    },
    installName: 'genos',
  },
  {
    label: 'Geologica',
    value: 'Geologica',
    preview:
      'https://fonts.gstatic.com/s/geologica/v1/oY1o8evIr7j9P3TN9YwNAdyjzUyDKkKdAGOJh1UlCDUIhAIdhCZOn1fLsig7jfvCCPHZckU8H3G11_z-_OZqDx_rc-ISAA.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/geologica/v1/oY1o8evIr7j9P3TN9YwNAdyjzUyDKkKdAGOJh1UlCDUIhAIdhCZOn1fLsig7jfvCCPHZckU8H3G11_z-_OZqDx_rQ-YYAXWnqFs.woff2',
      '500':
        'https://fonts.gstatic.com/s/geologica/v1/oY1o8evIr7j9P3TN9YwNAdyjzUyDKkKdAGOJh1UlCDUIhAIdhCZOn1fLsig7jfvCCPHZckU8H3G11_z-_OZqDy3rQ-YYAXWnqFs.woff2',
      '600':
        'https://fonts.gstatic.com/s/geologica/v1/oY1o8evIr7j9P3TN9YwNAdyjzUyDKkKdAGOJh1UlCDUIhAIdhCZOn1fLsig7jfvCCPHZckU8H3G11_z-_OZqD8HsQ-YYAXWnqFs.woff2',
      '700':
        'https://fonts.gstatic.com/s/geologica/v1/oY1o8evIr7j9P3TN9YwNAdyjzUyDKkKdAGOJh1UlCDUIhAIdhCZOn1fLsig7jfvCCPHZckU8H3G11_z-_OZqD_jsQ-YYAXWnqFs.woff2',
      '800':
        'https://fonts.gstatic.com/s/geologica/v1/oY1o8evIr7j9P3TN9YwNAdyjzUyDKkKdAGOJh1UlCDUIhAIdhCZOn1fLsig7jfvCCPHZckU8H3G11_z-_OZqD5_sQ-YYAXWnqFs.woff2',
    },
    installName: 'geologica',
  },
  {
    label: 'Georama',
    value: 'Georama',
    preview:
      'https://fonts.gstatic.com/s/georama/v13/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5GvgdmAEK.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/georama/v13/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5GvgtnAsL5_tgbg.woff2',
      '500':
        'https://fonts.gstatic.com/s/georama/v13/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5KPgtnAsL5_tgbg.woff2',
      '600':
        'https://fonts.gstatic.com/s/georama/v13/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5xP8tnAsL5_tgbg.woff2',
      '700':
        'https://fonts.gstatic.com/s/georama/v13/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5_f8tnAsL5_tgbg.woff2',
      '800':
        'https://fonts.gstatic.com/s/georama/v13/MCo5zAn438bIEyxFf6swMnNpvPcUwW4u4yRcDh-ZjxApn9K5mv8tnAsL5_tgbg.woff2',
    },
    installName: 'georama',
  },
  {
    label: 'Glory',
    value: 'Glory',
    preview:
      'https://fonts.gstatic.com/s/glory/v15/q5uasoi9Lf1w5t3Est24nq9blIRQwImzp3Wc.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/glory/v15/q5uasoi9Lf1w5t3Est24nq9blIRQwImDo3-dDi9EOQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/glory/v15/q5uasoi9Lf1w5t3Est24nq9blIRQ8omDo3-dDi9EOQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/glory/v15/q5uasoi9Lf1w5t3Est24nq9blIRQHo6Do3-dDi9EOQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/glory/v15/q5uasoi9Lf1w5t3Est24nq9blIRQJ46Do3-dDi9EOQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/glory/v15/q5uasoi9Lf1w5t3Est24nq9blIRQQI6Do3-dDi9EOQ.woff2',
    },
    installName: 'glory',
  },
  {
    label: 'Gluten',
    value: 'Gluten',
    preview:
      'https://fonts.gstatic.com/s/gluten/v16/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8Vb7S1KsHk.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/gluten/v16/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8Vb7R1Ouni7ciJh.woff2',
      '500':
        'https://fonts.gstatic.com/s/gluten/v16/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8Vp7R1Ouni7ciJh.woff2',
      '600':
        'https://fonts.gstatic.com/s/gluten/v16/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8WF6h1Ouni7ciJh.woff2',
      '700':
        'https://fonts.gstatic.com/s/gluten/v16/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8W86h1Ouni7ciJh.woff2',
      '800':
        'https://fonts.gstatic.com/s/gluten/v16/Hhy_U5gk9fW7OUdVIPh2zD_RSqQJ__A15jgJsn-Bhb_yI8Xb6h1Ouni7ciJh.woff2',
    },
    installName: 'gluten',
  },
  {
    label: 'Golos Text',
    value: 'Golos Text',
    preview:
      'https://fonts.gstatic.com/s/golostext/v4/q5uXsoe9Lv5t7Meb31EcOR9UdVTNs822plVRRT5dGL4.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/golostext/v4/q5uXsoe9Lv5t7Meb31EcOR9UdVTNs822plVRRQ5ZEr8zXcyx.woff2',
      '500':
        'https://fonts.gstatic.com/s/golostext/v4/q5uXsoe9Lv5t7Meb31EcOR9UdVTNs822plVjRQ5ZEr8zXcyx.woff2',
      '600':
        'https://fonts.gstatic.com/s/golostext/v4/q5uXsoe9Lv5t7Meb31EcOR9UdVTNs822plWPQg5ZEr8zXcyx.woff2',
      '700':
        'https://fonts.gstatic.com/s/golostext/v4/q5uXsoe9Lv5t7Meb31EcOR9UdVTNs822plW2Qg5ZEr8zXcyx.woff2',
      '800':
        'https://fonts.gstatic.com/s/golostext/v4/q5uXsoe9Lv5t7Meb31EcOR9UdVTNs822plXRQg5ZEr8zXcyx.woff2',
    },
    installName: 'golos_text',
  },
  {
    label: 'Gothic A1',
    value: 'Gothic A1',
    preview:
      'https://fonts.gstatic.com/s/gothica1/v13/CSR94z5ZnPydRjlCCwlKbccv.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/gothica1/v13/CSR94z5ZnPydRjlCCwl6ac0uQNJmvQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/gothica1/v13/CSR44z5ZnPydRjlCCwlCmOQKTfl6tOU9Eg.woff2',
      '600':
        'https://fonts.gstatic.com/s/gothica1/v13/CSR44z5ZnPydRjlCCwlCtOMKTfl6tOU9Eg.woff2',
      '700':
        'https://fonts.gstatic.com/s/gothica1/v13/CSR44z5ZnPydRjlCCwlC0OIKTfl6tOU9Eg.woff2',
      '800':
        'https://fonts.gstatic.com/s/gothica1/v13/CSR44z5ZnPydRjlCCwlCzOEKTfl6tOU9Eg.woff2',
    },
    installName: 'gothic_a1',
  },
  {
    label: 'Grandstander',
    value: 'Grandstander',
    preview:
      'https://fonts.gstatic.com/s/grandstander/v17/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQD1--P3nctw.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/grandstander/v17/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQD1--D33WttFGmQk.woff2',
      '500':
        'https://fonts.gstatic.com/s/grandstander/v17/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQD22-D33WttFGmQk.woff2',
      '600':
        'https://fonts.gstatic.com/s/grandstander/v17/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQD4G5D33WttFGmQk.woff2',
      '700':
        'https://fonts.gstatic.com/s/grandstander/v17/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQD7i5D33WttFGmQk.woff2',
      '800':
        'https://fonts.gstatic.com/s/grandstander/v17/ga6fawtA-GpSsTWrnNHPCSIMZhhKpFjyNZIQD9-5D33WttFGmQk.woff2',
    },
    installName: 'grandstander',
  },
  {
    label: 'Grenze',
    value: 'Grenze',
    preview:
      'https://fonts.gstatic.com/s/grenze/v15/O4ZTFGb7hR12BxqH_mIm.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/grenze/v15/O4ZTFGb7hR12Bxq3-mgnmgwKlg.woff2',
      '500':
        'https://fonts.gstatic.com/s/grenze/v15/O4ZQFGb7hR12BxqPC0EDlycWn2CEyw.woff2',
      '600':
        'https://fonts.gstatic.com/s/grenze/v15/O4ZQFGb7hR12BxqPJ0YDlycWn2CEyw.woff2',
      '700':
        'https://fonts.gstatic.com/s/grenze/v15/O4ZQFGb7hR12BxqPQ0cDlycWn2CEyw.woff2',
      '800':
        'https://fonts.gstatic.com/s/grenze/v15/O4ZQFGb7hR12BxqPX0QDlycWn2CEyw.woff2',
    },
    installName: 'grenze',
  },
  {
    label: 'Grenze Gotisch',
    value: 'Grenze Gotisch',
    preview:
      'https://fonts.gstatic.com/s/grenzegotisch/v18/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i5Lz9kcYqc.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/grenzegotisch/v18/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i5Lz9UdYCdYPSd_w.woff2',
      '500':
        'https://fonts.gstatic.com/s/grenzegotisch/v18/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i5HT9UdYCdYPSd_w.woff2',
      '600':
        'https://fonts.gstatic.com/s/grenzegotisch/v18/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i58ThUdYCdYPSd_w.woff2',
      '700':
        'https://fonts.gstatic.com/s/grenzegotisch/v18/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i5yDhUdYCdYPSd_w.woff2',
      '800':
        'https://fonts.gstatic.com/s/grenzegotisch/v18/Fh4hPjjqNDz1osh_jX9YfjudpBJBNV5y5wf_k1i5rzhUdYCdYPSd_w.woff2',
    },
    installName: 'grenze_gotisch',
  },
  {
    label: 'Hahmlet',
    value: 'Hahmlet',
    preview:
      'https://fonts.gstatic.com/s/hahmlet/v13/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4RhKOOjpZMI.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/hahmlet/v13/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4RhKONjtbsO-aVxn.woff2',
      '500':
        'https://fonts.gstatic.com/s/hahmlet/v13/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4Rh4ONjtbsO-aVxn.woff2',
      '600':
        'https://fonts.gstatic.com/s/hahmlet/v13/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4RiUP9jtbsO-aVxn.woff2',
      '700':
        'https://fonts.gstatic.com/s/hahmlet/v13/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4RitP9jtbsO-aVxn.woff2',
      '800':
        'https://fonts.gstatic.com/s/hahmlet/v13/BngXUXpCQ3nKpIo0TfPyfCdXfaeU4RjKP9jtbsO-aVxn.woff2',
    },
    installName: 'hahmlet',
  },
  {
    label: 'Handjet',
    value: 'Handjet',
    preview:
      'https://fonts.gstatic.com/s/handjet/v19/oY1n8eXHq7n1OnbQrOY_2FrEwYEMLlcdP1mCtZaLaTutCwcIhGZ0lGU0akFcO3XFHTmaYkQmEQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/handjet/v19/oY1n8eXHq7n1OnbQrOY_2FrEwYEMLlcdP1mCtZaLaTutCwcIhGZ0lGU0akFcO3XFHTmaUkAsEHFAH2A.woff2',
      '500':
        'https://fonts.gstatic.com/s/handjet/v19/oY1n8eXHq7n1OnbQrOY_2FrEwYEMLlcdP1mCtZaLaTutCwcIhGZ0lGU0akFcO3XFHQuaUkAsEHFAH2A.woff2',
      '600':
        'https://fonts.gstatic.com/s/handjet/v19/oY1n8eXHq7n1OnbQrOY_2FrEwYEMLlcdP1mCtZaLaTutCwcIhGZ0lGU0akFcO3XFHeedUkAsEHFAH2A.woff2',
      '700':
        'https://fonts.gstatic.com/s/handjet/v19/oY1n8eXHq7n1OnbQrOY_2FrEwYEMLlcdP1mCtZaLaTutCwcIhGZ0lGU0akFcO3XFHd6dUkAsEHFAH2A.woff2',
      '800':
        'https://fonts.gstatic.com/s/handjet/v19/oY1n8eXHq7n1OnbQrOY_2FrEwYEMLlcdP1mCtZaLaTutCwcIhGZ0lGU0akFcO3XFHbmdUkAsEHFAH2A.woff2',
    },
    installName: 'handjet',
  },
  {
    label: 'Hanken Grotesk',
    value: 'Hanken Grotesk',
    preview:
      'https://fonts.gstatic.com/s/hankengrotesk/v8/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_Ncs2Zq4PBM.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/hankengrotesk/v8/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_Ncs2Za5PpNzXhRKA.woff2',
      '500':
        'https://fonts.gstatic.com/s/hankengrotesk/v8/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_NcgWZa5PpNzXhRKA.woff2',
      '600':
        'https://fonts.gstatic.com/s/hankengrotesk/v8/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_NcbWFa5PpNzXhRKA.woff2',
      '700':
        'https://fonts.gstatic.com/s/hankengrotesk/v8/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_NcVGFa5PpNzXhRKA.woff2',
      '800':
        'https://fonts.gstatic.com/s/hankengrotesk/v8/ieVq2YZDLWuGJpnzaiwFXS9tYvBRzyFLlZg_f_NcM2Fa5PpNzXhRKA.woff2',
    },
    installName: 'hanken_grotesk',
  },
  {
    label: 'Heebo',
    value: 'Heebo',
    preview:
      'https://fonts.gstatic.com/s/heebo/v21/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EiSysc0mm.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/heebo/v21/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EiSycd0Onz02SXQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/heebo/v21/NGSpv5_NC0k9P_v6ZUCbLRAHxK1Euyycd0Onz02SXQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/heebo/v21/NGSpv5_NC0k9P_v6ZUCbLRAHxK1EVyucd0Onz02SXQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/heebo/v21/NGSpv5_NC0k9P_v6ZUCbLRAHxK1Ebiucd0Onz02SXQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/heebo/v21/NGSpv5_NC0k9P_v6ZUCbLRAHxK1ECSucd0Onz02SXQ.woff2',
    },
    installName: 'heebo',
  },
  {
    label: 'Hepta Slab',
    value: 'Hepta Slab',
    preview:
      'https://fonts.gstatic.com/s/heptaslab/v23/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5HvkV5wfaaZE.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/heptaslab/v23/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5HvkV5zfeY5B0NBkz.woff2',
      '500':
        'https://fonts.gstatic.com/s/heptaslab/v23/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5Hvkn5zfeY5B0NBkz.woff2',
      '600':
        'https://fonts.gstatic.com/s/heptaslab/v23/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5HvnL4DfeY5B0NBkz.woff2',
      '700':
        'https://fonts.gstatic.com/s/heptaslab/v23/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5Hvny4DfeY5B0NBkz.woff2',
      '800':
        'https://fonts.gstatic.com/s/heptaslab/v23/ea8JadoyU_jkHdalebHvyWVNdYoIsHe5HvmV4DfeY5B0NBkz.woff2',
    },
    installName: 'hepta_slab',
  },
  {
    label: 'Imbue',
    value: 'Imbue',
    preview:
      'https://fonts.gstatic.com/s/imbue/v26/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoP8iXTOoHNQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/imbue/v26/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoP8iXfO4NNK-Q4xY.woff2',
      '500':
        'https://fonts.gstatic.com/s/imbue/v26/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoP_qXfO4NNK-Q4xY.woff2',
      '600':
        'https://fonts.gstatic.com/s/imbue/v26/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoPxaQfO4NNK-Q4xY.woff2',
      '700':
        'https://fonts.gstatic.com/s/imbue/v26/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoPy-QfO4NNK-Q4xY.woff2',
      '800':
        'https://fonts.gstatic.com/s/imbue/v26/RLpXK5P16Ki3fXhj5cvGrqjocPk4n-gVX3M93TnrnvhoP0iQfO4NNK-Q4xY.woff2',
    },
    installName: 'imbue',
  },
  {
    label: 'Inconsolata',
    value: 'Inconsolata',
    preview:
      'https://fonts.gstatic.com/s/inconsolata/v31/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lpp4U8WRv2lw.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/inconsolata/v31/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lpp4U8aR_8lleY2co.woff2',
      '500':
        'https://fonts.gstatic.com/s/inconsolata/v31/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lpp7c8aR_8lleY2co.woff2',
      '600':
        'https://fonts.gstatic.com/s/inconsolata/v31/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lpp1s7aR_8lleY2co.woff2',
      '700':
        'https://fonts.gstatic.com/s/inconsolata/v31/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7Lpp2I7aR_8lleY2co.woff2',
      '800':
        'https://fonts.gstatic.com/s/inconsolata/v31/QldgNThLqRwH-OJ1UHjlKENVzkWGVkL3GZQmAwLYxYWI2qfdm7LppwU7aR_8lleY2co.woff2',
    },
    installName: 'inconsolata',
  },
  {
    label: 'Inknut Antiqua',
    value: 'Inknut Antiqua',
    preview:
      'https://fonts.gstatic.com/s/inknutantiqua/v14/Y4GSYax7VC4ot_qNB4nYpBdaKUUC4J0.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/inknutantiqua/v14/Y4GSYax7VC4ot_qNB4nYpBdaKXUG6pzxRwYB.woff2',
      '500':
        'https://fonts.gstatic.com/s/inknutantiqua/v14/Y4GRYax7VC4ot_qNB4nYpBdaKU33w7j8bBoIYJNf.woff2',
      '600':
        'https://fonts.gstatic.com/s/inknutantiqua/v14/Y4GRYax7VC4ot_qNB4nYpBdaKU3bxLj8bBoIYJNf.woff2',
      '700':
        'https://fonts.gstatic.com/s/inknutantiqua/v14/Y4GRYax7VC4ot_qNB4nYpBdaKU2_xbj8bBoIYJNf.woff2',
      '800':
        'https://fonts.gstatic.com/s/inknutantiqua/v14/Y4GRYax7VC4ot_qNB4nYpBdaKU2jxrj8bBoIYJNf.woff2',
    },
    installName: 'inknut_antiqua',
  },
  {
    label: 'Inter',
    value: 'Inter',
    preview:
      'https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfAZlhiA.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuLyfMZ1rib2Bg-4.woff2',
      '500':
        'https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuI6fMZ1rib2Bg-4.woff2',
      '600':
        'https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuGKYMZ1rib2Bg-4.woff2',
      '700':
        'https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuFuYMZ1rib2Bg-4.woff2',
      '800':
        'https://fonts.gstatic.com/s/inter/v12/UcCO3FwrK3iLTeHuS_fvQtMwCp50KnMw2boKoduKmMEVuDyYMZ1rib2Bg-4.woff2',
    },
    installName: 'inter',
  },
  {
    label: 'Inter Tight',
    value: 'Inter Tight',
    preview:
      'https://fonts.gstatic.com/s/intertight/v7/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mjDw-aXS5S.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/intertight/v7/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mjDw-qWSRToK8EPg.woff2',
      '500':
        'https://fonts.gstatic.com/s/intertight/v7/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mjPQ-qWSRToK8EPg.woff2',
      '600':
        'https://fonts.gstatic.com/s/intertight/v7/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mj0QiqWSRToK8EPg.woff2',
      '700':
        'https://fonts.gstatic.com/s/intertight/v7/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mj6AiqWSRToK8EPg.woff2',
      '800':
        'https://fonts.gstatic.com/s/intertight/v7/NGSnv5HMAFg6IuGlBNMjxJEL2VmU3NS7Z2mjjwiqWSRToK8EPg.woff2',
    },
    installName: 'inter_tight',
  },
  {
    label: 'JetBrains Mono',
    value: 'JetBrains Mono',
    preview:
      'https://fonts.gstatic.com/s/jetbrainsmono/v18/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8yKxTPFOV.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/jetbrainsmono/v18/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8yKxjOFmUsaaDhw.woff2',
      '500':
        'https://fonts.gstatic.com/s/jetbrainsmono/v18/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8-qxjOFmUsaaDhw.woff2',
      '600':
        'https://fonts.gstatic.com/s/jetbrainsmono/v18/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8FqtjOFmUsaaDhw.woff2',
      '700':
        'https://fonts.gstatic.com/s/jetbrainsmono/v18/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8L6tjOFmUsaaDhw.woff2',
      '800':
        'https://fonts.gstatic.com/s/jetbrainsmono/v18/tDbY2o-flEEny0FZhsfKu5WU4zr3E_BX0PnT8RD8SKtjOFmUsaaDhw.woff2',
    },
    installName: 'jetbrains_mono',
  },
  {
    label: 'Jost',
    value: 'Jost',
    preview:
      'https://fonts.gstatic.com/s/jost/v14/92zPtBhPNqw79Ij1E865zBUv7myjJTVHNIg.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/jost/v14/92zPtBhPNqw79Ij1E865zBUv7myjJQVDPokMmuHL.woff2',
      '500':
        'https://fonts.gstatic.com/s/jost/v14/92zPtBhPNqw79Ij1E865zBUv7myRJQVDPokMmuHL.woff2',
      '600':
        'https://fonts.gstatic.com/s/jost/v14/92zPtBhPNqw79Ij1E865zBUv7mx9IgVDPokMmuHL.woff2',
      '700':
        'https://fonts.gstatic.com/s/jost/v14/92zPtBhPNqw79Ij1E865zBUv7mxEIgVDPokMmuHL.woff2',
      '800':
        'https://fonts.gstatic.com/s/jost/v14/92zPtBhPNqw79Ij1E865zBUv7mwjIgVDPokMmuHL.woff2',
    },
    installName: 'jost',
  },
  {
    label: 'K2D',
    value: 'K2D',
    preview: 'https://fonts.gstatic.com/s/k2d/v11/J7aTnpF2V0EjdqUs.woff2',
    weights: {
      '400': 'https://fonts.gstatic.com/s/k2d/v11/J7aTnpF2V0ETcq8tnLcg7w.woff2',
      '500':
        'https://fonts.gstatic.com/s/k2d/v11/J7aenpF2V0Erg4YJkZw85ppSGw.woff2',
      '600':
        'https://fonts.gstatic.com/s/k2d/v11/J7aenpF2V0Err4EJkZw85ppSGw.woff2',
      '700':
        'https://fonts.gstatic.com/s/k2d/v11/J7aenpF2V0Ery4AJkZw85ppSGw.woff2',
      '800':
        'https://fonts.gstatic.com/s/k2d/v11/J7aenpF2V0Er14MJkZw85ppSGw.woff2',
    },
    installName: 'k2d',
  },
  {
    label: 'Kanit',
    value: 'Kanit',
    preview: 'https://fonts.gstatic.com/s/kanit/v15/nKKZ-Go6G5tXcraTGwA.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/kanit/v15/nKKZ-Go6G5tXcoaXEQGodLxA.woff2',
      '500':
        'https://fonts.gstatic.com/s/kanit/v15/nKKU-Go6G5tXcr5mOCWlX6BJNUJy.woff2',
      '600':
        'https://fonts.gstatic.com/s/kanit/v15/nKKU-Go6G5tXcr5KPyWlX6BJNUJy.woff2',
      '700':
        'https://fonts.gstatic.com/s/kanit/v15/nKKU-Go6G5tXcr4uPiWlX6BJNUJy.woff2',
      '800':
        'https://fonts.gstatic.com/s/kanit/v15/nKKU-Go6G5tXcr4yPSWlX6BJNUJy.woff2',
    },
    installName: 'kanit',
  },
  {
    label: 'Karla',
    value: 'Karla',
    preview:
      'https://fonts.gstatic.com/s/karla/v30/qkBIXvYC6trAT55ZBi1ueQVIjQTD-JqaFUlK.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/karla/v30/qkBIXvYC6trAT55ZBi1ueQVIjQTD-JqqEUNLR7fHGw.woff2',
      '500':
        'https://fonts.gstatic.com/s/karla/v30/qkBIXvYC6trAT55ZBi1ueQVIjQTDypqqEUNLR7fHGw.woff2',
      '600':
        'https://fonts.gstatic.com/s/karla/v30/qkBIXvYC6trAT55ZBi1ueQVIjQTDJp2qEUNLR7fHGw.woff2',
      '700':
        'https://fonts.gstatic.com/s/karla/v30/qkBIXvYC6trAT55ZBi1ueQVIjQTDH52qEUNLR7fHGw.woff2',
      '800':
        'https://fonts.gstatic.com/s/karla/v30/qkBIXvYC6trAT55ZBi1ueQVIjQTDeJ2qEUNLR7fHGw.woff2',
    },
    installName: 'karla',
  },
  {
    label: 'Kufam',
    value: 'Kufam',
    preview:
      'https://fonts.gstatic.com/s/kufam/v20/C8c-4cY7pG7w_oSJDszBXsKCcBH3lqkLqAqI.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/kufam/v20/C8c-4cY7pG7w_oSJDszBXsKCcBH3lqk7rACJHvIwYg.woff2',
      '500':
        'https://fonts.gstatic.com/s/kufam/v20/C8c-4cY7pG7w_oSJDszBXsKCcBH3pKk7rACJHvIwYg.woff2',
      '600':
        'https://fonts.gstatic.com/s/kufam/v20/C8c-4cY7pG7w_oSJDszBXsKCcBH3SK47rACJHvIwYg.woff2',
      '700':
        'https://fonts.gstatic.com/s/kufam/v20/C8c-4cY7pG7w_oSJDszBXsKCcBH3ca47rACJHvIwYg.woff2',
      '800':
        'https://fonts.gstatic.com/s/kufam/v20/C8c-4cY7pG7w_oSJDszBXsKCcBH3Fq47rACJHvIwYg.woff2',
    },
    installName: 'kufam',
  },
  {
    label: 'Kumbh Sans',
    value: 'Kumbh Sans',
    preview:
      'https://fonts.gstatic.com/s/kumbhsans/v20/c4mP1n92AsfhuCq6tVsaoIx1LQICk0boNoq0SjlDfnzKo-bF3mdQkZYw8L7v.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/kumbhsans/v20/c4mP1n92AsfhuCq6tVsaoIx1LQICk0boNoq0SjlDfnzKo-bF3mdQkZYA9LTuUkqaLg.woff2',
      '500':
        'https://fonts.gstatic.com/s/kumbhsans/v20/c4mP1n92AsfhuCq6tVsaoIx1LQICk0boNoq0SjlDfnzKo-bF3mdQo5YA9LTuUkqaLg.woff2',
      '600':
        'https://fonts.gstatic.com/s/kumbhsans/v20/c4mP1n92AsfhuCq6tVsaoIx1LQICk0boNoq0SjlDfnzKo-bF3mdQT5EA9LTuUkqaLg.woff2',
      '700':
        'https://fonts.gstatic.com/s/kumbhsans/v20/c4mP1n92AsfhuCq6tVsaoIx1LQICk0boNoq0SjlDfnzKo-bF3mdQdpEA9LTuUkqaLg.woff2',
      '800':
        'https://fonts.gstatic.com/s/kumbhsans/v20/c4mP1n92AsfhuCq6tVsaoIx1LQICk0boNoq0SjlDfnzKo-bF3mdQEZEA9LTuUkqaLg.woff2',
    },
    installName: 'kumbh_sans',
  },
  {
    label: 'Labrada',
    value: 'Labrada',
    preview:
      'https://fonts.gstatic.com/s/labrada/v2/ieVh2Y9HLWefIpOyF1Vi3ZqDss1Px9VTSzM5SvY.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/labrada/v2/ieVh2Y9HLWefIpOyF1Vi3ZqDss1Px9VTSwM9QPdUej17.woff2',
      '500':
        'https://fonts.gstatic.com/s/labrada/v2/ieVh2Y9HLWefIpOyF1Vi3ZqDss1Px9VhSwM9QPdUej17.woff2',
      '600':
        'https://fonts.gstatic.com/s/labrada/v2/ieVh2Y9HLWefIpOyF1Vi3ZqDss1Px9WNTAM9QPdUej17.woff2',
      '700':
        'https://fonts.gstatic.com/s/labrada/v2/ieVh2Y9HLWefIpOyF1Vi3ZqDss1Px9W0TAM9QPdUej17.woff2',
      '800':
        'https://fonts.gstatic.com/s/labrada/v2/ieVh2Y9HLWefIpOyF1Vi3ZqDss1Px9XTTAM9QPdUej17.woff2',
    },
    installName: 'labrada',
  },
  {
    label: 'Lateef',
    value: 'Lateef',
    preview:
      'https://fonts.gstatic.com/s/lateef/v29/hESw6XVnNCxEvkb8px2F.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/lateef/v29/hESw6XVnNCxEvkbMoxeEZo_H_w.woff2',
      '500':
        'https://fonts.gstatic.com/s/lateef/v29/hESz6XVnNCxEvkb0Uj6ga6Tb9nQ-RA.woff2',
      '600':
        'https://fonts.gstatic.com/s/lateef/v29/hESz6XVnNCxEvkb0fjmga6Tb9nQ-RA.woff2',
      '700':
        'https://fonts.gstatic.com/s/lateef/v29/hESz6XVnNCxEvkb0Gjiga6Tb9nQ-RA.woff2',
      '800':
        'https://fonts.gstatic.com/s/lateef/v29/hESz6XVnNCxEvkb0Bjuga6Tb9nQ-RA.woff2',
    },
    installName: 'lateef',
  },
  {
    label: 'League Spartan',
    value: 'League Spartan',
    preview:
      'https://fonts.gstatic.com/s/leaguespartan/v11/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvM_oTZBc1d.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/leaguespartan/v11/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvM_oTpAcdcFguczA.woff2',
      '500':
        'https://fonts.gstatic.com/s/leaguespartan/v11/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvMzITpAcdcFguczA.woff2',
      '600':
        'https://fonts.gstatic.com/s/leaguespartan/v11/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvMIIPpAcdcFguczA.woff2',
      '700':
        'https://fonts.gstatic.com/s/leaguespartan/v11/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvMGYPpAcdcFguczA.woff2',
      '800':
        'https://fonts.gstatic.com/s/leaguespartan/v11/kJEnBuEW6A0lliaV_m88ja5Twtx8BWhtkDVmjZvMfoPpAcdcFguczA.woff2',
    },
    installName: 'league_spartan',
  },
  {
    label: 'Lexend',
    value: 'Lexend',
    preview:
      'https://fonts.gstatic.com/s/lexend/v18/wlptgwvFAVdoq2_F94zlCfv0bz1WCzsWzLFneg.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/lexend/v18/wlptgwvFAVdoq2_F94zlCfv0bz1WCzsW_LVte6KuGEo.woff2',
      '500':
        'https://fonts.gstatic.com/s/lexend/v18/wlptgwvFAVdoq2_F94zlCfv0bz1WCwkW_LVte6KuGEo.woff2',
      '600':
        'https://fonts.gstatic.com/s/lexend/v18/wlptgwvFAVdoq2_F94zlCfv0bz1WC-UR_LVte6KuGEo.woff2',
      '700':
        'https://fonts.gstatic.com/s/lexend/v18/wlptgwvFAVdoq2_F94zlCfv0bz1WC9wR_LVte6KuGEo.woff2',
      '800':
        'https://fonts.gstatic.com/s/lexend/v18/wlptgwvFAVdoq2_F94zlCfv0bz1WC7sR_LVte6KuGEo.woff2',
    },
    installName: 'lexend',
  },
  {
    label: 'Lexend Deca',
    value: 'Lexend Deca',
    preview:
      'https://fonts.gstatic.com/s/lexenddeca/v21/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U48M1wrRnD.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/lexenddeca/v21/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U48M1AqRPCqLNflg.woff2',
      '500':
        'https://fonts.gstatic.com/s/lexenddeca/v21/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4ws1AqRPCqLNflg.woff2',
      '600':
        'https://fonts.gstatic.com/s/lexenddeca/v21/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4LspAqRPCqLNflg.woff2',
      '700':
        'https://fonts.gstatic.com/s/lexenddeca/v21/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4F8pAqRPCqLNflg.woff2',
      '800':
        'https://fonts.gstatic.com/s/lexenddeca/v21/K2FifZFYk-dHSE0UPPuwQ7CrD94i-NCKm-U4cMpAqRPCqLNflg.woff2',
    },
    installName: 'lexend_deca',
  },
  {
    label: 'Lexend Exa',
    value: 'Lexend Exa',
    preview:
      'https://fonts.gstatic.com/s/lexendexa/v30/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9r7TpbGFp4.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/lexendexa/v30/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9r7TqbCHJ8BRq0b.woff2',
      '500':
        'https://fonts.gstatic.com/s/lexendexa/v30/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9rJTqbCHJ8BRq0b.woff2',
      '600':
        'https://fonts.gstatic.com/s/lexendexa/v30/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9olSabCHJ8BRq0b.woff2',
      '700':
        'https://fonts.gstatic.com/s/lexendexa/v30/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9ocSabCHJ8BRq0b.woff2',
      '800':
        'https://fonts.gstatic.com/s/lexendexa/v30/UMBCrPdOoHOnxExyjdBeQCH18mulUxBvI9p7SabCHJ8BRq0b.woff2',
    },
    installName: 'lexend_exa',
  },
  {
    label: 'Lexend Giga',
    value: 'Lexend Giga',
    preview:
      'https://fonts.gstatic.com/s/lexendgiga/v24/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRC2Li06sAp.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/lexendgiga/v24/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRC2LiE7soo6eepYQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/lexendgiga/v24/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRC6riE7soo6eepYQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/lexendgiga/v24/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRCBr-E7soo6eepYQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/lexendgiga/v24/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRCP7-E7soo6eepYQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/lexendgiga/v24/PlIuFl67Mah5Y8yMHE7lkUZPlTBo4MWFfNRCWL-E7soo6eepYQ.woff2',
    },
    installName: 'lexend_giga',
  },
  {
    label: 'Lexend Mega',
    value: 'Lexend Mega',
    preview:
      'https://fonts.gstatic.com/s/lexendmega/v24/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDL8fmfvOaj.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/lexendmega/v24/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDL8fmvuOyiq9EqQw.woff2',
      '500':
        'https://fonts.gstatic.com/s/lexendmega/v24/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDLw_mvuOyiq9EqQw.woff2',
      '600':
        'https://fonts.gstatic.com/s/lexendmega/v24/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDLL_6vuOyiq9EqQw.woff2',
      '700':
        'https://fonts.gstatic.com/s/lexendmega/v24/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDLFv6vuOyiq9EqQw.woff2',
      '800':
        'https://fonts.gstatic.com/s/lexendmega/v24/qFdX35aBi5JtHD41zSTFEuTByuvYFuE9IbDLcf6vuOyiq9EqQw.woff2',
    },
    installName: 'lexend_mega',
  },
  {
    label: 'Lexend Peta',
    value: 'Lexend Peta',
    preview:
      'https://fonts.gstatic.com/s/lexendpeta/v27/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgR6SBCWlwv.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/lexendpeta/v27/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgR6SByXlYuRTsnfw.woff2',
      '500':
        'https://fonts.gstatic.com/s/lexendpeta/v27/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgR2yByXlYuRTsnfw.woff2',
      '600':
        'https://fonts.gstatic.com/s/lexendpeta/v27/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgRNydyXlYuRTsnfw.woff2',
      '700':
        'https://fonts.gstatic.com/s/lexendpeta/v27/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgRDidyXlYuRTsnfw.woff2',
      '800':
        'https://fonts.gstatic.com/s/lexendpeta/v27/BXR4vFPGjeLPh0kCfI4OkFX-UTQHSCaxvBgRaSdyXlYuRTsnfw.woff2',
    },
    installName: 'lexend_peta',
  },
  {
    label: 'Lexend Tera',
    value: 'Lexend Tera',
    preview:
      'https://fonts.gstatic.com/s/lexendtera/v27/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiM5zMjd5b1.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/lexendtera/v27/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiM5zMTc5z0fYxcrQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/lexendtera/v27/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiM1TMTc5z0fYxcrQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/lexendtera/v27/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiMOTQTc5z0fYxcrQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/lexendtera/v27/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiMADQTc5z0fYxcrQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/lexendtera/v27/RrQDbo98_jt_IXnBPwCWtYJLZ3P4hnaGKFiMZzQTc5z0fYxcrQ.woff2',
    },
    installName: 'lexend_tera',
  },
  {
    label: 'Lexend Zetta',
    value: 'Lexend Zetta',
    preview:
      'https://fonts.gstatic.com/s/lexendzetta/v28/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCy9bG4z9pbw.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/lexendzetta/v28/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCy9bG0ztjbs8qbts.woff2',
      '500':
        'https://fonts.gstatic.com/s/lexendzetta/v28/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCy-TG0ztjbs8qbts.woff2',
      '600':
        'https://fonts.gstatic.com/s/lexendzetta/v28/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCywjB0ztjbs8qbts.woff2',
      '700':
        'https://fonts.gstatic.com/s/lexendzetta/v28/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCyzHB0ztjbs8qbts.woff2',
      '800':
        'https://fonts.gstatic.com/s/lexendzetta/v28/ll8uK2KYXje7CdOFnEWcU8synQbuVYjYB3BCy1bB0ztjbs8qbts.woff2',
    },
    installName: 'lexend_zetta',
  },
  {
    label: 'Libre Franklin',
    value: 'Libre Franklin',
    preview:
      'https://fonts.gstatic.com/s/librefranklin/v13/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhLsWkBtDJ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/librefranklin/v13/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhLsWUAtrIb-JH1g.woff2',
      '500':
        'https://fonts.gstatic.com/s/librefranklin/v13/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhHMWUAtrIb-JH1g.woff2',
      '600':
        'https://fonts.gstatic.com/s/librefranklin/v13/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduh8MKUAtrIb-JH1g.woff2',
      '700':
        'https://fonts.gstatic.com/s/librefranklin/v13/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhycKUAtrIb-JH1g.woff2',
      '800':
        'https://fonts.gstatic.com/s/librefranklin/v13/jizOREVItHgc8qDIbSTKq4XkRg8T88bjFuXOnduhrsKUAtrIb-JH1g.woff2',
    },
    installName: 'libre_franklin',
  },
  {
    label: 'Lisu Bosa',
    value: 'Lisu Bosa',
    preview:
      'https://fonts.gstatic.com/s/lisubosa/v2/3XFoErkv240fsdmJRJQflkHj.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/lisubosa/v2/3XFoErkv240fsdmJRJQvkkviTf3E3Q.woff2',
      '500':
        'https://fonts.gstatic.com/s/lisubosa/v2/3XFtErkv240fsdmJRJQXY2LGQNbY1P1Sbg.woff2',
      '600':
        'https://fonts.gstatic.com/s/lisubosa/v2/3XFtErkv240fsdmJRJQXT2XGQNbY1P1Sbg.woff2',
      '700':
        'https://fonts.gstatic.com/s/lisubosa/v2/3XFtErkv240fsdmJRJQXK2TGQNbY1P1Sbg.woff2',
      '800':
        'https://fonts.gstatic.com/s/lisubosa/v2/3XFtErkv240fsdmJRJQXN2fGQNbY1P1Sbg.woff2',
    },
    installName: 'lisu_bosa',
  },
  {
    label: 'Literata',
    value: 'Literata',
    preview:
      'https://fonts.gstatic.com/s/literata/v35/or3PQ6P12-iJxAIgLa78DkrbXsDgk0oVDaDPYLanFLHpPf2TbBG_J_fWTA.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/literata/v35/or3PQ6P12-iJxAIgLa78DkrbXsDgk0oVDaDPYLanFLHpPf2TbBG_F_PcTWCWp8g.woff2',
      '500':
        'https://fonts.gstatic.com/s/literata/v35/or3PQ6P12-iJxAIgLa78DkrbXsDgk0oVDaDPYLanFLHpPf2TbCO_F_PcTWCWp8g.woff2',
      '600':
        'https://fonts.gstatic.com/s/literata/v35/or3PQ6P12-iJxAIgLa78DkrbXsDgk0oVDaDPYLanFLHpPf2TbM-4F_PcTWCWp8g.woff2',
      '700':
        'https://fonts.gstatic.com/s/literata/v35/or3PQ6P12-iJxAIgLa78DkrbXsDgk0oVDaDPYLanFLHpPf2TbPa4F_PcTWCWp8g.woff2',
      '800':
        'https://fonts.gstatic.com/s/literata/v35/or3PQ6P12-iJxAIgLa78DkrbXsDgk0oVDaDPYLanFLHpPf2TbJG4F_PcTWCWp8g.woff2',
    },
    installName: 'literata',
  },
  {
    label: 'M PLUS 1',
    value: 'M PLUS 1',
    preview:
      'https://fonts.gstatic.com/s/mplus1/v6/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW5VSaL83xd.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/mplus1/v6/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW5VSa793ZcsGGycA.woff2',
      '500':
        'https://fonts.gstatic.com/s/mplus1/v6/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW5Zya793ZcsGGycA.woff2',
      '600':
        'https://fonts.gstatic.com/s/mplus1/v6/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW5iyG793ZcsGGycA.woff2',
      '700':
        'https://fonts.gstatic.com/s/mplus1/v6/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW5siG793ZcsGGycA.woff2',
      '800':
        'https://fonts.gstatic.com/s/mplus1/v6/R70EjygA28ymD4HgBUGzkN5Eyoj-WpW51SG793ZcsGGycA.woff2',
    },
    installName: 'm_plus_1',
  },
  {
    label: 'M PLUS 2',
    value: 'M PLUS 2',
    preview:
      'https://fonts.gstatic.com/s/mplus2/v6/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkwOa6lx1CG.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/mplus2/v6/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkwOa6Vw1qHrzNgAw.woff2',
      '500':
        'https://fonts.gstatic.com/s/mplus2/v6/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkwC66Vw1qHrzNgAw.woff2',
      '600':
        'https://fonts.gstatic.com/s/mplus2/v6/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkw56mVw1qHrzNgAw.woff2',
      '700':
        'https://fonts.gstatic.com/s/mplus2/v6/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkw3qmVw1qHrzNgAw.woff2',
      '800':
        'https://fonts.gstatic.com/s/mplus2/v6/7Auhp_Eq3gO_OGbGGhjdwrDdpeIBxlkwuamVw1qHrzNgAw.woff2',
    },
    installName: 'm_plus_2',
  },
  {
    label: 'Mada',
    value: 'Mada',
    preview:
      'https://fonts.gstatic.com/s/mada/v19/7Aulp_0qnzeSVz7u3PJLcUMYOFnOkEkx0eg.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/mada/v19/7Aulp_0qnzeSVz7u3PJLcUMYOFnOkHk12-m9x2iC.woff2',
      '500':
        'https://fonts.gstatic.com/s/mada/v19/7Aulp_0qnzeSVz7u3PJLcUMYOFn8kHk12-m9x2iC.woff2',
      '600':
        'https://fonts.gstatic.com/s/mada/v19/7Aulp_0qnzeSVz7u3PJLcUMYOFkQl3k12-m9x2iC.woff2',
      '700':
        'https://fonts.gstatic.com/s/mada/v19/7Aulp_0qnzeSVz7u3PJLcUMYOFkpl3k12-m9x2iC.woff2',
      '800':
        'https://fonts.gstatic.com/s/mada/v19/7Aulp_0qnzeSVz7u3PJLcUMYOFlOl3k12-m9x2iC.woff2',
    },
    installName: 'mada',
  },
  {
    label: 'Manrope',
    value: 'Manrope',
    preview:
      'https://fonts.gstatic.com/s/manrope/v14/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk79FN_E-bk.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/manrope/v14/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk79FO_A87jxeN7B.woff2',
      '500':
        'https://fonts.gstatic.com/s/manrope/v14/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk7PFO_A87jxeN7B.woff2',
      '600':
        'https://fonts.gstatic.com/s/manrope/v14/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk4jE-_A87jxeN7B.woff2',
      '700':
        'https://fonts.gstatic.com/s/manrope/v14/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk4aE-_A87jxeN7B.woff2',
      '800':
        'https://fonts.gstatic.com/s/manrope/v14/xn7_YHE41ni1AdIRqAuZuw1Bx9mbZk59E-_A87jxeN7B.woff2',
    },
    installName: 'manrope',
  },
  {
    label: 'Manuale',
    value: 'Manuale',
    preview:
      'https://fonts.gstatic.com/s/manuale/v28/f0Xp0eas_8Z-TFZdHv3mMxFaSqASeeHke4wC3zE.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/manuale/v28/f0Xp0eas_8Z-TFZdHv3mMxFaSqASeeHke7wG1TB_JHHY.woff2',
      '500':
        'https://fonts.gstatic.com/s/manuale/v28/f0Xp0eas_8Z-TFZdHv3mMxFaSqASeeHWe7wG1TB_JHHY.woff2',
      '600':
        'https://fonts.gstatic.com/s/manuale/v28/f0Xp0eas_8Z-TFZdHv3mMxFaSqASeeE6fLwG1TB_JHHY.woff2',
      '700':
        'https://fonts.gstatic.com/s/manuale/v28/f0Xp0eas_8Z-TFZdHv3mMxFaSqASeeEDfLwG1TB_JHHY.woff2',
      '800':
        'https://fonts.gstatic.com/s/manuale/v28/f0Xp0eas_8Z-TFZdHv3mMxFaSqASeeFkfLwG1TB_JHHY.woff2',
    },
    installName: 'manuale',
  },
  {
    label: 'Martian Mono',
    value: 'Martian Mono',
    preview:
      'https://fonts.gstatic.com/s/martianmono/v3/2V08KIcADoYhV6w87xrTKjs4CYElh_VS9YA4TlTnQzaVMIE6j15dYY1qu_6XBb8.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/martianmono/v3/2V08KIcADoYhV6w87xrTKjs4CYElh_VS9YA4TlTnQzaVMIE6j15dYY1qu86TD75kdpF2.woff2',
      '500':
        'https://fonts.gstatic.com/s/martianmono/v3/2V08KIcADoYhV6w87xrTKjs4CYElh_VS9YA4TlTnQzaVMIE6j15dYY1Yu86TD75kdpF2.woff2',
      '600':
        'https://fonts.gstatic.com/s/martianmono/v3/2V08KIcADoYhV6w87xrTKjs4CYElh_VS9YA4TlTnQzaVMIE6j15dYY20vM6TD75kdpF2.woff2',
      '700':
        'https://fonts.gstatic.com/s/martianmono/v3/2V08KIcADoYhV6w87xrTKjs4CYElh_VS9YA4TlTnQzaVMIE6j15dYY2NvM6TD75kdpF2.woff2',
      '800':
        'https://fonts.gstatic.com/s/martianmono/v3/2V08KIcADoYhV6w87xrTKjs4CYElh_VS9YA4TlTnQzaVMIE6j15dYY3qvM6TD75kdpF2.woff2',
    },
    installName: 'martian_mono',
  },
  {
    label: 'Maven Pro',
    value: 'Maven Pro',
    preview:
      'https://fonts.gstatic.com/s/mavenpro/v32/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8SX21nGjog.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/mavenpro/v32/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8SX25nWpozp5GvU.woff2',
      '500':
        'https://fonts.gstatic.com/s/mavenpro/v32/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8Rf25nWpozp5GvU.woff2',
      '600':
        'https://fonts.gstatic.com/s/mavenpro/v32/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8fvx5nWpozp5GvU.woff2',
      '700':
        'https://fonts.gstatic.com/s/mavenpro/v32/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8cLx5nWpozp5GvU.woff2',
      '800':
        'https://fonts.gstatic.com/s/mavenpro/v32/7Auup_AqnyWWAxW2Wk3swUz56MS91Eww8aXx5nWpozp5GvU.woff2',
    },
    installName: 'maven_pro',
  },
  {
    label: 'Merienda',
    value: 'Merienda',
    preview:
      'https://fonts.gstatic.com/s/merienda/v19/gNMaW3x8Qoy5_mf8uUkJGHtiYXjmKFy5enhYSET9.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/merienda/v19/gNMaW3x8Qoy5_mf8uUkJGHtiYXjmKFy5enhoTE78QGBV0A.woff2',
      '500':
        'https://fonts.gstatic.com/s/merienda/v19/gNMaW3x8Qoy5_mf8uUkJGHtiYXjmKFy5SHhoTE78QGBV0A.woff2',
      '600':
        'https://fonts.gstatic.com/s/merienda/v19/gNMaW3x8Qoy5_mf8uUkJGHtiYXjmKFy5pH9oTE78QGBV0A.woff2',
      '700':
        'https://fonts.gstatic.com/s/merienda/v19/gNMaW3x8Qoy5_mf8uUkJGHtiYXjmKFy5nX9oTE78QGBV0A.woff2',
      '800':
        'https://fonts.gstatic.com/s/merienda/v19/gNMaW3x8Qoy5_mf8uUkJGHtiYXjmKFy5-n9oTE78QGBV0A.woff2',
    },
    installName: 'merienda',
  },
  {
    label: 'Merriweather Sans',
    value: 'Merriweather Sans',
    preview:
      'https://fonts.gstatic.com/s/merriweathersans/v26/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZou4Vj-sH.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/merriweathersans/v26/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZou4li-EG7xFHnQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/merriweathersans/v26/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZkO4li-EG7xFHnQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/merriweathersans/v26/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZfOkli-EG7xFHnQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/merriweathersans/v26/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZRekli-EG7xFHnQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/merriweathersans/v26/2-cO9IRs1JiJN1FRAMjTN5zd9vgsFF_5asQTb6hZ2JKZIukli-EG7xFHnQ.woff2',
    },
    installName: 'merriweather_sans',
  },
  {
    label: 'Montserrat',
    value: 'Montserrat',
    preview:
      'https://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCtr6Hw_aXo.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCtr6Ew7Y3tcoqK5.woff2',
      '500':
        'https://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCtZ6Ew7Y3tcoqK5.woff2',
      '600':
        'https://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCu170w7Y3tcoqK5.woff2',
      '700':
        'https://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCuM70w7Y3tcoqK5.woff2',
      '800':
        'https://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCvr70w7Y3tcoqK5.woff2',
    },
    installName: 'montserrat',
  },
  {
    label: 'Montserrat Alternates',
    value: 'Montserrat Alternates',
    preview:
      'https://fonts.gstatic.com/s/montserratalternates/v17/mFTvWacfw6zH4dthXcyms1lPpC8I_b0juU057afQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/montserratalternates/v17/mFTvWacfw6zH4dthXcyms1lPpC8I_b0juU0J6a3RCJ1b0w.woff2',
      '500':
        'https://fonts.gstatic.com/s/montserratalternates/v17/mFTiWacfw6zH4dthXcyms1lPpC8I_b0juU0xGIT1BbZH2mBhkw.woff2',
      '600':
        'https://fonts.gstatic.com/s/montserratalternates/v17/mFTiWacfw6zH4dthXcyms1lPpC8I_b0juU0xNIP1BbZH2mBhkw.woff2',
      '700':
        'https://fonts.gstatic.com/s/montserratalternates/v17/mFTiWacfw6zH4dthXcyms1lPpC8I_b0juU0xUIL1BbZH2mBhkw.woff2',
      '800':
        'https://fonts.gstatic.com/s/montserratalternates/v17/mFTiWacfw6zH4dthXcyms1lPpC8I_b0juU0xTIH1BbZH2mBhkw.woff2',
    },
    installName: 'montserrat_alternates',
  },
  {
    label: 'Mukta',
    value: 'Mukta',
    preview: 'https://fonts.gstatic.com/s/mukta/v14/iJWKBXyXfDDVXbnHrXw.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/mukta/v14/iJWKBXyXfDDVXYnDp32S0H3f.woff2',
      '500':
        'https://fonts.gstatic.com/s/mukta/v14/iJWHBXyXfDDVXbEyjlmf-2HW7ZB_.woff2',
      '600':
        'https://fonts.gstatic.com/s/mukta/v14/iJWHBXyXfDDVXbEeiVmf-2HW7ZB_.woff2',
      '700':
        'https://fonts.gstatic.com/s/mukta/v14/iJWHBXyXfDDVXbF6iFmf-2HW7ZB_.woff2',
      '800':
        'https://fonts.gstatic.com/s/mukta/v14/iJWHBXyXfDDVXbFmi1mf-2HW7ZB_.woff2',
    },
    installName: 'mukta',
  },
  {
    label: 'Mukta Mahee',
    value: 'Mukta Mahee',
    preview:
      'https://fonts.gstatic.com/s/muktamahee/v16/XRXQ3IOIi0hcP8iVU67hA9vMUT8.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/muktamahee/v16/XRXQ3IOIi0hcP8iVU67hA-vIWz4PDWtj.woff2',
      '500':
        'https://fonts.gstatic.com/s/muktamahee/v16/XRXN3IOIi0hcP8iVU67hA9M5choCJndqZCsW.woff2',
      '600':
        'https://fonts.gstatic.com/s/muktamahee/v16/XRXN3IOIi0hcP8iVU67hA9MVdRoCJndqZCsW.woff2',
      '700':
        'https://fonts.gstatic.com/s/muktamahee/v16/XRXN3IOIi0hcP8iVU67hA9NxdBoCJndqZCsW.woff2',
      '800':
        'https://fonts.gstatic.com/s/muktamahee/v16/XRXN3IOIi0hcP8iVU67hA9NtdxoCJndqZCsW.woff2',
    },
    installName: 'mukta_mahee',
  },
  {
    label: 'Mukta Malar',
    value: 'Mukta Malar',
    preview:
      'https://fonts.gstatic.com/s/muktamalar/v12/MCoXzAXyz8LOE2FpJMxZqIv5J_U.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/muktamalar/v12/MCoXzAXyz8LOE2FpJMxZqLv9LfQJwHbn.woff2',
      '500':
        'https://fonts.gstatic.com/s/muktamalar/v12/MCoKzAXyz8LOE2FpJMxZqIMMBNAE62ruoAZW.woff2',
      '600':
        'https://fonts.gstatic.com/s/muktamalar/v12/MCoKzAXyz8LOE2FpJMxZqIMgA9AE62ruoAZW.woff2',
      '700':
        'https://fonts.gstatic.com/s/muktamalar/v12/MCoKzAXyz8LOE2FpJMxZqINEAtAE62ruoAZW.woff2',
      '800':
        'https://fonts.gstatic.com/s/muktamalar/v12/MCoKzAXyz8LOE2FpJMxZqINYAdAE62ruoAZW.woff2',
    },
    installName: 'mukta_malar',
  },
  {
    label: 'Mukta Vaani',
    value: 'Mukta Vaani',
    preview:
      'https://fonts.gstatic.com/s/muktavaani/v13/3Jn5SD_-ynaxmxnEfVHPIG0EduU.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/muktavaani/v13/3Jn5SD_-ynaxmxnEfVHPIF0AfORL0fNy.woff2',
      '500':
        'https://fonts.gstatic.com/s/muktavaani/v13/3JnkSD_-ynaxmxnEfVHPIGXxVcBG-u97MW1a.woff2',
      '600':
        'https://fonts.gstatic.com/s/muktavaani/v13/3JnkSD_-ynaxmxnEfVHPIGXdUsBG-u97MW1a.woff2',
      '700':
        'https://fonts.gstatic.com/s/muktavaani/v13/3JnkSD_-ynaxmxnEfVHPIGW5U8BG-u97MW1a.woff2',
      '800':
        'https://fonts.gstatic.com/s/muktavaani/v13/3JnkSD_-ynaxmxnEfVHPIGWlUMBG-u97MW1a.woff2',
    },
    installName: 'mukta_vaani',
  },
  {
    label: 'Mulish',
    value: 'Mulish',
    preview:
      'https://fonts.gstatic.com/s/mulish/v12/1Ptyg83HX_SGhgqO0yLcmjzUAuWexZNR8aGvGw.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/mulish/v12/1Ptyg83HX_SGhgqO0yLcmjzUAuWexZNRwaWlGrw-PTY.woff2',
      '500':
        'https://fonts.gstatic.com/s/mulish/v12/1Ptyg83HX_SGhgqO0yLcmjzUAuWexaFRwaWlGrw-PTY.woff2',
      '600':
        'https://fonts.gstatic.com/s/mulish/v12/1Ptyg83HX_SGhgqO0yLcmjzUAuWexU1WwaWlGrw-PTY.woff2',
      '700':
        'https://fonts.gstatic.com/s/mulish/v12/1Ptyg83HX_SGhgqO0yLcmjzUAuWexXRWwaWlGrw-PTY.woff2',
      '800':
        'https://fonts.gstatic.com/s/mulish/v12/1Ptyg83HX_SGhgqO0yLcmjzUAuWexRNWwaWlGrw-PTY.woff2',
    },
    installName: 'mulish',
  },
  {
    label: 'Murecho',
    value: 'Murecho',
    preview:
      'https://fonts.gstatic.com/s/murecho/v11/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMpr5UWYJis.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/murecho/v11/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMpr5XWcLCpUOaM6.woff2',
      '500':
        'https://fonts.gstatic.com/s/murecho/v11/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMpZ5XWcLCpUOaM6.woff2',
      '600':
        'https://fonts.gstatic.com/s/murecho/v11/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMq14nWcLCpUOaM6.woff2',
      '700':
        'https://fonts.gstatic.com/s/murecho/v11/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMqM4nWcLCpUOaM6.woff2',
      '800':
        'https://fonts.gstatic.com/s/murecho/v11/q5uYsoq3NOBn_I-ggCJg98TBOoNFCMrr4nWcLCpUOaM6.woff2',
    },
    installName: 'murecho',
  },
  {
    label: 'MuseoModerno',
    value: 'MuseoModerno',
    preview:
      'https://fonts.gstatic.com/s/museomoderno/v27/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMlZEie0QjA.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/museomoderno/v27/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMlZEuekajeKlCdo.woff2',
      '500':
        'https://fonts.gstatic.com/s/museomoderno/v27/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMmREuekajeKlCdo.woff2',
      '600':
        'https://fonts.gstatic.com/s/museomoderno/v27/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMohDuekajeKlCdo.woff2',
      '700':
        'https://fonts.gstatic.com/s/museomoderno/v27/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMrFDuekajeKlCdo.woff2',
      '800':
        'https://fonts.gstatic.com/s/museomoderno/v27/zrf30HnU0_7wWdMrFcWqSEXPVyEaWJ55pTleMtZDuekajeKlCdo.woff2',
    },
    installName: 'museomoderno',
  },
  {
    label: 'Newsreader',
    value: 'Newsreader',
    preview:
      'https://fonts.gstatic.com/s/newsreader/v19/cY9qfjOCX1hbuyalUrK49dLac06G1ZGsZBtoBCzBDXXD9JVF438weI_wDeZF.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/newsreader/v19/cY9qfjOCX1hbuyalUrK49dLac06G1ZGsZBtoBCzBDXXD9JVF438weI_ACexEPjCggA.woff2',
      '500':
        'https://fonts.gstatic.com/s/newsreader/v19/cY9qfjOCX1hbuyalUrK49dLac06G1ZGsZBtoBCzBDXXD9JVF438wSo_ACexEPjCggA.woff2',
      '600':
        'https://fonts.gstatic.com/s/newsreader/v19/cY9qfjOCX1hbuyalUrK49dLac06G1ZGsZBtoBCzBDXXD9JVF438wpojACexEPjCggA.woff2',
      '700':
        'https://fonts.gstatic.com/s/newsreader/v19/cY9qfjOCX1hbuyalUrK49dLac06G1ZGsZBtoBCzBDXXD9JVF438wn4jACexEPjCggA.woff2',
      '800':
        'https://fonts.gstatic.com/s/newsreader/v19/cY9qfjOCX1hbuyalUrK49dLac06G1ZGsZBtoBCzBDXXD9JVF438w-IjACexEPjCggA.woff2',
    },
    installName: 'newsreader',
  },
  {
    label: 'Noto Rashi Hebrew',
    value: 'Noto Rashi Hebrew',
    preview:
      'https://fonts.gstatic.com/s/notorashihebrew/v25/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZB-HURiC7.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notorashihebrew/v25/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZB-HkQiq6Nf2pfA.woff2',
      '500':
        'https://fonts.gstatic.com/s/notorashihebrew/v25/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZNeHkQiq6Nf2pfA.woff2',
      '600':
        'https://fonts.gstatic.com/s/notorashihebrew/v25/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZ2ebkQiq6Nf2pfA.woff2',
      '700':
        'https://fonts.gstatic.com/s/notorashihebrew/v25/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZ4ObkQiq6Nf2pfA.woff2',
      '800':
        'https://fonts.gstatic.com/s/notorashihebrew/v25/EJR_Qh82XsIK-QFmqXk4zvLwFVya0vFL-HlKM5e6C6HZh-bkQiq6Nf2pfA.woff2',
    },
    installName: 'noto_rashi_hebrew',
  },
  {
    label: 'Noto Sans',
    value: 'Noto Sans',
    preview:
      'https://fonts.gstatic.com/s/notosans/v30/o-0IIpQlx3QUlC5A4PNr4zRA.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosans/v30/o-0IIpQlx3QUlC5A4PNb5z5Ba_2c7A.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosans/v30/o-0NIpQlx3QUlC5A4PNjFhdlZtaA5Wl6PQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosans/v30/o-0NIpQlx3QUlC5A4PNjOhBlZtaA5Wl6PQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosans/v30/o-0NIpQlx3QUlC5A4PNjXhFlZtaA5Wl6PQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosans/v30/o-0NIpQlx3QUlC5A4PNjQhJlZtaA5Wl6PQ.woff2',
    },
    installName: 'noto_sans',
  },
  {
    label: 'Noto Sans Armenian',
    value: 'Noto Sans Armenian',
    preview:
      'https://fonts.gstatic.com/s/notosansarmenian/v42/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLorxb50jaS8.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosansarmenian/v42/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLorxb60nYy6zF3Eg.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansarmenian/v42/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLorDb60nYy6zF3Eg.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansarmenian/v42/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLoovaK0nYy6zF3Eg.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansarmenian/v42/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLooWaK0nYy6zF3Eg.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansarmenian/v42/ZgN0jOZKPa7CHqq0h37c7ReDUubm2SEdFXp7ig73qtTY5idb74R9UdM3y2nZLopxaK0nYy6zF3Eg.woff2',
    },
    installName: 'noto_sans_armenian',
  },
  {
    label: 'Noto Sans Bengali',
    value: 'Noto Sans Bengali',
    preview:
      'https://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6KmsolLidGu8w.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6KmsolLudWk8izI0lc.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6KmsrtLudWk8izI0lc.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6KmsldMudWk8izI0lc.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6Kmsm5MudWk8izI0lc.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansbengali/v20/Cn-SJsCGWQxOjaGwMQ6fIiMywrNJIky6nvd8BjzVMvJx2mcSPVFpVEqE-6KmsglMudWk8izI0lc.woff2',
    },
    installName: 'noto_sans_bengali',
  },
  {
    label: 'Noto Sans Canadian Aboriginal',
    value: 'Noto Sans Canadian Aboriginal',
    preview:
      'https://fonts.gstatic.com/s/notosanscanadianaboriginal/v21/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzigWLnPyQEh.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosanscanadianaboriginal/v21/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzigWLn_zQsg0q0uhQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanscanadianaboriginal/v21/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzigarn_zQsg0q0uhQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanscanadianaboriginal/v21/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzighr7_zQsg0q0uhQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanscanadianaboriginal/v21/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzigv77_zQsg0q0uhQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanscanadianaboriginal/v21/4C_TLjTuEqPj-8J01CwaGkiZ9os0iGVkezM1mUT-j_Lmlzda6uH_nnX1bzig2L7_zQsg0q0uhQ.woff2',
    },
    installName: 'noto_sans_canadian_aboriginal',
  },
  {
    label: 'Noto Sans Cham',
    value: 'Noto Sans Cham',
    preview:
      'https://fonts.gstatic.com/s/notosanscham/v27/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfcERwsvruz.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosanscham/v27/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfcERwcurGykboaLg.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanscham/v27/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfcIxwcurGykboaLg.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanscham/v27/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfczxscurGykboaLg.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanscham/v27/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfc9hscurGykboaLg.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanscham/v27/pe06MIySN5pO62Z5YkFyQb_bbuRhe6D4yip43qfckRscurGykboaLg.woff2',
    },
    installName: 'noto_sans_cham',
  },
  {
    label: 'Noto Sans Cherokee',
    value: 'Noto Sans Cherokee',
    preview:
      'https://fonts.gstatic.com/s/notosanscherokee/v19/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWi5PPkizrQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosanscherokee/v19/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWi5PDky5rAffjl0.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanscherokee/v19/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWhxPDky5rAffjl0.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanscherokee/v19/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWvBIDky5rAffjl0.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanscherokee/v19/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWslIDky5rAffjl0.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanscherokee/v19/KFOPCm6Yu8uF-29fiz9vQF9YWK6Z8O10cHNA0cSkZCHYWq5IDky5rAffjl0.woff2',
    },
    installName: 'noto_sans_cherokee',
  },
  {
    label: 'Noto Sans Devanagari',
    value: 'Noto Sans Devanagari',
    preview:
      'https://fonts.gstatic.com/s/notosansdevanagari/v25/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08AlXQl--E5oQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosansdevanagari/v25/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08AlXQly-UzoFoW4Ow.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansdevanagari/v25/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08AlUYly-UzoFoW4Ow.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansdevanagari/v25/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08Alaoiy-UzoFoW4Ow.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansdevanagari/v25/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08AlZMiy-UzoFoW4Ow.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansdevanagari/v25/TuGoUUFzXI5FBtUq5a8bjKYTZjtRU6Sgv3NaV_SNmI0b8QQCQmHn6B2OHjbL_08AlfQiy-UzoFoW4Ow.woff2',
    },
    installName: 'noto_sans_devanagari',
  },
  {
    label: 'Noto Sans Display',
    value: 'Noto Sans Display',
    preview:
      'https://fonts.gstatic.com/s/notosansdisplay/v25/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp_3cKZTCa2w.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosansdisplay/v25/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp_3cKVTSQ2iHrvWM.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansdisplay/v25/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp_0UKVTSQ2iHrvWM.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansdisplay/v25/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp_6kNVTSQ2iHrvWM.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansdisplay/v25/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp_5ANVTSQ2iHrvWM.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansdisplay/v25/RLpbK4fy6r6tOBEJg0IAKzqdFZVZxpMkXJMhnB9XjO1o90LuV-PT4Doq_AKp__cNVTSQ2iHrvWM.woff2',
    },
    installName: 'noto_sans_display',
  },
  {
    label: 'Noto Sans Ethiopic',
    value: 'Noto Sans Ethiopic',
    preview:
      'https://fonts.gstatic.com/s/notosansethiopic/v46/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T35OK5DiyGY.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosansethiopic/v46/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T35OK6DmwmfeaY9u.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansethiopic/v46/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T358K6DmwmfeaY9u.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansethiopic/v46/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T36QLKDmwmfeaY9u.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansethiopic/v46/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T36pLKDmwmfeaY9u.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansethiopic/v46/7cHPv50vjIepfJVOZZgcpQ5B9FBTH9KGNfhSTgtoow1KVnIvyBoMSzUMacb-T37OLKDmwmfeaY9u.woff2',
    },
    installName: 'noto_sans_ethiopic',
  },
  {
    label: 'Noto Sans Georgian',
    value: 'Noto Sans Georgian',
    preview:
      'https://fonts.gstatic.com/s/notosansgeorgian/v42/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdpvnzGj_dZQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosansgeorgian/v42/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdpvnzFj7f5WK0OQV.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansgeorgian/v42/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdpvVzFj7f5WK0OQV.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansgeorgian/v42/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdps5y1j7f5WK0OQV.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansgeorgian/v42/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdpsAy1j7f5WK0OQV.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansgeorgian/v42/PlIaFke5O6RzLfvNNVSitxkr76PRHBC4Ytyq-Gof7PUs4S7zWn-8YDB09HFNdptny1j7f5WK0OQV.woff2',
    },
    installName: 'noto_sans_georgian',
  },
  {
    label: 'Noto Sans Gujarati',
    value: 'Noto Sans Gujarati',
    preview:
      'https://fonts.gstatic.com/s/notosansgujarati/v23/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_ypFzPN9uY.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosansgujarati/v23/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_ypFwPJ_OdiEH0s.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansgujarati/v23/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_ybFwPJ_OdiEH0s.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansgujarati/v23/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_x3EAPJ_OdiEH0s.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansgujarati/v23/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_xOEAPJ_OdiEH0s.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansgujarati/v23/wlpWgx_HC1ti5ViekvcxnhMlCVo3f5pv17ivlzsUB14gg1TMR2Gw4VceEl7MA_wpEAPJ_OdiEH0s.woff2',
    },
    installName: 'noto_sans_gujarati',
  },
  {
    label: 'Noto Sans Gurmukhi',
    value: 'Noto Sans Gurmukhi',
    preview:
      'https://fonts.gstatic.com/s/notosansgurmukhi/v26/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG1Oekbwbfo.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosansgurmukhi/v26/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG1Oenb0Z_trdp7h.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansgurmukhi/v26/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG18enb0Z_trdp7h.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansgurmukhi/v26/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG2QfXb0Z_trdp7h.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansgurmukhi/v26/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG2pfXb0Z_trdp7h.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansgurmukhi/v26/w8g9H3EvQP81sInb43inmyN9zZ7hb7ATbSWo4q8dJ74a3cVrYFQ_bogT0-gPeG3OfXb0Z_trdp7h.woff2',
    },
    installName: 'noto_sans_gurmukhi',
  },
  {
    label: 'Noto Sans Hebrew',
    value: 'Noto Sans Hebrew',
    preview:
      'https://fonts.gstatic.com/s/notosanshebrew/v43/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiXd4qdoyhk.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosanshebrew/v43/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiXd4qtpyJltutR2g.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanshebrew/v43/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiXRYqtpyJltutR2g.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanshebrew/v43/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiXqY2tpyJltutR2g.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanshebrew/v43/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiXkI2tpyJltutR2g.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanshebrew/v43/or3HQ7v33eiDljA1IufXTtVf7V6RvEEdhQlk0LlGxCyaeNKYZC0sqk3xXGiX942tpyJltutR2g.woff2',
    },
    installName: 'noto_sans_hebrew',
  },
  {
    label: 'Noto Sans HK',
    value: 'Noto Sans HK',
    preview:
      'https://fonts.gstatic.com/s/notosanshk/v31/nKKF-GM_FYFRJvXzVXaAPe97P1KHynJFP716qHB-yoSZiA.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosanshk/v31/nKKF-GM_FYFRJvXzVXaAPe97P1KHynJFP716qHB--oCTiYjNvVA.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanshk/v31/nKKF-GM_FYFRJvXzVXaAPe97P1KHynJFP716qEJ--oCTiYjNvVA.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanshk/v31/nKKF-GM_FYFRJvXzVXaAPe97P1KHynJFP716qK55-oCTiYjNvVA.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanshk/v31/nKKF-GM_FYFRJvXzVXaAPe97P1KHynJFP716qJd5-oCTiYjNvVA.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanshk/v31/nKKF-GM_FYFRJvXzVXaAPe97P1KHynJFP716qPB5-oCTiYjNvVA.woff2',
    },
    installName: 'noto_sans_hk',
  },
  {
    label: 'Noto Sans JP',
    value: 'Noto Sans JP',
    preview:
      'https://fonts.gstatic.com/s/notosansjp/v52/-F6jfjtqLzI2JPCgQBnw7HFyzSD-AsregP8VFBEj35rS0w.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosansjp/v52/-F6jfjtqLzI2JPCgQBnw7HFyzSD-AsregP8VFBEj757Y0rw-oME.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansjp/v52/-F6jfjtqLzI2JPCgQBnw7HFyzSD-AsregP8VFCMj757Y0rw-oME.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansjp/v52/-F6jfjtqLzI2JPCgQBnw7HFyzSD-AsregP8VFM8k757Y0rw-oME.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansjp/v52/-F6jfjtqLzI2JPCgQBnw7HFyzSD-AsregP8VFPYk757Y0rw-oME.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansjp/v52/-F6jfjtqLzI2JPCgQBnw7HFyzSD-AsregP8VFJEk757Y0rw-oME.woff2',
    },
    installName: 'noto_sans_jp',
  },
  {
    label: 'Noto Sans Kannada',
    value: 'Noto Sans Kannada',
    preview:
      'https://fonts.gstatic.com/s/notosanskannada/v26/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrDvN_SMGLw.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosanskannada/v26/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrDvNzScMLsPKrkY.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanskannada/v26/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrAnNzScMLsPKrkY.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanskannada/v26/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrOXKzScMLsPKrkY.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanskannada/v26/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrNzKzScMLsPKrkY.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanskannada/v26/8vIs7xs32H97qzQKnzfeXycxXZyUmySvZWItmf1fe6TVmgop9ndpS-BqHEyGrLvKzScMLsPKrkY.woff2',
    },
    installName: 'noto_sans_kannada',
  },
  {
    label: 'Noto Sans Khmer',
    value: 'Noto Sans Khmer',
    preview:
      'https://fonts.gstatic.com/s/notosanskhmer/v23/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYuNAKz5mgc.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosanskhmer/v23/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYuNAJz9kAbrddiA.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanskhmer/v23/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYu_AJz9kAbrddiA.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanskhmer/v23/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYtTB5z9kAbrddiA.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanskhmer/v23/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYtqB5z9kAbrddiA.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanskhmer/v23/ijw3s5roRME5LLRxjsRb-gssOenAyendxrgV2c-Zw-9vbVUti_Z_dWgtWYsNB5z9kAbrddiA.woff2',
    },
    installName: 'noto_sans_khmer',
  },
  {
    label: 'Noto Sans KR',
    value: 'Noto Sans KR',
    preview:
      'https://fonts.gstatic.com/s/notosanskr/v36/PbyxFmXiEBPT4ITbgNA5Cgms3VYcOA-vvnIzzuoySLXg8Q.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosanskr/v36/PbyxFmXiEBPT4ITbgNA5Cgms3VYcOA-vvnIzzuoyeLHq8H4hfeE.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanskr/v36/PbyxFmXiEBPT4ITbgNA5Cgms3VYcOA-vvnIzztgyeLHq8H4hfeE.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanskr/v36/PbyxFmXiEBPT4ITbgNA5Cgms3VYcOA-vvnIzzjQ1eLHq8H4hfeE.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanskr/v36/PbyxFmXiEBPT4ITbgNA5Cgms3VYcOA-vvnIzzg01eLHq8H4hfeE.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanskr/v36/PbyxFmXiEBPT4ITbgNA5Cgms3VYcOA-vvnIzzmo1eLHq8H4hfeE.woff2',
    },
    installName: 'noto_sans_kr',
  },
  {
    label: 'Noto Sans Lao',
    value: 'Noto Sans Lao',
    preview:
      'https://fonts.gstatic.com/s/notosanslao/v24/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt4ccbtfpkL.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosanslao/v24/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt4ccbdepMK3riB2w.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanslao/v24/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt4Q8bdepMK3riB2w.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanslao/v24/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt4r8HdepMK3riB2w.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanslao/v24/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt4lsHdepMK3riB2w.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanslao/v24/bx6lNx2Ol_ixgdYWLm9BwxM3NW6BOkuf763Clj73CiQ_J1Djx9pidOt48cHdepMK3riB2w.woff2',
    },
    installName: 'noto_sans_lao',
  },
  {
    label: 'Noto Sans Lao Looped',
    value: 'Noto Sans Lao Looped',
    preview:
      'https://fonts.gstatic.com/s/notosanslaolooped/v5/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomPr3A-d65A.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosanslaolooped/v5/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomPr3M-Nw5V_T71k.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanslaolooped/v5/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomMj3M-Nw5V_T71k.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanslaolooped/v5/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomCTwM-Nw5V_T71k.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanslaolooped/v5/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomB3wM-Nw5V_T71k.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanslaolooped/v5/a8IgNpbwKmHXpgXbMIsbSMP7-3U72qUOX5gBg6LRXExhqHIX9YPTpvqkW4UthhjomHrwM-Nw5V_T71k.woff2',
    },
    installName: 'noto_sans_lao_looped',
  },
  {
    label: 'Noto Sans Malayalam',
    value: 'Noto Sans Malayalam',
    preview:
      'https://fonts.gstatic.com/s/notosansmalayalam/v26/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_RuDNBVbF.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosansmalayalam/v26/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_RuD9AVzEr6HxEA.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansmalayalam/v26/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_dOD9AVzEr6HxEA.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansmalayalam/v26/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_mOf9AVzEr6HxEA.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansmalayalam/v26/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_oef9AVzEr6HxEA.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansmalayalam/v26/sJoi3K5XjsSdcnzn071rL37lpAOsUThnDZIfPdbeSNzVakglNM-Qw8EaeB8Nss-_xuf9AVzEr6HxEA.woff2',
    },
    installName: 'noto_sans_malayalam',
  },
  {
    label: 'Noto Sans Meetei Mayek',
    value: 'Noto Sans Meetei Mayek',
    preview:
      'https://fonts.gstatic.com/s/notosansmeeteimayek/v14/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1TJ_sTX7vk.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosansmeeteimayek/v14/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1TJ_vTT5PgeFYVa.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansmeeteimayek/v14/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1T7_vTT5PgeFYVa.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansmeeteimayek/v14/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1QX-fTT5PgeFYVa.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansmeeteimayek/v14/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1Qu-fTT5PgeFYVa.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansmeeteimayek/v14/HTxAL3QyKieByqY9eZPFweO0be7M21uSphSdhqILnmrRfJ8t_1RJ-fTT5PgeFYVa.woff2',
    },
    installName: 'noto_sans_meetei_mayek',
  },
  {
    label: 'Noto Sans Mono',
    value: 'Noto Sans Mono',
    preview:
      'https://fonts.gstatic.com/s/notosansmono/v29/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_FNJ09vdVQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosansmono/v29/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_FNJ49_XVEQQL8Y.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansmono/v29/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_GFJ49_XVEQQL8Y.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansmono/v29/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_I1O49_XVEQQL8Y.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansmono/v29/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_LRO49_XVEQQL8Y.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansmono/v29/BngrUXNETWXI6LwhGYvaxZikqZqK6fBq6kPvUce2oAZcdthSBUsYck4-_NNO49_XVEQQL8Y.woff2',
    },
    installName: 'noto_sans_mono',
  },
  {
    label: 'Noto Sans Oriya',
    value: 'Noto Sans Oriya',
    preview:
      'https://fonts.gstatic.com/s/notosansoriya/v27/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5Ivj0f5_d4rk.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosansoriya/v27/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5Ivj0f6_Z6LhHBRe-.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansoriya/v27/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5IvjGf6_Z6LhHBRe-.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansoriya/v27/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5IvgqeK_Z6LhHBRe-.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansoriya/v27/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5IvgTeK_Z6LhHBRe-.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansoriya/v27/AYCppXfzfccDCstK_hrjDyADv5e9748vhj3CJBLHIARtgD6TJQS0dJT5Ivh0eK_Z6LhHBRe-.woff2',
    },
    installName: 'noto_sans_oriya',
  },
  {
    label: 'Noto Sans SC',
    value: 'Noto Sans SC',
    preview:
      'https://fonts.gstatic.com/s/notosanssc/v36/k3kCo84MPvpLmixcA63oeAL7Iqp5IZJF9bmaG9_FrY1HbQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosanssc/v36/k3kCo84MPvpLmixcA63oeAL7Iqp5IZJF9bmaG9_FnYlNbPzS5HE.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanssc/v36/k3kCo84MPvpLmixcA63oeAL7Iqp5IZJF9bmaG-3FnYlNbPzS5HE.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanssc/v36/k3kCo84MPvpLmixcA63oeAL7Iqp5IZJF9bmaGwHCnYlNbPzS5HE.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanssc/v36/k3kCo84MPvpLmixcA63oeAL7Iqp5IZJF9bmaGzjCnYlNbPzS5HE.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanssc/v36/k3kCo84MPvpLmixcA63oeAL7Iqp5IZJF9bmaG1_CnYlNbPzS5HE.woff2',
    },
    installName: 'noto_sans_sc',
  },
  {
    label: 'Noto Sans Sinhala',
    value: 'Noto Sans Sinhala',
    preview:
      'https://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwg2a1lkBpQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwg2a5l0LpJwbQRM.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwj-a5l0LpJwbQRM.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwtOd5l0LpJwbQRM.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwuqd5l0LpJwbQRM.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanssinhala/v26/yMJ2MJBya43H0SUF_WmcBEEf4rQVO2P524V5N_MxQzQtb-tf5dJbC30Fu9zUwo2d5l0LpJwbQRM.woff2',
    },
    installName: 'noto_sans_sinhala',
  },
  {
    label: 'Noto Sans Symbols',
    value: 'Noto Sans Symbols',
    preview:
      'https://fonts.gstatic.com/s/notosanssymbols/v40/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3gfQ8Qa_9E.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosanssymbols/v40/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3gfQ8gb_VFRkzrbQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanssymbols/v40/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3gTw8gb_VFRkzrbQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanssymbols/v40/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3gowggb_VFRkzrbQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanssymbols/v40/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3gmgggb_VFRkzrbQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanssymbols/v40/rP2up3q65FkAtHfwd-eIS2brbDN6gxP34F9jRRCe4W3g_Qggb_VFRkzrbQ.woff2',
    },
    installName: 'noto_sans_symbols',
  },
  {
    label: 'Noto Sans Syriac',
    value: 'Noto Sans Syriac',
    preview:
      'https://fonts.gstatic.com/s/notosanssyriac/v16/Ktk7AKuMeZjqPnXgyqribqzQqgW0LYiVqV7dXcP0C-VD9PaIw5Y.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosanssyriac/v16/Ktk7AKuMeZjqPnXgyqribqzQqgW0LYiVqV7dXcP0C-VD9MaMyZfUL_FC.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanssyriac/v16/Ktk7AKuMeZjqPnXgyqribqzQqgW0LYiVqV7dXcP0C-Vx9MaMyZfUL_FC.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanssyriac/v16/Ktk7AKuMeZjqPnXgyqribqzQqgW0LYiVqV7dXcP0C-Wd88aMyZfUL_FC.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanssyriac/v16/Ktk7AKuMeZjqPnXgyqribqzQqgW0LYiVqV7dXcP0C-Wk88aMyZfUL_FC.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanssyriac/v16/Ktk7AKuMeZjqPnXgyqribqzQqgW0LYiVqV7dXcP0C-XD88aMyZfUL_FC.woff2',
    },
    installName: 'noto_sans_syriac',
  },
  {
    label: 'Noto Sans Syriac Eastern',
    value: 'Noto Sans Syriac Eastern',
    preview:
      'https://fonts.gstatic.com/s/notosanssyriaceastern/v1/Noac6Vj_wIWFbTTCrYmvy8AjVU8aslWRHHvRYxS-Ro3yS0FDacnHPi-fgzGB5A.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosanssyriaceastern/v1/Noac6Vj_wIWFbTTCrYmvy8AjVU8aslWRHHvRYxS-Ro3yS0FDacnHPi-fszWL5ep1QPQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanssyriaceastern/v1/Noac6Vj_wIWFbTTCrYmvy8AjVU8aslWRHHvRYxS-Ro3yS0FDacnHPh2fszWL5ep1QPQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanssyriaceastern/v1/Noac6Vj_wIWFbTTCrYmvy8AjVU8aslWRHHvRYxS-Ro3yS0FDacnHPvGYszWL5ep1QPQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanssyriaceastern/v1/Noac6Vj_wIWFbTTCrYmvy8AjVU8aslWRHHvRYxS-Ro3yS0FDacnHPsiYszWL5ep1QPQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanssyriaceastern/v1/Noac6Vj_wIWFbTTCrYmvy8AjVU8aslWRHHvRYxS-Ro3yS0FDacnHPq-YszWL5ep1QPQ.woff2',
    },
    installName: 'noto_sans_syriac_eastern',
  },
  {
    label: 'Noto Sans Tamil',
    value: 'Noto Sans Tamil',
    preview:
      'https://fonts.gstatic.com/s/notosanstamil/v27/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7vGo40QoqE.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosanstamil/v27/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7vGo70UqKDt_EvT.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanstamil/v27/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7v0o70UqKDt_EvT.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanstamil/v27/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7sYpL0UqKDt_EvT.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanstamil/v27/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7shpL0UqKDt_EvT.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanstamil/v27/ieVc2YdFI3GCY6SyQy1KfStzYKZgzN1z4LKDbeZce-0429tBManUktuex7tGpL0UqKDt_EvT.woff2',
    },
    installName: 'noto_sans_tamil',
  },
  {
    label: 'Noto Sans TC',
    value: 'Noto Sans TC',
    preview:
      'https://fonts.gstatic.com/s/notosanstc/v35/-nFuOG829Oofr2wohFbTp9ifNAn722rq0MXz76CyzCtEtw.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosanstc/v35/-nFuOG829Oofr2wohFbTp9ifNAn722rq0MXz76Cy_C9Otma3uNQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanstc/v35/-nFuOG829Oofr2wohFbTp9ifNAn722rq0MXz75Ky_C9Otma3uNQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanstc/v35/-nFuOG829Oofr2wohFbTp9ifNAn722rq0MXz7361_C9Otma3uNQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanstc/v35/-nFuOG829Oofr2wohFbTp9ifNAn722rq0MXz70e1_C9Otma3uNQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanstc/v35/-nFuOG829Oofr2wohFbTp9ifNAn722rq0MXz7yC1_C9Otma3uNQ.woff2',
    },
    installName: 'noto_sans_tc',
  },
  {
    label: 'Noto Sans Telugu',
    value: 'Noto Sans Telugu',
    preview:
      'https://fonts.gstatic.com/s/notosanstelugu/v25/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEntezbaQEze.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosanstelugu/v25/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEntezbqREbf-3v37w.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosanstelugu/v25/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEntSTbqREbf-3v37w.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosanstelugu/v25/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEntpTHqREbf-3v37w.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosanstelugu/v25/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEntnDHqREbf-3v37w.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosanstelugu/v25/0FlxVOGZlE2Rrtr-HmgkMWJNjJ5_RyT8o8c7fHkeg-esVC5dzHkHIJQqrEnt-zHqREbf-3v37w.woff2',
    },
    installName: 'noto_sans_telugu',
  },
  {
    label: 'Noto Sans Thaana',
    value: 'Noto Sans Thaana',
    preview:
      'https://fonts.gstatic.com/s/notosansthaana/v23/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4XrbiLglO8.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosansthaana/v23/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4XrbhLknu4-tbNu.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansthaana/v23/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4XZbhLknu4-tbNu.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansthaana/v23/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4U1aRLknu4-tbNu.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansthaana/v23/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4UMaRLknu4-tbNu.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansthaana/v23/C8c14dM-vnz-s-3jaEsxlxHkBH-WZOETXfoQrfQ9Y4VraRLknu4-tbNu.woff2',
    },
    installName: 'noto_sans_thaana',
  },
  {
    label: 'Noto Sans Thai',
    value: 'Noto Sans Thai',
    preview:
      'https://fonts.gstatic.com/s/notosansthai/v20/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdU5RtlzB0QA.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosansthai/v20/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdU5RtpzR-QRvzzXg.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansthai/v20/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdU6ZtpzR-QRvzzXg.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansthai/v20/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdU0pqpzR-QRvzzXg.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansthai/v20/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdU3NqpzR-QRvzzXg.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansthai/v20/iJWnBXeUZi_OHPqn4wq6hQ2_hbJ1xyN9wd43SofNWcd1MKVQt_So_9CdUxRqpzR-QRvzzXg.woff2',
    },
    installName: 'noto_sans_thai',
  },
  {
    label: 'Noto Sans Thai Looped',
    value: 'Noto Sans Thai Looped',
    preview:
      'https://fonts.gstatic.com/s/notosansthailooped/v14/B50RF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3QOqAd.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notosansthailooped/v14/B50RF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3gPqocWiHvWQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/notosansthailooped/v14/B50cF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3Yz4M4VwrzUO5sKA.woff2',
      '600':
        'https://fonts.gstatic.com/s/notosansthailooped/v14/B50cF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3Y44Q4VwrzUO5sKA.woff2',
      '700':
        'https://fonts.gstatic.com/s/notosansthailooped/v14/B50cF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3Yh4U4VwrzUO5sKA.woff2',
      '800':
        'https://fonts.gstatic.com/s/notosansthailooped/v14/B50cF6pOpWTRcGrhOVJJ3-oPfY7WQuFu5R3Ym4Y4VwrzUO5sKA.woff2',
    },
    installName: 'noto_sans_thai_looped',
  },
  {
    label: 'Noto Serif',
    value: 'Noto Serif',
    preview:
      'https://fonts.gstatic.com/s/notoserif/v22/ga6iaw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTa32J4wsL2JAlAhZqFCTwccK.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notoserif/v22/ga6iaw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTa32J4wsL2JAlAhZqFCjxc0Lhq_Szw.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserif/v22/ga6iaw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTa32J4wsL2JAlAhZmlCjxc0Lhq_Szw.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserif/v22/ga6iaw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTa32J4wsL2JAlAhZdlejxc0Lhq_Szw.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserif/v22/ga6iaw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTa32J4wsL2JAlAhZT1ejxc0Lhq_Szw.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserif/v22/ga6iaw1J5X9T9RW6j9bNVls-hfgvz8JcMofYTa32J4wsL2JAlAhZKFejxc0Lhq_Szw.woff2',
    },
    installName: 'noto_serif',
  },
  {
    label: 'Noto Serif Armenian',
    value: 'Noto Serif Armenian',
    preview:
      'https://fonts.gstatic.com/s/notoserifarmenian/v25/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZi8Krx__b.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notoserifarmenian/v25/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZi8Kbw_XagGdkbg.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifarmenian/v25/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZucKbw_XagGdkbg.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifarmenian/v25/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZVcWbw_XagGdkbg.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifarmenian/v25/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZbMWbw_XagGdkbg.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifarmenian/v25/3XFMEqMt3YoFsciDRZxptyCUKJmytZ0kVU-XvF7QaZuL85rnQ_zDNzDe5xNnKxyZC8Wbw_XagGdkbg.woff2',
    },
    installName: 'noto_serif_armenian',
  },
  {
    label: 'Noto Serif Bengali',
    value: 'Noto Serif Bengali',
    preview:
      'https://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JfcAHkqm6rk.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JfcAHnqi4LjQH8yD.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JfcyHnqi4LjQH8yD.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JffeGXqi4LjQH8yD.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JffnGXqi4LjQH8yD.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifbengali/v19/hYkuPvggTvnzO14VSXltirUdnnkt1pwmWrprmO7RjE0a5BtdATYU1crFaM_5JfeAGXqi4LjQH8yD.woff2',
    },
    installName: 'noto_serif_bengali',
  },
  {
    label: 'Noto Serif Devanagari',
    value: 'Noto Serif Devanagari',
    preview:
      'https://fonts.gstatic.com/s/notoserifdevanagari/v28/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTA-oz-GO0Y.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notoserifdevanagari/v28/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTA-ow-CMUe1u_dv.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifdevanagari/v28/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTAMow-CMUe1u_dv.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifdevanagari/v28/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTDgpA-CMUe1u_dv.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifdevanagari/v28/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTDZpA-CMUe1u_dv.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifdevanagari/v28/x3dYcl3IZKmUqiMk48ZHXJ5jwU-DZGRSaQ4Hh2dGyFzPLcQPVbnRNeFsw0xRWb6uxTC-pA-CMUe1u_dv.woff2',
    },
    installName: 'noto_serif_devanagari',
  },
  {
    label: 'Noto Serif Display',
    value: 'Noto Serif Display',
    preview:
      'https://fonts.gstatic.com/s/notoserifdisplay/v24/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVpd4ugLYjQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notoserifdisplay/v24/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVpd4tgPaDU9hvzC.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifdisplay/v24/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVpv4tgPaDU9hvzC.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifdisplay/v24/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVqD5dgPaDU9hvzC.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifdisplay/v24/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVq65dgPaDU9hvzC.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifdisplay/v24/buERppa9f8_vkXaZLAgP0G5Wi6QmA1QaeYah2sovLCDq_ZgLyt3idQfktOG-PVrd5dgPaDU9hvzC.woff2',
    },
    installName: 'noto_serif_display',
  },
  {
    label: 'Noto Serif Ethiopic',
    value: 'Noto Serif Ethiopic',
    preview:
      'https://fonts.gstatic.com/s/notoserifethiopic/v23/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxCzSUTkKm8.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notoserifethiopic/v23/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxCzSUjlKO9UVLyiw.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifethiopic/v23/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxC_yUjlKO9UVLyiw.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifethiopic/v23/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxCEyIjlKO9UVLyiw.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifethiopic/v23/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxCKiIjlKO9UVLyiw.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifethiopic/v23/V8mjoR7-XjwJ8_Au3Ti5tXj5Rd83frpWLK4d-taxqWw2HMWjDxBAg5S_0QsrggxCTSIjlKO9UVLyiw.woff2',
    },
    installName: 'noto_serif_ethiopic',
  },
  {
    label: 'Noto Serif Georgian',
    value: 'Noto Serif Georgian',
    preview:
      'https://fonts.gstatic.com/s/notoserifgeorgian/v24/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aSTvovdj7x.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notoserifgeorgian/v24/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aSTvofcjTw-FgZxQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifgeorgian/v24/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aSfPofcjTw-FgZxQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifgeorgian/v24/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aSkP0fcjTw-FgZxQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifgeorgian/v24/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aSqf0fcjTw-FgZxQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifgeorgian/v24/VEMXRpd8s4nv8hG_qOzL7HOAw4nt0Sl_XxyaEduNMvi7T6Y4etRnmGhyLop-R3aSzv0fcjTw-FgZxQ.woff2',
    },
    installName: 'noto_serif_georgian',
  },
  {
    label: 'Noto Serif Gujarati',
    value: 'Noto Serif Gujarati',
    preview:
      'https://fonts.gstatic.com/s/notoserifgujarati/v26/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2HuYycLzvOVM.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notoserifgujarati/v26/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2HuYycIzrM1Kf-OJu.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifgujarati/v26/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2HuYAcIzrM1Kf-OJu.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifgujarati/v26/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2Hubsd4zrM1Kf-OJu.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifgujarati/v26/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2HubVd4zrM1Kf-OJu.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifgujarati/v26/hESa6WBlOixO-3OJ1FTmTsmqlBRUJBVkcgNLpdsspzP2Huayd4zrM1Kf-OJu.woff2',
    },
    installName: 'noto_serif_gujarati',
  },
  {
    label: 'Noto Serif Gurmukhi',
    value: 'Noto Serif Gurmukhi',
    preview:
      'https://fonts.gstatic.com/s/notoserifgurmukhi/v20/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr6-eSTMkKQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notoserifgurmukhi/v20/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr6-eRTImqVU7y6l.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifgurmukhi/v20/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr6MeRTImqVU7y6l.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifgurmukhi/v20/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr5gfhTImqVU7y6l.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifgurmukhi/v20/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr5ZfhTImqVU7y6l.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifgurmukhi/v20/92z-tA9LNqsg7tCYlXdCV1VPnAEeDU0vLoYMbylXk0xTCr4-fhTImqVU7y6l.woff2',
    },
    installName: 'noto_serif_gurmukhi',
  },
  {
    label: 'Noto Serif Hebrew',
    value: 'Noto Serif Hebrew',
    preview:
      'https://fonts.gstatic.com/s/notoserifhebrew/v25/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVAwSMG41vw.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notoserifhebrew/v25/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVAwSAGo_vlQxz24.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifhebrew/v25/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVD4SAGo_vlQxz24.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifhebrew/v25/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVNIVAGo_vlQxz24.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifhebrew/v25/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVOsVAGo_vlQxz24.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifhebrew/v25/k3k0o9MMPvpLmixYH7euCwmkS9DohjX1-kRyiqyBqIxnoLbp93i9IKrXKF_qVIwVAGo_vlQxz24.woff2',
    },
    installName: 'noto_serif_hebrew',
  },
  {
    label: 'Noto Serif HK',
    value: 'Noto Serif HK',
    preview:
      'https://fonts.gstatic.com/s/notoserifhk/v2/BngdUXBETWXI6LwlBZGcqL-B_KuJFcgfwP_9RMd-K1RnXdU.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notoserifhk/v2/BngdUXBETWXI6LwlBZGcqL-B_KuJFcgfwP_9RMd-K2RjV9Su1M6i.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifhk/v2/BngdUXBETWXI6LwlBZGcqL-B_KuJFcgfwP_9RMdMK2RjV9Su1M6i.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifhk/v2/BngdUXBETWXI6LwlBZGcqL-B_KuJFcgfwP_9RMegLGRjV9Su1M6i.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifhk/v2/BngdUXBETWXI6LwlBZGcqL-B_KuJFcgfwP_9RMeZLGRjV9Su1M6i.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifhk/v2/BngdUXBETWXI6LwlBZGcqL-B_KuJFcgfwP_9RMf-LGRjV9Su1M6i.woff2',
    },
    installName: 'noto_serif_hk',
  },
  {
    label: 'Noto Serif Kannada',
    value: 'Noto Serif Kannada',
    preview:
      'https://fonts.gstatic.com/s/notoserifkannada/v26/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgcYDQeVD7g.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notoserifkannada/v26/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgcYDceFJ71svgcI.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifkannada/v26/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgfQDceFJ71svgcI.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifkannada/v26/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgRgEceFJ71svgcI.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifkannada/v26/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgSEEceFJ71svgcI.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifkannada/v26/v6-8GZHLJFKIhClqUYqXDiWqpxQxWSPoW6bz-l4hGHiNgUYEceFJ71svgcI.woff2',
    },
    installName: 'noto_serif_kannada',
  },
  {
    label: 'Noto Serif Khmer',
    value: 'Noto Serif Khmer',
    preview:
      'https://fonts.gstatic.com/s/notoserifkhmer/v23/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdN6B8AXUxL.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notoserifkhmer/v23/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdN6B8wWUZK9Xo4xg.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifkhmer/v23/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdN2h8wWUZK9Xo4xg.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifkhmer/v23/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdNNhgwWUZK9Xo4xg.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifkhmer/v23/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdNDxgwWUZK9Xo4xg.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifkhmer/v23/-F6UfidqLzI2JPCkXAO2hmogq0146FxtbwKEr951z5s6lI40sDRH_AVhUKdNaBgwWUZK9Xo4xg.woff2',
    },
    installName: 'noto_serif_khmer',
  },
  {
    label: 'Noto Serif Lao',
    value: 'Noto Serif Lao',
    preview:
      'https://fonts.gstatic.com/s/notoseriflao/v23/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8VeMKnvKplw.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notoseriflao/v23/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8VeMKrvajlmyhHHQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoseriflao/v23/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8VdEKrvajlmyhHHQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoseriflao/v23/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8VT0NrvajlmyhHHQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoseriflao/v23/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8VQQNrvajlmyhHHQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoseriflao/v23/3y9C6bYwcCjmsU8JEzCMxEwQfEBLk3f0rlSqCdaM_LlSNZ59oNw0BWH8VWMNrvajlmyhHHQ.woff2',
    },
    installName: 'noto_serif_lao',
  },
  {
    label: 'Noto Serif Malayalam',
    value: 'Noto Serif Malayalam',
    preview:
      'https://fonts.gstatic.com/s/notoserifmalayalam/v28/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL1t-xvnFYG.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notoserifmalayalam/v28/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL1t-xfmFwHpQVySg.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifmalayalam/v28/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL1hexfmFwHpQVySg.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifmalayalam/v28/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL1aetfmFwHpQVySg.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifmalayalam/v28/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL1UOtfmFwHpQVySg.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifmalayalam/v28/JIAZUU5sdmdP_HMcVcZFcH7DeVBeGVgSMEk2cmVDq1ihUXL1N-tfmFwHpQVySg.woff2',
    },
    installName: 'noto_serif_malayalam',
  },
  {
    label: 'Noto Serif Sinhala',
    value: 'Noto Serif Sinhala',
    preview:
      'https://fonts.gstatic.com/s/notoserifsinhala/v26/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pGxR2Mtz6M.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notoserifsinhala/v26/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pGxR1MpxaLRn3W-.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifsinhala/v26/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pGDR1MpxaLRn3W-.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifsinhala/v26/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pFvQFMpxaLRn3W-.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifsinhala/v26/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pFWQFMpxaLRn3W-.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifsinhala/v26/DtVEJwinQqclnZE2CnsPug9lgGC3y2F2nehQ7Eg4EdBKWxPiDxMivFLgRXs_-pExQFMpxaLRn3W-.woff2',
    },
    installName: 'noto_serif_sinhala',
  },
  {
    label: 'Noto Serif Tamil',
    value: 'Noto Serif Tamil',
    preview:
      'https://fonts.gstatic.com/s/notoseriftamil/v28/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecattN-h8fb2.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notoseriftamil/v28/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecattN-R9fz3v8Etew.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoseriftamil/v28/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecatht-R9fz3v8Etew.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoseriftamil/v28/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecatatiR9fz3v8Etew.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoseriftamil/v28/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecatU9iR9fz3v8Etew.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoseriftamil/v28/LYjndHr-klIgTfc40komjQ5OObazYp-6H94dBF-RX6nNRJfi-Gf55IgAecatNNiR9fz3v8Etew.woff2',
    },
    installName: 'noto_serif_tamil',
  },
  {
    label: 'Noto Serif Telugu',
    value: 'Noto Serif Telugu',
    preview:
      'https://fonts.gstatic.com/s/notoseriftelugu/v25/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9D9TCAuIee.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notoseriftelugu/v25/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9D9TCwvI2fjgrZYA.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoseriftelugu/v25/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9DxzCwvI2fjgrZYA.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoseriftelugu/v25/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9DKzewvI2fjgrZYA.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoseriftelugu/v25/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9DEjewvI2fjgrZYA.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoseriftelugu/v25/tDbl2pCbnkEKmXNVmt2M1q6f4HWbbj6MRbYEeav7Fe9DdTewvI2fjgrZYA.woff2',
    },
    installName: 'noto_serif_telugu',
  },
  {
    label: 'Noto Serif Thai',
    value: 'Noto Serif Thai',
    preview:
      'https://fonts.gstatic.com/s/notoserifthai/v19/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0oiF9RQAGo.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notoserifthai/v19/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0oiF-RUCmsdu0Qx.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoserifthai/v19/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0oQF-RUCmsdu0Qx.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoserifthai/v19/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0r8EORUCmsdu0Qx.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoserifthai/v19/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0rFEORUCmsdu0Qx.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoserifthai/v19/k3kyo80MPvpLmixYH7euCxWpSMu3-gcWGj0hHAKGvUQlUv_bCKDUSzB5L0qiEORUCmsdu0Qx.woff2',
    },
    installName: 'noto_serif_thai',
  },
  {
    label: 'Noto Serif Tibetan',
    value: 'Noto Serif Tibetan',
    preview:
      'https://fonts.gstatic.com/s/notoseriftibetan/v22/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmIrYcDS_hdA.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/notoseriftibetan/v22/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmIrYcPSvrdSy_32c.woff2',
      '500':
        'https://fonts.gstatic.com/s/notoseriftibetan/v22/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmIoQcPSvrdSy_32c.woff2',
      '600':
        'https://fonts.gstatic.com/s/notoseriftibetan/v22/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmImgbPSvrdSy_32c.woff2',
      '700':
        'https://fonts.gstatic.com/s/notoseriftibetan/v22/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmIlEbPSvrdSy_32c.woff2',
      '800':
        'https://fonts.gstatic.com/s/notoseriftibetan/v22/gokGH7nwAEdtF9N45n0Vaz7O-pk0wsvxHeDXMfqguoCmIjYbPSvrdSy_32c.woff2',
    },
    installName: 'noto_serif_tibetan',
  },
  {
    label: 'Nunito',
    value: 'Nunito',
    preview:
      'https://fonts.gstatic.com/s/nunito/v25/XRXI3I6Li01BKofiOc5wtlZ2di8HDLshdTI3jw.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/nunito/v25/XRXI3I6Li01BKofiOc5wtlZ2di8HDLshRTY9jo7eTWk.woff2',
      '500':
        'https://fonts.gstatic.com/s/nunito/v25/XRXI3I6Li01BKofiOc5wtlZ2di8HDIkhRTY9jo7eTWk.woff2',
      '600':
        'https://fonts.gstatic.com/s/nunito/v25/XRXI3I6Li01BKofiOc5wtlZ2di8HDGUmRTY9jo7eTWk.woff2',
      '700':
        'https://fonts.gstatic.com/s/nunito/v25/XRXI3I6Li01BKofiOc5wtlZ2di8HDFwmRTY9jo7eTWk.woff2',
      '800':
        'https://fonts.gstatic.com/s/nunito/v25/XRXI3I6Li01BKofiOc5wtlZ2di8HDDsmRTY9jo7eTWk.woff2',
    },
    installName: 'nunito',
  },
  {
    label: 'Nunito Sans',
    value: 'Nunito Sans',
    preview:
      'https://fonts.gstatic.com/s/nunitosans/v15/pe1mMImSLYBIv1o4X1M8ce2xCx3yop4tQpF_MeTm0lfGWVpNn64CL7U8upHZIbMV51Q42ptCp5F5bxqqtQ1yiU4G1ilXtVUl.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/nunitosans/v15/pe1mMImSLYBIv1o4X1M8ce2xCx3yop4tQpF_MeTm0lfGWVpNn64CL7U8upHZIbMV51Q42ptCp5F5bxqqtQ1yiU4G1ilnsV8kA_Ykqw.woff2',
      '500':
        'https://fonts.gstatic.com/s/nunitosans/v15/pe1mMImSLYBIv1o4X1M8ce2xCx3yop4tQpF_MeTm0lfGWVpNn64CL7U8upHZIbMV51Q42ptCp5F5bxqqtQ1yiU4G5ClnsV8kA_Ykqw.woff2',
      '600':
        'https://fonts.gstatic.com/s/nunitosans/v15/pe1mMImSLYBIv1o4X1M8ce2xCx3yop4tQpF_MeTm0lfGWVpNn64CL7U8upHZIbMV51Q42ptCp5F5bxqqtQ1yiU4GCC5nsV8kA_Ykqw.woff2',
      '700':
        'https://fonts.gstatic.com/s/nunitosans/v15/pe1mMImSLYBIv1o4X1M8ce2xCx3yop4tQpF_MeTm0lfGWVpNn64CL7U8upHZIbMV51Q42ptCp5F5bxqqtQ1yiU4GMS5nsV8kA_Ykqw.woff2',
      '800':
        'https://fonts.gstatic.com/s/nunitosans/v15/pe1mMImSLYBIv1o4X1M8ce2xCx3yop4tQpF_MeTm0lfGWVpNn64CL7U8upHZIbMV51Q42ptCp5F5bxqqtQ1yiU4GVi5nsV8kA_Ykqw.woff2',
    },
    installName: 'nunito_sans',
  },
  {
    label: 'Open Sans',
    value: 'Open Sans',
    preview:
      'https://fonts.gstatic.com/s/opensans/v35/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0B4maVI.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/opensans/v35/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjZ0C4iY1M2xLER.woff2',
      '500':
        'https://fonts.gstatic.com/s/opensans/v35/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsjr0C4iY1M2xLER.woff2',
      '600':
        'https://fonts.gstatic.com/s/opensans/v35/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsgH1y4iY1M2xLER.woff2',
      '700':
        'https://fonts.gstatic.com/s/opensans/v35/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgsg-1y4iY1M2xLER.woff2',
      '800':
        'https://fonts.gstatic.com/s/opensans/v35/memSYaGs126MiZpBA-UvWbX2vVnXBbObj2OVZyOOSr4dVJWUgshZ1y4iY1M2xLER.woff2',
    },
    installName: 'open_sans',
  },
  {
    label: 'Orbitron',
    value: 'Orbitron',
    preview:
      'https://fonts.gstatic.com/s/orbitron/v31/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nyGy6Bp2gz.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/orbitron/v31/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nyGy6xo2IyXjU1pg.woff2',
      '500':
        'https://fonts.gstatic.com/s/orbitron/v31/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nyKS6xo2IyXjU1pg.woff2',
      '600':
        'https://fonts.gstatic.com/s/orbitron/v31/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nyxSmxo2IyXjU1pg.woff2',
      '700':
        'https://fonts.gstatic.com/s/orbitron/v31/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1ny_Cmxo2IyXjU1pg.woff2',
      '800':
        'https://fonts.gstatic.com/s/orbitron/v31/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nymymxo2IyXjU1pg.woff2',
    },
    installName: 'orbitron',
  },
  {
    label: 'Outfit',
    value: 'Outfit',
    preview:
      'https://fonts.gstatic.com/s/outfit/v11/QGYyz_MVcBeNP4NjuGObqx1XmO1I4TC1O4C0Ew.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/outfit/v11/QGYyz_MVcBeNP4NjuGObqx1XmO1I4TC1C4S-EiAou6Y.woff2',
      '500':
        'https://fonts.gstatic.com/s/outfit/v11/QGYyz_MVcBeNP4NjuGObqx1XmO1I4QK1C4S-EiAou6Y.woff2',
      '600':
        'https://fonts.gstatic.com/s/outfit/v11/QGYyz_MVcBeNP4NjuGObqx1XmO1I4e6yC4S-EiAou6Y.woff2',
      '700':
        'https://fonts.gstatic.com/s/outfit/v11/QGYyz_MVcBeNP4NjuGObqx1XmO1I4deyC4S-EiAou6Y.woff2',
      '800':
        'https://fonts.gstatic.com/s/outfit/v11/QGYyz_MVcBeNP4NjuGObqx1XmO1I4bCyC4S-EiAou6Y.woff2',
    },
    installName: 'outfit',
  },
  {
    label: 'Overpass',
    value: 'Overpass',
    preview:
      'https://fonts.gstatic.com/s/overpass/v12/qFda35WCmI96Ajtm83upeyoaX6QPnlo6_PPbOJqK.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/overpass/v12/qFda35WCmI96Ajtm83upeyoaX6QPnlo6_PPrPJCLtce-og.woff2',
      '500':
        'https://fonts.gstatic.com/s/overpass/v12/qFda35WCmI96Ajtm83upeyoaX6QPnlo6zvPrPJCLtce-og.woff2',
      '600':
        'https://fonts.gstatic.com/s/overpass/v12/qFda35WCmI96Ajtm83upeyoaX6QPnlo6IvTrPJCLtce-og.woff2',
      '700':
        'https://fonts.gstatic.com/s/overpass/v12/qFda35WCmI96Ajtm83upeyoaX6QPnlo6G_TrPJCLtce-og.woff2',
      '800':
        'https://fonts.gstatic.com/s/overpass/v12/qFda35WCmI96Ajtm83upeyoaX6QPnlo6fPTrPJCLtce-og.woff2',
    },
    installName: 'overpass',
  },
  {
    label: 'Oxanium',
    value: 'Oxanium',
    preview:
      'https://fonts.gstatic.com/s/oxanium/v19/RrQPboN_4yJ0JmiMUW7sIGjd1IA9G81JfkiND3U.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/oxanium/v19/RrQPboN_4yJ0JmiMUW7sIGjd1IA9G81JfniJBXQ7d67x.woff2',
      '500':
        'https://fonts.gstatic.com/s/oxanium/v19/RrQPboN_4yJ0JmiMUW7sIGjd1IA9G817fniJBXQ7d67x.woff2',
      '600':
        'https://fonts.gstatic.com/s/oxanium/v19/RrQPboN_4yJ0JmiMUW7sIGjd1IA9G82XeXiJBXQ7d67x.woff2',
      '700':
        'https://fonts.gstatic.com/s/oxanium/v19/RrQPboN_4yJ0JmiMUW7sIGjd1IA9G82ueXiJBXQ7d67x.woff2',
      '800':
        'https://fonts.gstatic.com/s/oxanium/v19/RrQPboN_4yJ0JmiMUW7sIGjd1IA9G83JeXiJBXQ7d67x.woff2',
    },
    installName: 'oxanium',
  },
  {
    label: 'Pathway Extreme',
    value: 'Pathway Extreme',
    preview:
      'https://fonts.gstatic.com/s/pathwayextreme/v3/neI6zCC3pJ0rsaH2_sD-QttXPfDPonvkQ-pxx5gufvP2VmLjiFyxGf8BLymNjYv2Oy6vkLmw4xak2N1FKiY2.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/pathwayextreme/v3/neI6zCC3pJ0rsaH2_sD-QttXPfDPonvkQ-pxx5gufvP2VmLjiFyxGf8BLymNjYv2Oy6vkLmw4xak2N11Liw3igP5eg.woff2',
      '500':
        'https://fonts.gstatic.com/s/pathwayextreme/v3/neI6zCC3pJ0rsaH2_sD-QttXPfDPonvkQ-pxx5gufvP2VmLjiFyxGf8BLymNjYv2Oy6vkLmw4xak6t11Liw3igP5eg.woff2',
      '600':
        'https://fonts.gstatic.com/s/pathwayextreme/v3/neI6zCC3pJ0rsaH2_sD-QttXPfDPonvkQ-pxx5gufvP2VmLjiFyxGf8BLymNjYv2Oy6vkLmw4xakBtp1Liw3igP5eg.woff2',
      '700':
        'https://fonts.gstatic.com/s/pathwayextreme/v3/neI6zCC3pJ0rsaH2_sD-QttXPfDPonvkQ-pxx5gufvP2VmLjiFyxGf8BLymNjYv2Oy6vkLmw4xakP9p1Liw3igP5eg.woff2',
      '800':
        'https://fonts.gstatic.com/s/pathwayextreme/v3/neI6zCC3pJ0rsaH2_sD-QttXPfDPonvkQ-pxx5gufvP2VmLjiFyxGf8BLymNjYv2Oy6vkLmw4xakWNp1Liw3igP5eg.woff2',
    },
    installName: 'pathway_extreme',
  },
  {
    label: 'Petrona',
    value: 'Petrona',
    preview:
      'https://fonts.gstatic.com/s/petrona/v32/mtGl4_NXL7bZo9XXq35wRLONYyOjFk6NsTRAFY8.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/petrona/v32/mtGl4_NXL7bZo9XXq35wRLONYyOjFk6NsQREH452Mvds.woff2',
      '500':
        'https://fonts.gstatic.com/s/petrona/v32/mtGl4_NXL7bZo9XXq35wRLONYyOjFk6_sQREH452Mvds.woff2',
      '600':
        'https://fonts.gstatic.com/s/petrona/v32/mtGl4_NXL7bZo9XXq35wRLONYyOjFk5TtgREH452Mvds.woff2',
      '700':
        'https://fonts.gstatic.com/s/petrona/v32/mtGl4_NXL7bZo9XXq35wRLONYyOjFk5qtgREH452Mvds.woff2',
      '800':
        'https://fonts.gstatic.com/s/petrona/v32/mtGl4_NXL7bZo9XXq35wRLONYyOjFk4NtgREH452Mvds.woff2',
    },
    installName: 'petrona',
  },
  {
    label: 'Phudu',
    value: 'Phudu',
    preview:
      'https://fonts.gstatic.com/s/phudu/v4/0FlJVPSHk0ya-7OUeO_U-Lwm7PkKtWzkSg-v.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/phudu/v4/0FlJVPSHk0ya-7OUeO_U-Lwm7PkKtWzUTgWuz38Tgg.woff2',
      '500':
        'https://fonts.gstatic.com/s/phudu/v4/0FlJVPSHk0ya-7OUeO_U-Lwm7PkKh2zUTgWuz38Tgg.woff2',
      '600':
        'https://fonts.gstatic.com/s/phudu/v4/0FlJVPSHk0ya-7OUeO_U-Lwm7PkKa2vUTgWuz38Tgg.woff2',
      '700':
        'https://fonts.gstatic.com/s/phudu/v4/0FlJVPSHk0ya-7OUeO_U-Lwm7PkKUmvUTgWuz38Tgg.woff2',
      '800':
        'https://fonts.gstatic.com/s/phudu/v4/0FlJVPSHk0ya-7OUeO_U-Lwm7PkKNWvUTgWuz38Tgg.woff2',
    },
    installName: 'phudu',
  },
  {
    label: 'Piazzolla',
    value: 'Piazzolla',
    preview:
      'https://fonts.gstatic.com/s/piazzolla/v35/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7LYxkLz3gA.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/piazzolla/v35/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7LYxnL31AHfAAy5.woff2',
      '500':
        'https://fonts.gstatic.com/s/piazzolla/v35/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7LqxnL31AHfAAy5.woff2',
      '600':
        'https://fonts.gstatic.com/s/piazzolla/v35/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7IGwXL31AHfAAy5.woff2',
      '700':
        'https://fonts.gstatic.com/s/piazzolla/v35/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7I_wXL31AHfAAy5.woff2',
      '800':
        'https://fonts.gstatic.com/s/piazzolla/v35/N0b52SlTPu5rIkWIZjVKKtYtfxYqZ4RJBFzFfYUjkSDdlqZgy7JYwXL31AHfAAy5.woff2',
    },
    installName: 'piazzolla',
  },
  {
    label: 'Playfair',
    value: 'Playfair',
    preview:
      'https://fonts.gstatic.com/s/playfair/v2/0nkQC9D7PO4KhmUJ5_zTZ_4MYQXznAK-TUcZXKO3UMnW6VNpe4-SiiZ4b8h5G3GutPkUeugcqyI.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/playfair/v2/0nkQC9D7PO4KhmUJ5_zTZ_4MYQXznAK-TUcZXKO3UMnW6VNpe4-SiiZ4b8h5G3GutPkUetgYoSMw5ifm.woff2',
      '500':
        'https://fonts.gstatic.com/s/playfair/v2/0nkQC9D7PO4KhmUJ5_zTZ_4MYQXznAK-TUcZXKO3UMnW6VNpe4-SiiZ4b8h5G3GutPkmetgYoSMw5ifm.woff2',
      '600':
        'https://fonts.gstatic.com/s/playfair/v2/0nkQC9D7PO4KhmUJ5_zTZ_4MYQXznAK-TUcZXKO3UMnW6VNpe4-SiiZ4b8h5G3GutPnKfdgYoSMw5ifm.woff2',
      '700':
        'https://fonts.gstatic.com/s/playfair/v2/0nkQC9D7PO4KhmUJ5_zTZ_4MYQXznAK-TUcZXKO3UMnW6VNpe4-SiiZ4b8h5G3GutPnzfdgYoSMw5ifm.woff2',
      '800':
        'https://fonts.gstatic.com/s/playfair/v2/0nkQC9D7PO4KhmUJ5_zTZ_4MYQXznAK-TUcZXKO3UMnW6VNpe4-SiiZ4b8h5G3GutPmUfdgYoSMw5ifm.woff2',
    },
    installName: 'playfair',
  },
  {
    label: 'Playfair Display',
    value: 'Playfair Display',
    preview:
      'https://fonts.gstatic.com/s/playfairdisplay/v36/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKdFvXDRbtM.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/playfairdisplay/v36/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKdFvUDVZNLo_U2r.woff2',
      '500':
        'https://fonts.gstatic.com/s/playfairdisplay/v36/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKd3vUDVZNLo_U2r.woff2',
      '600':
        'https://fonts.gstatic.com/s/playfairdisplay/v36/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKebukDVZNLo_U2r.woff2',
      '700':
        'https://fonts.gstatic.com/s/playfairdisplay/v36/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKeiukDVZNLo_U2r.woff2',
      '800':
        'https://fonts.gstatic.com/s/playfairdisplay/v36/nuFvD-vYSZviVYUb_rj3ij__anPXJzDwcbmjWBN2PKfFukDVZNLo_U2r.woff2',
    },
    installName: 'playfair_display',
  },
  {
    label: 'Plus Jakarta Sans',
    value: 'Plus Jakarta Sans',
    preview:
      'https://fonts.gstatic.com/s/plusjakartasans/v8/LDIbaomQNQcsA88c7O9yZ4KMCoOg4IA6-91aHEjcWuA_qU79Sx_V.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/plusjakartasans/v8/LDIbaomQNQcsA88c7O9yZ4KMCoOg4IA6-91aHEjcWuA_qU7NTxXUEKi4Rw.woff2',
      '500':
        'https://fonts.gstatic.com/s/plusjakartasans/v8/LDIbaomQNQcsA88c7O9yZ4KMCoOg4IA6-91aHEjcWuA_m07NTxXUEKi4Rw.woff2',
      '600':
        'https://fonts.gstatic.com/s/plusjakartasans/v8/LDIbaomQNQcsA88c7O9yZ4KMCoOg4IA6-91aHEjcWuA_d0nNTxXUEKi4Rw.woff2',
      '700':
        'https://fonts.gstatic.com/s/plusjakartasans/v8/LDIbaomQNQcsA88c7O9yZ4KMCoOg4IA6-91aHEjcWuA_TknNTxXUEKi4Rw.woff2',
      '800':
        'https://fonts.gstatic.com/s/plusjakartasans/v8/LDIbaomQNQcsA88c7O9yZ4KMCoOg4IA6-91aHEjcWuA_KUnNTxXUEKi4Rw.woff2',
    },
    installName: 'plus_jakarta_sans',
  },
  {
    label: 'Podkova',
    value: 'Podkova',
    preview:
      'https://fonts.gstatic.com/s/podkova/v31/K2FufZ1EmftJSV9VQpXb1lo9vC3nZWtFzfU5GIs.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/podkova/v31/K2FufZ1EmftJSV9VQpXb1lo9vC3nZWtFzcU9EoporSHH.woff2',
      '500':
        'https://fonts.gstatic.com/s/podkova/v31/K2FufZ1EmftJSV9VQpXb1lo9vC3nZWt3zcU9EoporSHH.woff2',
      '600':
        'https://fonts.gstatic.com/s/podkova/v31/K2FufZ1EmftJSV9VQpXb1lo9vC3nZWubysU9EoporSHH.woff2',
      '700':
        'https://fonts.gstatic.com/s/podkova/v31/K2FufZ1EmftJSV9VQpXb1lo9vC3nZWuiysU9EoporSHH.woff2',
      '800':
        'https://fonts.gstatic.com/s/podkova/v31/K2FufZ1EmftJSV9VQpXb1lo9vC3nZWvFysU9EoporSHH.woff2',
    },
    installName: 'podkova',
  },
  {
    label: 'Poppins',
    value: 'Poppins',
    preview:
      'https://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrJJHecg.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/poppins/v20/pxiEyp8kv8JHgFVrFJXUc1NECPY.woff2',
      '500':
        'https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLGT9V15vFP-KUEg.woff2',
      '600':
        'https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLEj6V15vFP-KUEg.woff2',
      '700':
        'https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLCz7V15vFP-KUEg.woff2',
      '800':
        'https://fonts.gstatic.com/s/poppins/v20/pxiByp8kv8JHgFVrLDD4V15vFP-KUEg.woff2',
    },
    installName: 'poppins',
  },
  {
    label: 'Prompt',
    value: 'Prompt',
    preview:
      'https://fonts.gstatic.com/s/prompt/v10/-W__XJnvUD7dzB2KZtod.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/prompt/v10/-W__XJnvUD7dzB26YtAcZkIzeg.woff2',
      '500':
        'https://fonts.gstatic.com/s/prompt/v10/-W_8XJnvUD7dzB2Ck_k4a2kvc5Q9dw.woff2',
      '600':
        'https://fonts.gstatic.com/s/prompt/v10/-W_8XJnvUD7dzB2Cv_44a2kvc5Q9dw.woff2',
      '700':
        'https://fonts.gstatic.com/s/prompt/v10/-W_8XJnvUD7dzB2C2_84a2kvc5Q9dw.woff2',
      '800':
        'https://fonts.gstatic.com/s/prompt/v10/-W_8XJnvUD7dzB2Cx_w4a2kvc5Q9dw.woff2',
    },
    installName: 'prompt',
  },
  {
    label: 'Proza Libre',
    value: 'Proza Libre',
    preview:
      'https://fonts.gstatic.com/s/prozalibre/v9/LYjGdGHgj0k1DIQRyUEyyEoudNo.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/prozalibre/v9/LYjGdGHgj0k1DIQRyUEyyHoqftvXWYyz.woff2',
      '500':
        'https://fonts.gstatic.com/s/prozalibre/v9/LYjbdGHgj0k1DIQRyUEyyELbV__acpC69i6N.woff2',
      '600':
        'https://fonts.gstatic.com/s/prozalibre/v9/LYjbdGHgj0k1DIQRyUEyyEL3UP_acpC69i6N.woff2',
      '700':
        'https://fonts.gstatic.com/s/prozalibre/v9/LYjbdGHgj0k1DIQRyUEyyEKTUf_acpC69i6N.woff2',
      '800':
        'https://fonts.gstatic.com/s/prozalibre/v9/LYjbdGHgj0k1DIQRyUEyyEKPUv_acpC69i6N.woff2',
    },
    installName: 'proza_libre',
  },
  {
    label: 'Public Sans',
    value: 'Public Sans',
    preview:
      'https://fonts.gstatic.com/s/publicsans/v14/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymuFpmJwgco.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/publicsans/v14/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymuFpm5xg0pX189fg.woff2',
      '500':
        'https://fonts.gstatic.com/s/publicsans/v14/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymuJJm5xg0pX189fg.woff2',
      '600':
        'https://fonts.gstatic.com/s/publicsans/v14/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymuyJ65xg0pX189fg.woff2',
      '700':
        'https://fonts.gstatic.com/s/publicsans/v14/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymu8Z65xg0pX189fg.woff2',
      '800':
        'https://fonts.gstatic.com/s/publicsans/v14/ijwGs572Xtc6ZYQws9YVwllKVG8qX1oyOymulp65xg0pX189fg.woff2',
    },
    installName: 'public_sans',
  },
  {
    label: 'Raleway',
    value: 'Raleway',
    preview:
      'https://fonts.gstatic.com/s/raleway/v28/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVvaorCOPrE.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/raleway/v28/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVvaooCKNLA3JC9c.woff2',
      '500':
        'https://fonts.gstatic.com/s/raleway/v28/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVvoooCKNLA3JC9c.woff2',
      '600':
        'https://fonts.gstatic.com/s/raleway/v28/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVsEpYCKNLA3JC9c.woff2',
      '700':
        'https://fonts.gstatic.com/s/raleway/v28/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVs9pYCKNLA3JC9c.woff2',
      '800':
        'https://fonts.gstatic.com/s/raleway/v28/1Ptxg8zYS_SKggPN4iEgvnHyvveLxVtapYCKNLA3JC9c.woff2',
    },
    installName: 'raleway',
  },
  {
    label: 'Recursive',
    value: 'Recursive',
    preview:
      'https://fonts.gstatic.com/s/recursive/v37/8vJN7wMr0mhh-RQChyHEH06TlXhq_gukbYrFMk1QuAIcyEwG_X-dpEfaE5YaERmK-CImKsvxvU-MXGX2fSqasNfUvz2xbXfn1uEQadCCk319tQ0.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/recursive/v37/8vJN7wMr0mhh-RQChyHEH06TlXhq_gukbYrFMk1QuAIcyEwG_X-dpEfaE5YaERmK-CImKsvxvU-MXGX2fSqasNfUvz2xbXfn1uEQadCCk015vwxjDJCL.woff2',
      '500':
        'https://fonts.gstatic.com/s/recursive/v37/8vJN7wMr0mhh-RQChyHEH06TlXhq_gukbYrFMk1QuAIcyEwG_X-dpEfaE5YaERmK-CImKsvxvU-MXGX2fSqasNfUvz2xbXfn1uEQadCwk015vwxjDJCL.woff2',
      '600':
        'https://fonts.gstatic.com/s/recursive/v37/8vJN7wMr0mhh-RQChyHEH06TlXhq_gukbYrFMk1QuAIcyEwG_X-dpEfaE5YaERmK-CImKsvxvU-MXGX2fSqasNfUvz2xbXfn1uEQadBclE15vwxjDJCL.woff2',
      '700':
        'https://fonts.gstatic.com/s/recursive/v37/8vJN7wMr0mhh-RQChyHEH06TlXhq_gukbYrFMk1QuAIcyEwG_X-dpEfaE5YaERmK-CImKsvxvU-MXGX2fSqasNfUvz2xbXfn1uEQadBllE15vwxjDJCL.woff2',
      '800':
        'https://fonts.gstatic.com/s/recursive/v37/8vJN7wMr0mhh-RQChyHEH06TlXhq_gukbYrFMk1QuAIcyEwG_X-dpEfaE5YaERmK-CImKsvxvU-MXGX2fSqasNfUvz2xbXfn1uEQadAClE15vwxjDJCL.woff2',
    },
    installName: 'recursive',
  },
  {
    label: 'Red Hat Display',
    value: 'Red Hat Display',
    preview:
      'https://fonts.gstatic.com/s/redhatdisplay/v19/8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbmyWQkkz-A.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/redhatdisplay/v19/8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbmyWck05-Xecg3w.woff2',
      '500':
        'https://fonts.gstatic.com/s/redhatdisplay/v19/8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbl6Wck05-Xecg3w.woff2',
      '600':
        'https://fonts.gstatic.com/s/redhatdisplay/v19/8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbrKRck05-Xecg3w.woff2',
      '700':
        'https://fonts.gstatic.com/s/redhatdisplay/v19/8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbouRck05-Xecg3w.woff2',
      '800':
        'https://fonts.gstatic.com/s/redhatdisplay/v19/8vIf7wUr0m80wwYf0QCXZzYzUoTK8RZQvRd-D1NYbuyRck05-Xecg3w.woff2',
    },
    installName: 'red_hat_display',
  },
  {
    label: 'REM',
    value: 'REM',
    preview:
      'https://fonts.gstatic.com/s/rem/v2/WnzgHAIoSDyHbRjfsYumpRvUPMLqnTsebQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/rem/v2/WnzgHAIoSDyHbRjfsYumpRvUPMLqrT8UbIqIfBU.woff2',
      '500':
        'https://fonts.gstatic.com/s/rem/v2/WnzgHAIoSDyHbRjfsYumpRvUPPDqrT8UbIqIfBU.woff2',
      '600':
        'https://fonts.gstatic.com/s/rem/v2/WnzgHAIoSDyHbRjfsYumpRvUPBztrT8UbIqIfBU.woff2',
      '700':
        'https://fonts.gstatic.com/s/rem/v2/WnzgHAIoSDyHbRjfsYumpRvUPCXtrT8UbIqIfBU.woff2',
      '800':
        'https://fonts.gstatic.com/s/rem/v2/WnzgHAIoSDyHbRjfsYumpRvUPELtrT8UbIqIfBU.woff2',
    },
    installName: 'rem',
  },
  {
    label: 'Roboto Serif',
    value: 'Roboto Serif',
    preview:
      'https://fonts.gstatic.com/s/robotoserif/v13/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcEliotl6Z8AA.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/robotoserif/v13/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcEliotp6J2Af5fR4k.woff2',
      '500':
        'https://fonts.gstatic.com/s/robotoserif/v13/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcElhgtp6J2Af5fR4k.woff2',
      '600':
        'https://fonts.gstatic.com/s/robotoserif/v13/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcElvQqp6J2Af5fR4k.woff2',
      '700':
        'https://fonts.gstatic.com/s/robotoserif/v13/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcEls0qp6J2Af5fR4k.woff2',
      '800':
        'https://fonts.gstatic.com/s/robotoserif/v13/R71RjywflP6FLr3gZx7K8UyuXDs9zVwDmXCb8lxYgmuii32UGoVldX6UgfjL4-3sMM_kB_qXSEXTJQCFLH5-_bcElqoqp6J2Af5fR4k.woff2',
    },
    installName: 'roboto_serif',
  },
  {
    label: 'Roboto Slab',
    value: 'Roboto Slab',
    preview:
      'https://fonts.gstatic.com/s/robotoslab/v25/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjojISmaWRj.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/robotoslab/v25/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjojISWbW5iddG-1A.woff2',
      '500':
        'https://fonts.gstatic.com/s/robotoslab/v25/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjovoSWbW5iddG-1A.woff2',
      '600':
        'https://fonts.gstatic.com/s/robotoslab/v25/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjoUoOWbW5iddG-1A.woff2',
      '700':
        'https://fonts.gstatic.com/s/robotoslab/v25/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjoa4OWbW5iddG-1A.woff2',
      '800':
        'https://fonts.gstatic.com/s/robotoslab/v25/BngbUXZYTXPIvIBgJJSb6s3BzlRRfKOFbvjoDIOWbW5iddG-1A.woff2',
    },
    installName: 'roboto_slab',
  },
  {
    label: 'Rokkitt',
    value: 'Rokkitt',
    preview:
      'https://fonts.gstatic.com/s/rokkitt/v36/qFdb35qfgYFjGy5hukqqhw5XeRgdi1ryd6DKGb8.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/rokkitt/v36/qFdb35qfgYFjGy5hukqqhw5XeRgdi1ryd5DOE76HvN6n.woff2',
      '500':
        'https://fonts.gstatic.com/s/rokkitt/v36/qFdb35qfgYFjGy5hukqqhw5XeRgdi1rAd5DOE76HvN6n.woff2',
      '600':
        'https://fonts.gstatic.com/s/rokkitt/v36/qFdb35qfgYFjGy5hukqqhw5XeRgdi1oscJDOE76HvN6n.woff2',
      '700':
        'https://fonts.gstatic.com/s/rokkitt/v36/qFdb35qfgYFjGy5hukqqhw5XeRgdi1oVcJDOE76HvN6n.woff2',
      '800':
        'https://fonts.gstatic.com/s/rokkitt/v36/qFdb35qfgYFjGy5hukqqhw5XeRgdi1pycJDOE76HvN6n.woff2',
    },
    installName: 'rokkitt',
  },
  {
    label: 'Rubik',
    value: 'Rubik',
    preview:
      'https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-B4iFUUU1.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-B4i1VU80V4bVkA.woff2',
      '500':
        'https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-NYi1VU80V4bVkA.woff2',
      '600':
        'https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-2Y-1VU80V4bVkA.woff2',
      '700':
        'https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-4I-1VU80V4bVkA.woff2',
      '800':
        'https://fonts.gstatic.com/s/rubik/v28/iJWZBXyIfDnIV5PNhY1KTN7Z-Yh-h4-1VU80V4bVkA.woff2',
    },
    installName: 'rubik',
  },
  {
    label: 'Ruda',
    value: 'Ruda',
    preview:
      'https://fonts.gstatic.com/s/ruda/v28/k3kKo8YQJOpFgHQ1mQ5VkEbUKaJFsh__0qk.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/ruda/v28/k3kKo8YQJOpFgHQ1mQ5VkEbUKaJFsi_72KiSGg-H.woff2',
      '500':
        'https://fonts.gstatic.com/s/ruda/v28/k3kKo8YQJOpFgHQ1mQ5VkEbUKaJ3si_72KiSGg-H.woff2',
      '600':
        'https://fonts.gstatic.com/s/ruda/v28/k3kKo8YQJOpFgHQ1mQ5VkEbUKaKbtS_72KiSGg-H.woff2',
      '700':
        'https://fonts.gstatic.com/s/ruda/v28/k3kKo8YQJOpFgHQ1mQ5VkEbUKaKitS_72KiSGg-H.woff2',
      '800':
        'https://fonts.gstatic.com/s/ruda/v28/k3kKo8YQJOpFgHQ1mQ5VkEbUKaLFtS_72KiSGg-H.woff2',
    },
    installName: 'ruda',
  },
  {
    label: 'Saira',
    value: 'Saira',
    preview:
      'https://fonts.gstatic.com/s/saira/v19/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA71rCkskxlg.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/saira/v19/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA71rCos07lwYmUVY.woff2',
      '500':
        'https://fonts.gstatic.com/s/saira/v19/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA72jCos07lwYmUVY.woff2',
      '600':
        'https://fonts.gstatic.com/s/saira/v19/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA74TFos07lwYmUVY.woff2',
      '700':
        'https://fonts.gstatic.com/s/saira/v19/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA773Fos07lwYmUVY.woff2',
      '800':
        'https://fonts.gstatic.com/s/saira/v19/memWYa2wxmKQyPMrZX79wwYZQMhsyuShhKMjjbU9uXuA79rFos07lwYmUVY.woff2',
    },
    installName: 'saira',
  },
  {
    label: 'Saira Condensed',
    value: 'Saira Condensed',
    preview:
      'https://fonts.gstatic.com/s/sairacondensed/v11/EJROQgErUN8XuHNEtX81i9TmEkrvpOtF.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/sairacondensed/v11/EJROQgErUN8XuHNEtX81i9TmEkrfoOFE-IyCrw.woff2',
      '500':
        'https://fonts.gstatic.com/s/sairacondensed/v11/EJRLQgErUN8XuHNEtX81i9TmEkrnUchg9aeepi2lHw.woff2',
      '600':
        'https://fonts.gstatic.com/s/sairacondensed/v11/EJRLQgErUN8XuHNEtX81i9TmEkrnfc9g9aeepi2lHw.woff2',
      '700':
        'https://fonts.gstatic.com/s/sairacondensed/v11/EJRLQgErUN8XuHNEtX81i9TmEkrnGc5g9aeepi2lHw.woff2',
      '800':
        'https://fonts.gstatic.com/s/sairacondensed/v11/EJRLQgErUN8XuHNEtX81i9TmEkrnBc1g9aeepi2lHw.woff2',
    },
    installName: 'saira_condensed',
  },
  {
    label: 'Saira Extra Condensed',
    value: 'Saira Extra Condensed',
    preview:
      'https://fonts.gstatic.com/s/sairaextracondensed/v13/-nFiOHYr-vcC7h8MklGBkrvmUG9rbpkisrTj7kj0.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/sairaextracondensed/v13/-nFiOHYr-vcC7h8MklGBkrvmUG9rbpkisrTT6kL11Ct8sw.woff2',
      '500':
        'https://fonts.gstatic.com/s/sairaextracondensed/v13/-nFvOHYr-vcC7h8MklGBkrvmUG9rbpkisrTrG2vR2QBgum-uoQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/sairaextracondensed/v13/-nFvOHYr-vcC7h8MklGBkrvmUG9rbpkisrTrN2zR2QBgum-uoQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/sairaextracondensed/v13/-nFvOHYr-vcC7h8MklGBkrvmUG9rbpkisrTrU23R2QBgum-uoQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/sairaextracondensed/v13/-nFvOHYr-vcC7h8MklGBkrvmUG9rbpkisrTrT27R2QBgum-uoQ.woff2',
    },
    installName: 'saira_extra_condensed',
  },
  {
    label: 'Saira Semi Condensed',
    value: 'Saira Semi Condensed',
    preview:
      'https://fonts.gstatic.com/s/sairasemicondensed/v13/U9MD6c-2-nnJkHxyCjRcnMHcWVWV1cWRRX8KaOY.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/sairasemicondensed/v13/U9MD6c-2-nnJkHxyCjRcnMHcWVWV1cWRRU8OYuceqGT-.woff2',
      '500':
        'https://fonts.gstatic.com/s/sairasemicondensed/v13/U9MM6c-2-nnJkHxyCjRcnMHcWVWV1cWRRXf_S8MTg3j36Ebz.woff2',
      '600':
        'https://fonts.gstatic.com/s/sairasemicondensed/v13/U9MM6c-2-nnJkHxyCjRcnMHcWVWV1cWRRXfTTMMTg3j36Ebz.woff2',
      '700':
        'https://fonts.gstatic.com/s/sairasemicondensed/v13/U9MM6c-2-nnJkHxyCjRcnMHcWVWV1cWRRXe3TcMTg3j36Ebz.woff2',
      '800':
        'https://fonts.gstatic.com/s/sairasemicondensed/v13/U9MM6c-2-nnJkHxyCjRcnMHcWVWV1cWRRXerTsMTg3j36Ebz.woff2',
    },
    installName: 'saira_semi_condensed',
  },
  {
    label: 'Sansita Swashed',
    value: 'Sansita Swashed',
    preview:
      'https://fonts.gstatic.com/s/sansitaswashed/v17/BXR8vFfZifTZgFlDDLgNkBydPKTt3pVCeYWqJnZSW7RpXTsfew.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/sansitaswashed/v17/BXR8vFfZifTZgFlDDLgNkBydPKTt3pVCeYWqJnZSW7RpbT8VehmEa4Q.woff2',
      '500':
        'https://fonts.gstatic.com/s/sansitaswashed/v17/BXR8vFfZifTZgFlDDLgNkBydPKTt3pVCeYWqJnZSW4ZpbT8VehmEa4Q.woff2',
      '600':
        'https://fonts.gstatic.com/s/sansitaswashed/v17/BXR8vFfZifTZgFlDDLgNkBydPKTt3pVCeYWqJnZSW2pubT8VehmEa4Q.woff2',
      '700':
        'https://fonts.gstatic.com/s/sansitaswashed/v17/BXR8vFfZifTZgFlDDLgNkBydPKTt3pVCeYWqJnZSW1NubT8VehmEa4Q.woff2',
      '800':
        'https://fonts.gstatic.com/s/sansitaswashed/v17/BXR8vFfZifTZgFlDDLgNkBydPKTt3pVCeYWqJnZSWzRubT8VehmEa4Q.woff2',
    },
    installName: 'sansita_swashed',
  },
  {
    label: 'Sarabun',
    value: 'Sarabun',
    preview:
      'https://fonts.gstatic.com/s/sarabun/v15/DtVjJx26TKEr37c9aBNJnw.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/sarabun/v15/DtVjJx26TKEr37c9WBdDnlQN9gk.woff2',
      '500':
        'https://fonts.gstatic.com/s/sarabun/v15/DtVmJx26TKEr37c9YOZqulkm6gDXvwE.woff2',
      '600':
        'https://fonts.gstatic.com/s/sarabun/v15/DtVmJx26TKEr37c9YMptulkm6gDXvwE.woff2',
      '700':
        'https://fonts.gstatic.com/s/sarabun/v15/DtVmJx26TKEr37c9YK5sulkm6gDXvwE.woff2',
      '800':
        'https://fonts.gstatic.com/s/sarabun/v15/DtVmJx26TKEr37c9YLJvulkm6gDXvwE.woff2',
    },
    installName: 'sarabun',
  },
  {
    label: 'Sarpanch',
    value: 'Sarpanch',
    preview:
      'https://fonts.gstatic.com/s/sarpanch/v13/hESy6Xt4NCpRuk6Pzi2BTos.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/sarpanch/v13/hESy6Xt4NCpRuk6Pzh2FRIrX_20n.woff2',
      '500':
        'https://fonts.gstatic.com/s/sarpanch/v13/hES16Xt4NCpRuk6PziV0ba7a1HEuRHkM.woff2',
      '600':
        'https://fonts.gstatic.com/s/sarpanch/v13/hES16Xt4NCpRuk6PziVYaq7a1HEuRHkM.woff2',
      '700':
        'https://fonts.gstatic.com/s/sarpanch/v13/hES16Xt4NCpRuk6PziU8a67a1HEuRHkM.woff2',
      '800':
        'https://fonts.gstatic.com/s/sarpanch/v13/hES16Xt4NCpRuk6PziUgaK7a1HEuRHkM.woff2',
    },
    installName: 'sarpanch',
  },
  {
    label: 'Schibsted Grotesk',
    value: 'Schibsted Grotesk',
    preview:
      'https://fonts.gstatic.com/s/schibstedgrotesk/v3/JqzK5SSPQuCQF3t8uOwiUL-taUTtarVKQ9vZ6pJJWlMNIsEwTshv.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/schibstedgrotesk/v3/JqzK5SSPQuCQF3t8uOwiUL-taUTtarVKQ9vZ6pJJWlMNIsEASsJuXFGVOQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/schibstedgrotesk/v3/JqzK5SSPQuCQF3t8uOwiUL-taUTtarVKQ9vZ6pJJWlMNEMEASsJuXFGVOQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/schibstedgrotesk/v3/JqzK5SSPQuCQF3t8uOwiUL-taUTtarVKQ9vZ6pJJWlMN_MYASsJuXFGVOQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/schibstedgrotesk/v3/JqzK5SSPQuCQF3t8uOwiUL-taUTtarVKQ9vZ6pJJWlMNxcYASsJuXFGVOQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/schibstedgrotesk/v3/JqzK5SSPQuCQF3t8uOwiUL-taUTtarVKQ9vZ6pJJWlMNosYASsJuXFGVOQ.woff2',
    },
    installName: 'schibsted_grotesk',
  },
  {
    label: 'Sen',
    value: 'Sen',
    preview:
      'https://fonts.gstatic.com/s/sen/v9/6xK0dSxYI9_dkN18-vZKK2EISCq5L4_AlQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/sen/v9/6xK0dSxYI9_dkN18-vZKK2EISCq5H4vKlD9q78A.woff2',
      '500':
        'https://fonts.gstatic.com/s/sen/v9/6xK0dSxYI9_dkN18-vZKK2EISBi5H4vKlD9q78A.woff2',
      '600':
        'https://fonts.gstatic.com/s/sen/v9/6xK0dSxYI9_dkN18-vZKK2EISPS-H4vKlD9q78A.woff2',
      '700':
        'https://fonts.gstatic.com/s/sen/v9/6xK0dSxYI9_dkN18-vZKK2EISM2-H4vKlD9q78A.woff2',
      '800':
        'https://fonts.gstatic.com/s/sen/v9/6xK0dSxYI9_dkN18-vZKK2EISKq-H4vKlD9q78A.woff2',
    },
    installName: 'sen',
  },
  {
    label: 'Shantell Sans',
    value: 'Shantell Sans',
    preview:
      'https://fonts.gstatic.com/s/shantellsans/v9/FeUaS0pCoLIo-lcdY7kjvNoQqWVWB0qWpl29ajppTuUTu_kJKmHesPOL-maYi4xZeHCNQ09eBlmv2QcUzJ39-rAISYR8S1i3wv0.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/shantellsans/v9/FeUaS0pCoLIo-lcdY7kjvNoQqWVWB0qWpl29ajppTuUTu_kJKmHesPOL-maYi4xZeHCNQ09eBlmv2QcUzJ39-rAISYR8S2izyPwxjyRN.woff2',
      '500':
        'https://fonts.gstatic.com/s/shantellsans/v9/FeUaS0pCoLIo-lcdY7kjvNoQqWVWB0qWpl29ajppTuUTu_kJKmHesPOL-maYi4xZeHCNQ09eBlmv2QcUzJ39-rAISYROS2izyPwxjyRN.woff2',
      '600':
        'https://fonts.gstatic.com/s/shantellsans/v9/FeUaS0pCoLIo-lcdY7kjvNoQqWVWB0qWpl29ajppTuUTu_kJKmHesPOL-maYi4xZeHCNQ09eBlmv2QcUzJ39-rAISYSiTGizyPwxjyRN.woff2',
      '700':
        'https://fonts.gstatic.com/s/shantellsans/v9/FeUaS0pCoLIo-lcdY7kjvNoQqWVWB0qWpl29ajppTuUTu_kJKmHesPOL-maYi4xZeHCNQ09eBlmv2QcUzJ39-rAISYSbTGizyPwxjyRN.woff2',
      '800':
        'https://fonts.gstatic.com/s/shantellsans/v9/FeUaS0pCoLIo-lcdY7kjvNoQqWVWB0qWpl29ajppTuUTu_kJKmHesPOL-maYi4xZeHCNQ09eBlmv2QcUzJ39-rAISYT8TGizyPwxjyRN.woff2',
    },
    installName: 'shantell_sans',
  },
  {
    label: 'Shippori Mincho',
    value: 'Shippori Mincho',
    preview:
      'https://fonts.gstatic.com/s/shipporimincho/v14/VdGGAZweH5EbgHY6YExcZfDoj0Bw2vWD.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/shipporimincho/v14/VdGGAZweH5EbgHY6YExcZfDoj0BA3v-C7LoS7g.woff2',
      '500':
        'https://fonts.gstatic.com/s/shipporimincho/v14/VdGDAZweH5EbgHY6YExcZfDoj0B4L9am4ZEO5--2zg.woff2',
      '600':
        'https://fonts.gstatic.com/s/shipporimincho/v14/VdGDAZweH5EbgHY6YExcZfDoj0B4A9Gm4ZEO5--2zg.woff2',
      '700':
        'https://fonts.gstatic.com/s/shipporimincho/v14/VdGDAZweH5EbgHY6YExcZfDoj0B4Z9Cm4ZEO5--2zg.woff2',
      '800':
        'https://fonts.gstatic.com/s/shipporimincho/v14/VdGDAZweH5EbgHY6YExcZfDoj0B4e9Om4ZEO5--2zg.woff2',
    },
    installName: 'shippori_mincho',
  },
  {
    label: 'Shippori Mincho B1',
    value: 'Shippori Mincho B1',
    preview:
      'https://fonts.gstatic.com/s/shipporiminchob1/v19/~ChQKElNoaXBwb3JpIE1pbmNobyBCMRABIAU=.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/shipporiminchob1/v19/~ChQKElNoaXBwb3JpIE1pbmNobyBCMSAFKgQIARgB.woff2',
      '500':
        'https://fonts.gstatic.com/s/shipporiminchob1/v19/~ChcKElNoaXBwb3JpIE1pbmNobyBCMRj0AyAFKgQIARgB.woff2',
      '600':
        'https://fonts.gstatic.com/s/shipporiminchob1/v19/~ChcKElNoaXBwb3JpIE1pbmNobyBCMRjYBCAFKgQIARgB.woff2',
      '700':
        'https://fonts.gstatic.com/s/shipporiminchob1/v19/~ChcKElNoaXBwb3JpIE1pbmNobyBCMRi8BSAFKgQIARgB.woff2',
      '800':
        'https://fonts.gstatic.com/s/shipporiminchob1/v19/~ChcKElNoaXBwb3JpIE1pbmNobyBCMRigBiAFKgQIARgB.woff2',
    },
    installName: 'shippori_mincho_b1',
  },
  {
    label: 'Smooch Sans',
    value: 'Smooch Sans',
    preview:
      'https://fonts.gstatic.com/s/smoochsans/v13/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oiwUBYd6gf.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/smoochsans/v13/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oiwUBoc6IeNlzayg.woff2',
      '500':
        'https://fonts.gstatic.com/s/smoochsans/v13/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oi80Boc6IeNlzayg.woff2',
      '600':
        'https://fonts.gstatic.com/s/smoochsans/v13/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oiH0doc6IeNlzayg.woff2',
      '700':
        'https://fonts.gstatic.com/s/smoochsans/v13/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oiJkdoc6IeNlzayg.woff2',
      '800':
        'https://fonts.gstatic.com/s/smoochsans/v13/c4mz1n5uGsXss2LJh1QH6b129FZvxPj6I4oiQUdoc6IeNlzayg.woff2',
    },
    installName: 'smooch_sans',
  },
  {
    label: 'Sofia Sans',
    value: 'Sofia Sans',
    preview:
      'https://fonts.gstatic.com/s/sofiasans/v16/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69B6sJ3spPM.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/sofiasans/v16/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69B6sK3orvKCXl8k.woff2',
      '500':
        'https://fonts.gstatic.com/s/sofiasans/v16/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69BIsK3orvKCXl8k.woff2',
      '600':
        'https://fonts.gstatic.com/s/sofiasans/v16/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69Ckt63orvKCXl8k.woff2',
      '700':
        'https://fonts.gstatic.com/s/sofiasans/v16/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69Cdt63orvKCXl8k.woff2',
      '800':
        'https://fonts.gstatic.com/s/sofiasans/v16/Yq6E-LCVXSLy9uPBwlAThu1SY8Cx8rlT69D6t63orvKCXl8k.woff2',
    },
    installName: 'sofia_sans',
  },
  {
    label: 'Sofia Sans Condensed',
    value: 'Sofia Sans Condensed',
    preview:
      'https://fonts.gstatic.com/s/sofiasanscondensed/v2/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUqh-Gcls4P.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/sofiasanscondensed/v2/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUqh-GsksQO3OfwQQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/sofiasanscondensed/v2/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUqteGsksQO3OfwQQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/sofiasanscondensed/v2/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUqWeasksQO3OfwQQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/sofiasanscondensed/v2/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUqYOasksQO3OfwQQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/sofiasanscondensed/v2/r05xGKVS5aVKd567NYXawnFKJaTtoAuLnK0EjiAN5s9CZwUqB-asksQO3OfwQQ.woff2',
    },
    installName: 'sofia_sans_condensed',
  },
  {
    label: 'Sofia Sans Extra Condensed',
    value: 'Sofia Sans Extra Condensed',
    preview:
      'https://fonts.gstatic.com/s/sofiasansextracondensed/v2/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLmmi0fjON.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/sofiasansextracondensed/v2/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLmmiEejmM356GxA.woff2',
      '500':
        'https://fonts.gstatic.com/s/sofiasansextracondensed/v2/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLqGiEejmM356GxA.woff2',
      '600':
        'https://fonts.gstatic.com/s/sofiasansextracondensed/v2/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLRG-EejmM356GxA.woff2',
      '700':
        'https://fonts.gstatic.com/s/sofiasansextracondensed/v2/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLfW-EejmM356GxA.woff2',
      '800':
        'https://fonts.gstatic.com/s/sofiasansextracondensed/v2/raxdHjafvdAIOju4GcIfJH0i7zi50X3zRtuLNiMS0d6iDr-MD5Si9NGLGm-EejmM356GxA.woff2',
    },
    installName: 'sofia_sans_extra_condensed',
  },
  {
    label: 'Sofia Sans Semi Condensed',
    value: 'Sofia Sans Semi Condensed',
    preview:
      'https://fonts.gstatic.com/s/sofiasanssemicondensed/v4/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvoobEd9SE6k.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/sofiasanssemicondensed/v4/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvoobEe9WGahllIhN.woff2',
      '500':
        'https://fonts.gstatic.com/s/sofiasanssemicondensed/v4/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvoopEe9WGahllIhN.woff2',
      '600':
        'https://fonts.gstatic.com/s/sofiasanssemicondensed/v4/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvorFFu9WGahllIhN.woff2',
      '700':
        'https://fonts.gstatic.com/s/sofiasanssemicondensed/v4/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvor8Fu9WGahllIhN.woff2',
      '800':
        'https://fonts.gstatic.com/s/sofiasanssemicondensed/v4/46kOlaPnUDrQoNsWDCGXXxYlujh5Wv0nwP4RwxURm28cA7YLHsIVvoqbFu9WGahllIhN.woff2',
    },
    installName: 'sofia_sans_semi_condensed',
  },
  {
    label: 'Sono',
    value: 'Sono',
    preview:
      'https://fonts.gstatic.com/s/sono/v6/aFT97PNiY3U2Cqf_aYEN64CYaK18YWJEsV6u-QLiOsxVtkWtE355.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/sono/v6/aFT97PNiY3U2Cqf_aYEN64CYaK18YWJEsV6u-QLiOsxVtkWdF3R4qYeB4Q.woff2',
      '500':
        'https://fonts.gstatic.com/s/sono/v6/aFT97PNiY3U2Cqf_aYEN64CYaK18YWJEsV6u-QLiOsxVhEWdF3R4qYeB4Q.woff2',
      '600':
        'https://fonts.gstatic.com/s/sono/v6/aFT97PNiY3U2Cqf_aYEN64CYaK18YWJEsV6u-QLiOsxVaEKdF3R4qYeB4Q.woff2',
      '700':
        'https://fonts.gstatic.com/s/sono/v6/aFT97PNiY3U2Cqf_aYEN64CYaK18YWJEsV6u-QLiOsxVUUKdF3R4qYeB4Q.woff2',
      '800':
        'https://fonts.gstatic.com/s/sono/v6/aFT97PNiY3U2Cqf_aYEN64CYaK18YWJEsV6u-QLiOsxVNkKdF3R4qYeB4Q.woff2',
    },
    installName: 'sono',
  },
  {
    label: 'Sora',
    value: 'Sora',
    preview:
      'https://fonts.gstatic.com/s/sora/v11/xMQOuFFYT72X5wkB_18qmnndmSdSnk-LKQI.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/sora/v11/xMQOuFFYT72X5wkB_18qmnndmSdSnn-PIwNhBti0.woff2',
      '500':
        'https://fonts.gstatic.com/s/sora/v11/xMQOuFFYT72X5wkB_18qmnndmSdgnn-PIwNhBti0.woff2',
      '600':
        'https://fonts.gstatic.com/s/sora/v11/xMQOuFFYT72X5wkB_18qmnndmSeMmX-PIwNhBti0.woff2',
      '700':
        'https://fonts.gstatic.com/s/sora/v11/xMQOuFFYT72X5wkB_18qmnndmSe1mX-PIwNhBti0.woff2',
      '800':
        'https://fonts.gstatic.com/s/sora/v11/xMQOuFFYT72X5wkB_18qmnndmSfSmX-PIwNhBti0.woff2',
    },
    installName: 'sora',
  },
  {
    label: 'Source Code Pro',
    value: 'Source Code Pro',
    preview:
      'https://fonts.gstatic.com/s/sourcecodepro/v22/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DMyQtM9rTA.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/sourcecodepro/v22/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DMyQhMthTXUcdJg.woff2',
      '500':
        'https://fonts.gstatic.com/s/sourcecodepro/v22/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DP6QhMthTXUcdJg.woff2',
      '600':
        'https://fonts.gstatic.com/s/sourcecodepro/v22/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DBKXhMthTXUcdJg.woff2',
      '700':
        'https://fonts.gstatic.com/s/sourcecodepro/v22/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DCuXhMthTXUcdJg.woff2',
      '800':
        'https://fonts.gstatic.com/s/sourcecodepro/v22/HI_diYsKILxRpg3hIP6sJ7fM7PqPMcMnZFqUwX28DEyXhMthTXUcdJg.woff2',
    },
    installName: 'source_code_pro',
  },
  {
    label: 'Source Sans 3',
    value: 'Source Sans 3',
    preview:
      'https://fonts.gstatic.com/s/sourcesans3/v9/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8Ky462EM9Cs.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/sourcesans3/v9/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8Ky461EI_io6npfB.woff2',
      '500':
        'https://fonts.gstatic.com/s/sourcesans3/v9/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8KyK61EI_io6npfB.woff2',
      '600':
        'https://fonts.gstatic.com/s/sourcesans3/v9/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8Kxm7FEI_io6npfB.woff2',
      '700':
        'https://fonts.gstatic.com/s/sourcesans3/v9/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8Kxf7FEI_io6npfB.woff2',
      '800':
        'https://fonts.gstatic.com/s/sourcesans3/v9/nwpBtKy2OAdR1K-IwhWudF-R9QMylBJAV3Bo8Kw47FEI_io6npfB.woff2',
    },
    installName: 'source_sans_3',
  },
  {
    label: 'Source Serif 4',
    value: 'Source Serif 4',
    preview:
      'https://fonts.gstatic.com/s/sourceserif4/v7/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjihdqnh1dDg.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/sourceserif4/v7/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjihdqrhlXD-wGvjU.woff2',
      '500':
        'https://fonts.gstatic.com/s/sourceserif4/v7/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjiiVqrhlXD-wGvjU.woff2',
      '600':
        'https://fonts.gstatic.com/s/sourceserif4/v7/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjisltrhlXD-wGvjU.woff2',
      '700':
        'https://fonts.gstatic.com/s/sourceserif4/v7/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjivBtrhlXD-wGvjU.woff2',
      '800':
        'https://fonts.gstatic.com/s/sourceserif4/v7/vEFy2_tTDB4M7-auWDN0ahZJW3IX2ih5nk3AucvUHf6OAVIJmeUDygwjipdtrhlXD-wGvjU.woff2',
    },
    installName: 'source_serif_4',
  },
  {
    label: 'Spectral',
    value: 'Spectral',
    preview:
      'https://fonts.gstatic.com/s/spectral/v13/rnCr-xNNww_2s0amA9M_kng.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/spectral/v13/rnCr-xNNww_2s0amA-M7mHnOSOuk.woff2',
      '500':
        'https://fonts.gstatic.com/s/spectral/v13/rnCs-xNNww_2s0amA9vKsV3DY_etWWIJ.woff2',
      '600':
        'https://fonts.gstatic.com/s/spectral/v13/rnCs-xNNww_2s0amA9vmtl3DY_etWWIJ.woff2',
      '700':
        'https://fonts.gstatic.com/s/spectral/v13/rnCs-xNNww_2s0amA9uCt13DY_etWWIJ.woff2',
      '800':
        'https://fonts.gstatic.com/s/spectral/v13/rnCs-xNNww_2s0amA9uetF3DY_etWWIJ.woff2',
    },
    installName: 'spectral',
  },
  {
    label: 'Spectral SC',
    value: 'Spectral SC',
    preview:
      'https://fonts.gstatic.com/s/spectralsc/v12/KtkpALCRZonmalTgyPmRfsWj42E.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/spectralsc/v12/KtkpALCRZonmalTgyPmRfvWn6WDfFpuc.woff2',
      '500':
        'https://fonts.gstatic.com/s/spectralsc/v12/Ktk0ALCRZonmalTgyPmRfs1WwETSPYeVXJZB.woff2',
      '600':
        'https://fonts.gstatic.com/s/spectralsc/v12/Ktk0ALCRZonmalTgyPmRfs16x0TSPYeVXJZB.woff2',
      '700':
        'https://fonts.gstatic.com/s/spectralsc/v12/Ktk0ALCRZonmalTgyPmRfs0exkTSPYeVXJZB.woff2',
      '800':
        'https://fonts.gstatic.com/s/spectralsc/v12/Ktk0ALCRZonmalTgyPmRfs0CxUTSPYeVXJZB.woff2',
    },
    installName: 'spectral_sc',
  },
  {
    label: 'Stick No Bills',
    value: 'Stick No Bills',
    preview:
      'https://fonts.gstatic.com/s/sticknobills/v15/bWts7ffXZwHuAa9Uld-oEK4QKlxj9f9t_7uEmjcVv8QLK7Kx.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/sticknobills/v15/bWts7ffXZwHuAa9Uld-oEK4QKlxj9f9t_7uEmjcVv8Q7L7iwKhcTKA.woff2',
      '500':
        'https://fonts.gstatic.com/s/sticknobills/v15/bWts7ffXZwHuAa9Uld-oEK4QKlxj9f9t_7uEmjcVjcQ7L7iwKhcTKA.woff2',
      '600':
        'https://fonts.gstatic.com/s/sticknobills/v15/bWts7ffXZwHuAa9Uld-oEK4QKlxj9f9t_7uEmjcVYcM7L7iwKhcTKA.woff2',
      '700':
        'https://fonts.gstatic.com/s/sticknobills/v15/bWts7ffXZwHuAa9Uld-oEK4QKlxj9f9t_7uEmjcVWMM7L7iwKhcTKA.woff2',
      '800':
        'https://fonts.gstatic.com/s/sticknobills/v15/bWts7ffXZwHuAa9Uld-oEK4QKlxj9f9t_7uEmjcVP8M7L7iwKhcTKA.woff2',
    },
    installName: 'stick_no_bills',
  },
  {
    label: 'Syne',
    value: 'Syne',
    preview:
      'https://fonts.gstatic.com/s/syne/v22/8vIS7w4qzmVxsWxjBZRjr0FKM_04uQ6lTY8.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/syne/v22/8vIS7w4qzmVxsWxjBZRjr0FKM_04uT6hR47NCV5Z.woff2',
      '500':
        'https://fonts.gstatic.com/s/syne/v22/8vIS7w4qzmVxsWxjBZRjr0FKM_0KuT6hR47NCV5Z.woff2',
      '600':
        'https://fonts.gstatic.com/s/syne/v22/8vIS7w4qzmVxsWxjBZRjr0FKM_3mvj6hR47NCV5Z.woff2',
      '700':
        'https://fonts.gstatic.com/s/syne/v22/8vIS7w4qzmVxsWxjBZRjr0FKM_3fvj6hR47NCV5Z.woff2',
      '800':
        'https://fonts.gstatic.com/s/syne/v22/8vIS7w4qzmVxsWxjBZRjr0FKM_24vj6hR47NCV5Z.woff2',
    },
    installName: 'syne',
  },
  {
    label: 'Taviraj',
    value: 'Taviraj',
    preview:
      'https://fonts.gstatic.com/s/taviraj/v13/ahcZv8Cj3ylylTXzTO8rUg.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/taviraj/v13/ahcZv8Cj3ylylTXzfOshU-FwnU0.woff2',
      '500':
        'https://fonts.gstatic.com/s/taviraj/v13/ahccv8Cj3ylylTXzRBoId-xbgUS5u0s.woff2',
      '600':
        'https://fonts.gstatic.com/s/taviraj/v13/ahccv8Cj3ylylTXzRDYPd-xbgUS5u0s.woff2',
      '700':
        'https://fonts.gstatic.com/s/taviraj/v13/ahccv8Cj3ylylTXzRFIOd-xbgUS5u0s.woff2',
      '800':
        'https://fonts.gstatic.com/s/taviraj/v13/ahccv8Cj3ylylTXzRE4Nd-xbgUS5u0s.woff2',
    },
    installName: 'taviraj',
  },
  {
    label: 'Tektur',
    value: 'Tektur',
    preview:
      'https://fonts.gstatic.com/s/tektur/v3/XoHN2YHtS7q969kXCjzlV0aSkS_o8OacmTe0TYlYFot8TrwuVbtPacI.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/tektur/v3/XoHN2YHtS7q969kXCjzlV0aSkS_o8OacmTe0TYlYFot8TrwuVYtLY8P7TWd0.woff2',
      '500':
        'https://fonts.gstatic.com/s/tektur/v3/XoHN2YHtS7q969kXCjzlV0aSkS_o8OacmTe0TYlYFot8TrwcVYtLY8P7TWd0.woff2',
      '600':
        'https://fonts.gstatic.com/s/tektur/v3/XoHN2YHtS7q969kXCjzlV0aSkS_o8OacmTe0TYlYFot8TrzwUotLY8P7TWd0.woff2',
      '700':
        'https://fonts.gstatic.com/s/tektur/v3/XoHN2YHtS7q969kXCjzlV0aSkS_o8OacmTe0TYlYFot8TrzJUotLY8P7TWd0.woff2',
      '800':
        'https://fonts.gstatic.com/s/tektur/v3/XoHN2YHtS7q969kXCjzlV0aSkS_o8OacmTe0TYlYFot8TryuUotLY8P7TWd0.woff2',
    },
    installName: 'tektur',
  },
  {
    label: 'Texturina',
    value: 'Texturina',
    preview:
      'https://fonts.gstatic.com/s/texturina/v28/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2eYGsUh0Zs.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/texturina/v28/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2eYGvUl25riW1OD.woff2',
      '500':
        'https://fonts.gstatic.com/s/texturina/v28/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2eqGvUl25riW1OD.woff2',
      '600':
        'https://fonts.gstatic.com/s/texturina/v28/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2dGHfUl25riW1OD.woff2',
      '700':
        'https://fonts.gstatic.com/s/texturina/v28/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2d_HfUl25riW1OD.woff2',
      '800':
        'https://fonts.gstatic.com/s/texturina/v28/c4mM1nxpEtL3pXiAulRTkY-HGmNEX1b9NspjMwhAgliHhVrXy2cYHfUl25riW1OD.woff2',
    },
    installName: 'texturina',
  },
  {
    label: 'Tillana',
    value: 'Tillana',
    preview:
      'https://fonts.gstatic.com/s/tillana/v13/VuJxdNvf35P4qJ1OSKfdOQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/tillana/v13/VuJxdNvf35P4qJ1OeKPXOIFneRo.woff2',
      '500':
        'https://fonts.gstatic.com/s/tillana/v13/VuJ0dNvf35P4qJ1OQFL-HIxMZRNcp0o.woff2',
      '600':
        'https://fonts.gstatic.com/s/tillana/v13/VuJ0dNvf35P4qJ1OQH75HIxMZRNcp0o.woff2',
      '700':
        'https://fonts.gstatic.com/s/tillana/v13/VuJ0dNvf35P4qJ1OQBr4HIxMZRNcp0o.woff2',
      '800':
        'https://fonts.gstatic.com/s/tillana/v13/VuJ0dNvf35P4qJ1OQAb7HIxMZRNcp0o.woff2',
    },
    installName: 'tillana',
  },
  {
    label: 'Tomorrow',
    value: 'Tomorrow',
    preview:
      'https://fonts.gstatic.com/s/tomorrow/v17/WBLmrETNbFtZCeGqgRXUe2A.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/tomorrow/v17/WBLmrETNbFtZCeGqgSXQcWHALdio.woff2',
      '500':
        'https://fonts.gstatic.com/s/tomorrow/v17/WBLhrETNbFtZCeGqgR0hWEXNBsShiVd4.woff2',
      '600':
        'https://fonts.gstatic.com/s/tomorrow/v17/WBLhrETNbFtZCeGqgR0NX0XNBsShiVd4.woff2',
      '700':
        'https://fonts.gstatic.com/s/tomorrow/v17/WBLhrETNbFtZCeGqgR1pXkXNBsShiVd4.woff2',
      '800':
        'https://fonts.gstatic.com/s/tomorrow/v17/WBLhrETNbFtZCeGqgR11XUXNBsShiVd4.woff2',
    },
    installName: 'tomorrow',
  },
  {
    label: 'Tourney',
    value: 'Tourney',
    preview:
      'https://fonts.gstatic.com/s/tourney/v13/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7GOQFCZDB0.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/tourney/v13/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7GOQFyYDp1I1LcGA.woff2',
      '500':
        'https://fonts.gstatic.com/s/tourney/v13/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7GCwFyYDp1I1LcGA.woff2',
      '600':
        'https://fonts.gstatic.com/s/tourney/v13/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7G5wZyYDp1I1LcGA.woff2',
      '700':
        'https://fonts.gstatic.com/s/tourney/v13/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7G3gZyYDp1I1LcGA.woff2',
      '800':
        'https://fonts.gstatic.com/s/tourney/v13/AlZa_ztDtYzv1tzq1wcJnbVt7xseomk-tNs7qrzTWbyt8n7GuQZyYDp1I1LcGA.woff2',
    },
    installName: 'tourney',
  },
  {
    label: 'Trirong',
    value: 'Trirong',
    preview:
      'https://fonts.gstatic.com/s/trirong/v15/7r3GqXNgp8wxdOdOn40o2A.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/trirong/v15/7r3GqXNgp8wxdOdOr4ki2aZg-ug.woff2',
      '500':
        'https://fonts.gstatic.com/s/trirong/v15/7r3DqXNgp8wxdOdOl3gL_atL5uH-mts.woff2',
      '600':
        'https://fonts.gstatic.com/s/trirong/v15/7r3DqXNgp8wxdOdOl1QM_atL5uH-mts.woff2',
      '700':
        'https://fonts.gstatic.com/s/trirong/v15/7r3DqXNgp8wxdOdOlzAN_atL5uH-mts.woff2',
      '800':
        'https://fonts.gstatic.com/s/trirong/v15/7r3DqXNgp8wxdOdOlywO_atL5uH-mts.woff2',
    },
    installName: 'trirong',
  },
  {
    label: 'Trispace',
    value: 'Trispace',
    preview:
      'https://fonts.gstatic.com/s/trispace/v24/Yq65-LKSQC3o56LxxgRrtA6yBqsrXL5GI5KI-IUZVGsxWFIlbH9rkQh-zQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/trispace/v24/Yq65-LKSQC3o56LxxgRrtA6yBqsrXL5GI5KI-IUZVGsxWFIlbH9roQx0zHugpt0.woff2',
      '500':
        'https://fonts.gstatic.com/s/trispace/v24/Yq65-LKSQC3o56LxxgRrtA6yBqsrXL5GI5KI-IUZVGsxWFIlbE1roQx0zHugpt0.woff2',
      '600':
        'https://fonts.gstatic.com/s/trispace/v24/Yq65-LKSQC3o56LxxgRrtA6yBqsrXL5GI5KI-IUZVGsxWFIlbKFsoQx0zHugpt0.woff2',
      '700':
        'https://fonts.gstatic.com/s/trispace/v24/Yq65-LKSQC3o56LxxgRrtA6yBqsrXL5GI5KI-IUZVGsxWFIlbJhsoQx0zHugpt0.woff2',
      '800':
        'https://fonts.gstatic.com/s/trispace/v24/Yq65-LKSQC3o56LxxgRrtA6yBqsrXL5GI5KI-IUZVGsxWFIlbP9soQx0zHugpt0.woff2',
    },
    installName: 'trispace',
  },
  {
    label: 'Truculenta',
    value: 'Truculenta',
    preview:
      'https://fonts.gstatic.com/s/truculenta/v22/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMlAigwYPHw.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/truculenta/v22/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMlAiswIFHnJMMhg.woff2',
      '500':
        'https://fonts.gstatic.com/s/truculenta/v22/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMmIiswIFHnJMMhg.woff2',
      '600':
        'https://fonts.gstatic.com/s/truculenta/v22/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMo4lswIFHnJMMhg.woff2',
      '700':
        'https://fonts.gstatic.com/s/truculenta/v22/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMrclswIFHnJMMhg.woff2',
      '800':
        'https://fonts.gstatic.com/s/truculenta/v22/LhWfMVvBKusVIfNYGi1-WvRVyDdZeeiySNppcu32Mb2f06y6Oa21F6XHi0VYDX_PzOupMtAlswIFHnJMMhg.woff2',
    },
    installName: 'truculenta',
  },
  {
    label: 'Unbounded',
    value: 'Unbounded',
    preview:
      'https://fonts.gstatic.com/s/unbounded/v7/Yq6F-LOTXCb04q32xlpat-6uR42XTqtG6xjx44zNgQ.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/unbounded/v7/Yq6F-LOTXCb04q32xlpat-6uR42XTqtG6xjx04jHgP6LR0Y.woff2',
      '500':
        'https://fonts.gstatic.com/s/unbounded/v7/Yq6F-LOTXCb04q32xlpat-6uR42XTqtG6yrx04jHgP6LR0Y.woff2',
      '600':
        'https://fonts.gstatic.com/s/unbounded/v7/Yq6F-LOTXCb04q32xlpat-6uR42XTqtG68b204jHgP6LR0Y.woff2',
      '700':
        'https://fonts.gstatic.com/s/unbounded/v7/Yq6F-LOTXCb04q32xlpat-6uR42XTqtG6__204jHgP6LR0Y.woff2',
      '800':
        'https://fonts.gstatic.com/s/unbounded/v7/Yq6F-LOTXCb04q32xlpat-6uR42XTqtG65j204jHgP6LR0Y.woff2',
    },
    installName: 'unbounded',
  },
  {
    label: 'Urbanist',
    value: 'Urbanist',
    preview:
      'https://fonts.gstatic.com/s/urbanist/v15/L0xjDF02iFML4hGCyOCpRdycFsGxSrqDyx4vF5mq.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/urbanist/v15/L0xjDF02iFML4hGCyOCpRdycFsGxSrqDyx4fE5OrS8SlKw.woff2',
      '500':
        'https://fonts.gstatic.com/s/urbanist/v15/L0xjDF02iFML4hGCyOCpRdycFsGxSrqD-R4fE5OrS8SlKw.woff2',
      '600':
        'https://fonts.gstatic.com/s/urbanist/v15/L0xjDF02iFML4hGCyOCpRdycFsGxSrqDFRkfE5OrS8SlKw.woff2',
      '700':
        'https://fonts.gstatic.com/s/urbanist/v15/L0xjDF02iFML4hGCyOCpRdycFsGxSrqDLBkfE5OrS8SlKw.woff2',
      '800':
        'https://fonts.gstatic.com/s/urbanist/v15/L0xjDF02iFML4hGCyOCpRdycFsGxSrqDSxkfE5OrS8SlKw.woff2',
    },
    installName: 'urbanist',
  },
  {
    label: 'Vazirmatn',
    value: 'Vazirmatn',
    preview:
      'https://fonts.gstatic.com/s/vazirmatn/v13/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRklWgzCRaT7g.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/vazirmatn/v13/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRklWgzORKZ72DF_QY.woff2',
      '500':
        'https://fonts.gstatic.com/s/vazirmatn/v13/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRklVozORKZ72DF_QY.woff2',
      '600':
        'https://fonts.gstatic.com/s/vazirmatn/v13/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRklbY0ORKZ72DF_QY.woff2',
      '700':
        'https://fonts.gstatic.com/s/vazirmatn/v13/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRklY80ORKZ72DF_QY.woff2',
      '800':
        'https://fonts.gstatic.com/s/vazirmatn/v13/Dxx78j6PP2D_kU2muijPEe1n2vVbfJRkleg0ORKZ72DF_QY.woff2',
    },
    installName: 'vazirmatn',
  },
  {
    label: 'Vollkorn',
    value: 'Vollkorn',
    preview:
      'https://fonts.gstatic.com/s/vollkorn/v22/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df2MHGeGGmc.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/vollkorn/v22/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df2MHGuHGOdEbD63w.woff2',
      '500':
        'https://fonts.gstatic.com/s/vollkorn/v22/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df2AnGuHGOdEbD63w.woff2',
      '600':
        'https://fonts.gstatic.com/s/vollkorn/v22/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df27nauHGOdEbD63w.woff2',
      '700':
        'https://fonts.gstatic.com/s/vollkorn/v22/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df213auHGOdEbD63w.woff2',
      '800':
        'https://fonts.gstatic.com/s/vollkorn/v22/0ybgGDoxxrvAnPhYGzMlQLzuMasz6Df2sHauHGOdEbD63w.woff2',
    },
    installName: 'vollkorn',
  },
  {
    label: 'Wix Madefor Display',
    value: 'Wix Madefor Display',
    preview:
      'https://fonts.gstatic.com/s/wixmadefordisplay/v9/SZcS3EX9IbbyeJ8aOluD52KXgUA_7Ed1I13G853Cp9duUYFhYmtltfw.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/wixmadefordisplay/v9/SZcS3EX9IbbyeJ8aOluD52KXgUA_7Ed1I13G853Cp9duUYFhYlthv_3HQKgh.woff2',
      '500':
        'https://fonts.gstatic.com/s/wixmadefordisplay/v9/SZcS3EX9IbbyeJ8aOluD52KXgUA_7Ed1I13G853Cp9duUYFTYlthv_3HQKgh.woff2',
      '600':
        'https://fonts.gstatic.com/s/wixmadefordisplay/v9/SZcS3EX9IbbyeJ8aOluD52KXgUA_7Ed1I13G853Cp9duUYG_ZVthv_3HQKgh.woff2',
      '700':
        'https://fonts.gstatic.com/s/wixmadefordisplay/v9/SZcS3EX9IbbyeJ8aOluD52KXgUA_7Ed1I13G853Cp9duUYGGZVthv_3HQKgh.woff2',
      '800':
        'https://fonts.gstatic.com/s/wixmadefordisplay/v9/SZcS3EX9IbbyeJ8aOluD52KXgUA_7Ed1I13G853Cp9duUYHhZVthv_3HQKgh.woff2',
    },
    installName: 'wix_madefor_display',
  },
  {
    label: 'Wix Madefor Text',
    value: 'Wix Madefor Text',
    preview:
      'https://fonts.gstatic.com/s/wixmadefortext/v12/-W_oXI_oSymQ8Qj-Apx3HGN_Hu1RTCk5FtSDETgf0cK_NNeEiJU.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/wixmadefortext/v12/-W_oXI_oSymQ8Qj-Apx3HGN_Hu1RTCk5FtSDETgf0cK_NOeAgpRt9rN5.woff2',
      '500':
        'https://fonts.gstatic.com/s/wixmadefortext/v12/-W_oXI_oSymQ8Qj-Apx3HGN_Hu1RTCk5FtSDETgf0cKNNOeAgpRt9rN5.woff2',
      '600':
        'https://fonts.gstatic.com/s/wixmadefortext/v12/-W_oXI_oSymQ8Qj-Apx3HGN_Hu1RTCk5FtSDETgf0cJhM-eAgpRt9rN5.woff2',
      '700':
        'https://fonts.gstatic.com/s/wixmadefortext/v12/-W_oXI_oSymQ8Qj-Apx3HGN_Hu1RTCk5FtSDETgf0cJYM-eAgpRt9rN5.woff2',
      '800':
        'https://fonts.gstatic.com/s/wixmadefortext/v12/-W_oXI_oSymQ8Qj-Apx3HGN_Hu1RTCk5FtSDETgf0cI_M-eAgpRt9rN5.woff2',
    },
    installName: 'wix_madefor_text',
  },
  {
    label: 'Work Sans',
    value: 'Work Sans',
    preview:
      'https://fonts.gstatic.com/s/worksans/v18/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K0nXBikJpg.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/worksans/v18/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K0nXNi0Dp6_cOyA.woff2',
      '500':
        'https://fonts.gstatic.com/s/worksans/v18/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K3vXNi0Dp6_cOyA.woff2',
      '600':
        'https://fonts.gstatic.com/s/worksans/v18/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K5fQNi0Dp6_cOyA.woff2',
      '700':
        'https://fonts.gstatic.com/s/worksans/v18/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K67QNi0Dp6_cOyA.woff2',
      '800':
        'https://fonts.gstatic.com/s/worksans/v18/QGY_z_wNahGAdqQ43RhVcIgYT2Xz5u32K8nQNi0Dp6_cOyA.woff2',
    },
    installName: 'work_sans',
  },
  {
    label: 'Ysabeau',
    value: 'Ysabeau',
    preview:
      'https://fonts.gstatic.com/s/ysabeau/v1/kmKiZqEiBAXLcnuMvjZNI_5FGeJet7OWCAYxKcA.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/ysabeau/v1/kmKiZqEiBAXLcnuMvjZNI_5FGeJet7OWCDY1I8Gcw6Oi.woff2',
      '500':
        'https://fonts.gstatic.com/s/ysabeau/v1/kmKiZqEiBAXLcnuMvjZNI_5FGeJet7OkCDY1I8Gcw6Oi.woff2',
      '600':
        'https://fonts.gstatic.com/s/ysabeau/v1/kmKiZqEiBAXLcnuMvjZNI_5FGeJet7NIDzY1I8Gcw6Oi.woff2',
      '700':
        'https://fonts.gstatic.com/s/ysabeau/v1/kmKiZqEiBAXLcnuMvjZNI_5FGeJet7NxDzY1I8Gcw6Oi.woff2',
      '800':
        'https://fonts.gstatic.com/s/ysabeau/v1/kmKiZqEiBAXLcnuMvjZNI_5FGeJet7MWDzY1I8Gcw6Oi.woff2',
    },
    installName: 'ysabeau',
  },
  {
    label: 'Ysabeau Infant',
    value: 'Ysabeau Infant',
    preview:
      'https://fonts.gstatic.com/s/ysabeauinfant/v1/hv-ClzpqOkkV94kBTQVdX1EWI9B0V-HEmd9JmTQYFo83Kpqg.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/ysabeauinfant/v1/hv-ClzpqOkkV94kBTQVdX1EWI9B0V-HEmd9JmTQYFo8HLpChLwKH6A.woff2',
      '500':
        'https://fonts.gstatic.com/s/ysabeauinfant/v1/hv-ClzpqOkkV94kBTQVdX1EWI9B0V-HEmd9JmTQYJI8HLpChLwKH6A.woff2',
      '600':
        'https://fonts.gstatic.com/s/ysabeauinfant/v1/hv-ClzpqOkkV94kBTQVdX1EWI9B0V-HEmd9JmTQYyIgHLpChLwKH6A.woff2',
      '700':
        'https://fonts.gstatic.com/s/ysabeauinfant/v1/hv-ClzpqOkkV94kBTQVdX1EWI9B0V-HEmd9JmTQY8YgHLpChLwKH6A.woff2',
      '800':
        'https://fonts.gstatic.com/s/ysabeauinfant/v1/hv-ClzpqOkkV94kBTQVdX1EWI9B0V-HEmd9JmTQYlogHLpChLwKH6A.woff2',
    },
    installName: 'ysabeau_infant',
  },
  {
    label: 'Ysabeau Office',
    value: 'Ysabeau Office',
    preview:
      'https://fonts.gstatic.com/s/ysabeauoffice/v1/LDImapaZKhM9RuQIp8FmdYrPPNjFm07hbpKNlPPbh6MvYC3o.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/ysabeauoffice/v1/LDImapaZKhM9RuQIp8FmdYrPPNjFm07hbpKNlPPbh6MfZCfpQj7IGQ.woff2',
      '500':
        'https://fonts.gstatic.com/s/ysabeauoffice/v1/LDImapaZKhM9RuQIp8FmdYrPPNjFm07hbpKNlPPbtaMfZCfpQj7IGQ.woff2',
      '600':
        'https://fonts.gstatic.com/s/ysabeauoffice/v1/LDImapaZKhM9RuQIp8FmdYrPPNjFm07hbpKNlPPbWaQfZCfpQj7IGQ.woff2',
      '700':
        'https://fonts.gstatic.com/s/ysabeauoffice/v1/LDImapaZKhM9RuQIp8FmdYrPPNjFm07hbpKNlPPbYKQfZCfpQj7IGQ.woff2',
      '800':
        'https://fonts.gstatic.com/s/ysabeauoffice/v1/LDImapaZKhM9RuQIp8FmdYrPPNjFm07hbpKNlPPbB6QfZCfpQj7IGQ.woff2',
    },
    installName: 'ysabeau_office',
  },
  {
    label: 'Ysabeau SC',
    value: 'Ysabeau SC',
    preview:
      'https://fonts.gstatic.com/s/ysabeausc/v1/Noai6Uro3JCIKAbW46nMorJZyP7kKRflbw98UmqFbYA.woff2',
    weights: {
      '400':
        'https://fonts.gstatic.com/s/ysabeausc/v1/Noai6Uro3JCIKAbW46nMorJZyP7kKRflbw98UlqBZ4EOmsT5.woff2',
      '500':
        'https://fonts.gstatic.com/s/ysabeausc/v1/Noai6Uro3JCIKAbW46nMorJZyP7kKRflbw9OUlqBZ4EOmsT5.woff2',
      '600':
        'https://fonts.gstatic.com/s/ysabeausc/v1/Noai6Uro3JCIKAbW46nMorJZyP7kKRflbw-iVVqBZ4EOmsT5.woff2',
      '700':
        'https://fonts.gstatic.com/s/ysabeausc/v1/Noai6Uro3JCIKAbW46nMorJZyP7kKRflbw-bVVqBZ4EOmsT5.woff2',
      '800':
        'https://fonts.gstatic.com/s/ysabeausc/v1/Noai6Uro3JCIKAbW46nMorJZyP7kKRflbw_8VVqBZ4EOmsT5.woff2',
    },
    installName: 'ysabeau_sc',
  },
];
